export const data = [
  {
    ChildCareInfo: {
      list_total_count: 9366,
      RESULT: { CODE: "INFO-000", MESSAGE: "정상 처리되었습니다" },
      row: [
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000379",
          CRNAME: "사랑별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03712",
          CRADDR: "서울특별시 서대문구 수색로2길 19-7 DMC금호리첸시아아파트 단지 내",
          CRTELNO: "",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "95",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "27",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-10-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000123",
          CRNAME: "현대캐피탈 도담어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04527",
          CRADDR: "서울특별시 중구 세종대로 14 그랜드센트럴 2층 현대캐피탈 도담어린이집",
          CRTELNO: "02-6411-6191",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "178",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "1",
          CRCAPAT: "49",
          CRCHCNT: "15",
          LA: "37.55771431591427",
          LO: "126.97455785839598",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-10-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 1.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 3.0,
          CHILD_CNT_05: 2.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 1.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000364",
          CRNAME: "광진구육아종합지원센터(꾸미팡팡공동육아방 3호점)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04999",
          CRADDR: "서울특별시 광진구 동일로56가길 31 3층",
          CRTELNO: "02-466-1827",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "160",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-10-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000498",
          CRNAME: "삼환어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07227",
          CRADDR: "서울특별시 영등포구 영중로 145 영등포삼환아파트 104동 101호",
          CRTELNO: "02-2679-5967",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.52965303803424",
          LO: "126.9047238972906",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000648",
          CRNAME: "별숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08226",
          CRADDR: "서울특별시 구로구 경인로43길 49 고척아이파크MD 내 관리실",
          CRTELNO: "02-860-0000",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "10",
          NRTRROOMSIZE: "1649",
          PLGRDCO: "3",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "180",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000649",
          CRNAME: "달숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08225",
          CRADDR: "서울특별시 구로구 중앙로5길 59 고척아이파크 RD 내 관리동",
          CRTELNO: "02-860-0000",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "478",
          PLGRDCO: "2",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "89",
          CRCHCNT: "0",
          LA: "37.500515359324986",
          LO: "126.8602203035339",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000481",
          CRNAME: "삼성아이마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04139",
          CRADDR: "서울특별시 마포구 백범로25길 63 염리삼성래미안 관리동",
          CRTELNO: "02-3275-0667",
          CRFAXNO: "02-3275-0668",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "107",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "24",
          LA: "37.548530363975836",
          LO: "126.94614577784598",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 6.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 14.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000491",
          CRNAME: "중랑실내놀이터",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02255",
          CRADDR: "서울특별시 중랑구 용마산로 209",
          CRTELNO: "02-2207-1123",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "641",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-08-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000497",
          CRNAME: "LG 에너지솔루션 지정 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07335",
          CRADDR: "서울특별시 영등포구 여의대로 108 파크원빌딩 3층",
          CRTELNO: "02-2118-0700",
          CRFAXNO: "02-2118-0702",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "375",
          PLGRDCO: "1",
          CCTVINSTLCNT: "42",
          CHCRTESCNT: "43",
          CRCAPAT: "108",
          CRCHCNT: "62",
          LA: "37.52659220221173",
          LO: "126.92734807790963",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-08-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 10.0,
          CLASS_CNT_01: 6.0,
          CLASS_CNT_02: 5.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 24.0,
          CHILD_CNT_00: 20.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 18.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 5.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 34.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 3.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 43.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000513",
          CRNAME: "케이티앤지 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06176",
          CRADDR: "서울특별시 강남구 영동대로 416 케이티앤지타워 1층",
          CRTELNO: "02-566-1696",
          CRFAXNO: "",
          CRHOME: "www.daum.net/ktng2022",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "159",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "7",
          CRCAPAT: "49",
          CRCHCNT: "10",
          LA: "37.50646819560551",
          LO: "127.0650886883344",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-08-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 7.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000634",
          CRNAME: "나연어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08012",
          CRADDR: "서울특별시 양천구 목동서로 280 804동 104호",
          CRTELNO: "02-2605-7596",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "37",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "4",
          CRCAPAT: "12",
          CRCHCNT: "8",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-08-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 8.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 4.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000020",
          CRNAME: "돌마리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05686",
          CRADDR: "서울특별시 송파구 백제고분로40길 13-16 돌마리어린이집 2층 (석촌동)",
          CRTELNO: "02-3431-8535",
          CRFAXNO: "02-413-5783",
          CRHOME: "http://cafe.daum.net/dolmarichild",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "363",
          PLGRDCO: "1",
          CCTVINSTLCNT: "26",
          CHCRTESCNT: "14",
          CRCAPAT: "79",
          CRCHCNT: "69",
          LA: "37.50354405",
          LO: "127.1074342",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-07-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 14.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 69.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 9.0,
          EM_CNT_4Y: 9.0,
          EM_CNT_6Y: 36.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000569",
          CRNAME: "구립뉴포레어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08700",
          CRADDR: "서울특별시 관악구 조원로 25 1층 상가동",
          CRTELNO: "02-6389-3700",
          CRFAXNO: "02-6389-3701",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "663",
          PLGRDCO: "1",
          CCTVINSTLCNT: "28",
          CHCRTESCNT: "10",
          CRCAPAT: "88",
          CRCHCNT: "29",
          LA: "37.483652098931984",
          LO: "126.90455055846746",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-07-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000647",
          CRNAME: "디지털꿈터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08381",
          CRADDR: "서울특별시 구로구 디지털로27길 36 1층 108호",
          CRTELNO: "02-838-5653",
          CRFAXNO: "02-839-5653",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "298",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "20",
          LA: "37.48402245098858",
          LO: "126.89252839930873",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-07-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000213",
          CRNAME: "원효루미니어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04314",
          CRADDR: "서울특별시 용산구 원효로97길 15 1층",
          CRTELNO: "02-713-4777",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "91",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "10",
          CRCAPAT: "32",
          CRCHCNT: "21",
          LA: "37.54145907380427",
          LO: "126.96938101184236",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000462",
          CRNAME: "구립신대방누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07074",
          CRADDR: "서울특별시 동작구 신대방1다길 19 1층",
          CRTELNO: "010-5658-1031",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "135",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "1",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 1.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000496",
          CRNAME: "신길더샵해늘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07361",
          CRADDR: "서울특별시 영등포구 가마산로79길 37 관리동",
          CRTELNO: "02-6205-0707",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "127",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "11",
          CRCAPAT: "45",
          CRCHCNT: "35",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000687",
          CRNAME: "구립 북한산힐스솔숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03366",
          CRADDR: "서울특별시 은평구 불광로2길 33 북한산힐스테이트1차아파트 단지 내",
          CRTELNO: "02-357-5778",
          CRFAXNO: "02-357-5779",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "69",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "5",
          CRCAPAT: "23",
          CRCHCNT: "6",
          LA: "37.61299418171425",
          LO: "126.93699318098555",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-06-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 2.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 6.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000633",
          CRNAME: "토리좋은세상어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08017",
          CRADDR: "서울특별시 양천구 신목로5길 5 개진빌딩 1층",
          CRTELNO: "02-6734-6000",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "6",
          CRCAPAT: "22",
          CRCHCNT: "8",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-06-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 8.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000749",
          CRNAME: "청정원 마곡 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07616",
          CRADDR: "서울특별시 강서구 초원로16길 12",
          CRTELNO: "02-2664-1613",
          CRFAXNO: "",
          CRHOME: "https://www.puruni.com/chungjungonemagok",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "170",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "6",
          CRCAPAT: "49",
          CRCHCNT: "9",
          LA: "37.566949326128544",
          LO: "126.8150605330501",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-06-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 2.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 2.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 9.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000631",
          CRNAME: "구립 다온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08076",
          CRADDR: "서울특별시 양천구 중앙로29길 11 호반써밋목동아파트",
          CRTELNO: "02-2088-7093",
          CRFAXNO: "02-2088-7865",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "7",
          CRCAPAT: "30",
          CRCHCNT: "18",
          LA: "37.516431393652304",
          LO: "126.8526402416749",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000480",
          CRNAME: "모아어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03945",
          CRADDR: "서울특별시 마포구 월드컵북로30길 9-22 110동 1층 2호",
          CRTELNO: "02-309-0706",
          CRFAXNO: "02-309-0705",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "89",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "5",
          CRCAPAT: "30",
          CRCHCNT: "9",
          LA: "37.569491500313845",
          LO: "126.90861800522977",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-05-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 9.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000686",
          CRNAME: "구립 마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03475",
          CRADDR: "서울특별시 은평구 백련산로4길 17-7",
          CRTELNO: "02-388-9979",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "185",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "17",
          CRCAPAT: "64",
          CRCHCNT: "51",
          LA: "37.59514978867848",
          LO: "126.92495169916518",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-05-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 51.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000479",
          CRNAME: "현대홈타운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04180",
          CRADDR: "서울특별시 마포구 새창로8길 72 현대홈타운 204-101",
          CRTELNO: "02-704-1002",
          CRFAXNO: "02-714-1002",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "67",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "16",
          LA: "37.56668894540141",
          LO: "126.97806370753913",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-05-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 11.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000488",
          CRNAME: "행복어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02057",
          CRADDR: "서울특별시 중랑구 양원역로 92 (망우동)",
          CRTELNO: "02-2208-1891",
          CRFAXNO: "02-2208-1892",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "260",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "18",
          CRCAPAT: "74",
          CRCHCNT: "72",
          LA: "37.60916279874149",
          LO: "127.10675103372358",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 15.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 72.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000556",
          CRNAME: "도봉산탐험대 숲어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01362",
          CRADDR: "서울특별시 도봉구 시루봉로 107 29동 105호",
          CRTELNO: "02-3493-2440",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "71",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "4",
          CRCAPAT: "15",
          CRCHCNT: "12",
          LA: "37.65947622069994",
          LO: "127.02702946419218",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-04-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 4.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 12.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 2.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 4.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000632",
          CRNAME: "목동깨비장난감도서관공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07950",
          CRADDR: "서울특별시 양천구 목동중앙북로2길 8 3층",
          CRTELNO: "02-2646-7790",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "493",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-04-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000461",
          CRNAME: "포레힐즈어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06994",
          CRADDR: "서울특별시 동작구 동작대로45길 10 이수스위첸포레힐즈아파트 단지 내",
          CRTELNO: "02-537-2001",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "96",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "36",
          CRCHCNT: "23",
          LA: "37.497871139007",
          LO: "126.98198533481478",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-04-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 11.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000490",
          CRNAME: "망우자람공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02173",
          CRADDR: "서울특별시 중랑구 용마산로 461",
          CRTELNO: "02-433-1123",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "69",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-04-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000748",
          CRNAME: "등촌제일어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07570",
          CRADDR: "서울특별시 강서구 공항대로53가길 50 1층",
          CRTELNO: "02-6338-6046",
          CRFAXNO: "02-6338-6046",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "5",
          CRCAPAT: "18",
          CRCHCNT: "16",
          LA: "37.555529149561124",
          LO: "126.85909339229742",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-04-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000685",
          CRNAME: "구립 DMC센트럴자이나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03506",
          CRADDR: "서울특별시 은평구 수색로 200 DMC센트럴자이3블럭 단지 내",
          CRTELNO: "02-308-7401",
          CRFAXNO: "02-308-7402",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "185",
          PLGRDCO: "1",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "12",
          CRCAPAT: "68",
          CRCHCNT: "68",
          LA: "37.57936913502394",
          LO: "126.90356245047972",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-04-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 14.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 68.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000684",
          CRNAME: "구립 DMC센트럴자이새봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03506",
          CRADDR: "서울특별시 은평구 수색로 200 DMC센트럴자이 2블럭 단지 내",
          CRTELNO: "02-6218-6667",
          CRFAXNO: "02-6218-6668",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "117",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "36",
          CRCHCNT: "35",
          LA: "37.57872149169512",
          LO: "126.89944815559629",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-04-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000652",
          CRNAME: "리슈빌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02851",
          CRADDR: "서울특별시 성북구 보문로26길 17",
          CRTELNO: "02-911-6227",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "110",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "7",
          CRCAPAT: "41",
          CRCHCNT: "23",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000683",
          CRNAME: "구립 가람별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03301",
          CRADDR: "서울특별시 은평구 진관3로 77 921동(진관동, 은평뉴타운 구파발)",
          CRTELNO: "02-356-7111",
          CRFAXNO: "070-7392-0942",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "11",
          CRCAPAT: "32",
          CRCHCNT: "29",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000376",
          CRNAME: "새빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03626",
          CRADDR: "서울특별시 서대문구 세무서8길 30 새빛어린이집",
          CRTELNO: "02-396-2022",
          CRFAXNO: "02-396-2023",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "351",
          PLGRDCO: "1",
          CCTVINSTLCNT: "28",
          CHCRTESCNT: "20",
          CRCAPAT: "96",
          CRCHCNT: "68",
          LA: "37.588749393943054",
          LO: "126.94802463340747",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 15.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 20.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 68.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 17.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000747",
          CRNAME: "홈앤쇼핑 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07807",
          CRADDR: "서울특별시 강서구 공항대로 150 홈앤쇼핑 3층",
          CRTELNO: "02-2662-0720",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "109",
          PLGRDCO: "0",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "7",
          CRCAPAT: "30",
          CRCHCNT: "10",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000651",
          CRNAME: "101경비단 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02812",
          CRADDR: "서울특별시 성북구 정릉로10라길 18-5",
          CRTELNO: "02-911-2101",
          CRFAXNO: "02-909-4101",
          CRHOME: "https://www.puruni.com/smpa101",
          NRTRROOMCNT: "10",
          NRTRROOMSIZE: "399",
          PLGRDCO: "1",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "13",
          CRCAPAT: "100",
          CRCHCNT: "18",
          LA: "37.60555981790512",
          LO: "126.9994337538099",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 2.0,
          CHILD_CNT_05: 1.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000477",
          CRNAME: "IBK참!좋은(마포)어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04166",
          CRADDR: "서울특별시 마포구 큰우물로 64 1층",
          CRTELNO: "02-2078-2160",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "209",
          PLGRDCO: "0",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "17",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000377",
          CRNAME: "현대아이사랑어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03638",
          CRADDR: "서울특별시 서대문구 통일로39가길 57 107동 108호",
          CRTELNO: "02-394-7701",
          CRFAXNO: "050-4430-7147",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "18",
          CRCHCNT: "10",
          LA: "37.58916519374019",
          LO: "126.94128183248672",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000476",
          CRNAME: "금호어울림어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02057",
          CRADDR: "서울특별시 중랑구 양원역로10길 75 금호어울림 관리동 (망우동)",
          CRTELNO: "02-434-0678",
          CRFAXNO: "02-434-0679",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "247",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "45",
          CRCHCNT: "43",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000475",
          CRNAME: "엘스타시온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02057",
          CRADDR: "서울특별시 중랑구 양원역로10길 47 엘스타시온 관리동 (망우본동)",
          CRTELNO: "02-433-9702",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "381",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "16",
          CRCAPAT: "70",
          CRCHCNT: "70",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 70.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000184",
          CRNAME: "연동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03128",
          CRADDR: "서울특별시 종로구 대학로3길 9 연지동",
          CRTELNO: "02-3673-2866",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "112",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "13",
          CRCAPAT: "41",
          CRCHCNT: "33",
          LA: "37.57392371531399",
          LO: "127.00140652631974",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000378",
          CRNAME: "참사랑어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03769",
          CRADDR: "서울특별시 서대문구 이화여대8길 62 두산아파트 102동 106호",
          CRTELNO: "02-6356-6767",
          CRFAXNO: "010-4226-2748",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "47",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "6",
          CRCAPAT: "15",
          CRCHCNT: "15",
          LA: "37.55932036871453",
          LO: "126.94997054366745",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000183",
          CRNAME: "감사원어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03053",
          CRADDR: "서울특별시 종로구 북촌로 127",
          CRTELNO: "02-730-9390",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "175",
          PLGRDCO: "0",
          CCTVINSTLCNT: "26",
          CHCRTESCNT: "7",
          CRCAPAT: "49",
          CRCHCNT: "10",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 2.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000504",
          CRNAME: "연세어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02527",
          CRADDR: "서울특별시 동대문구 장한로27나길 65",
          CRTELNO: "02-2245-6390",
          CRFAXNO: "02-2245-6390",
          CRHOME: "키즈노트",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "210",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "79",
          CRCHCNT: "72",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 72.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000565",
          CRNAME: "구립햇님데이케어어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08725",
          CRADDR: "서울특별시 관악구 성현로 80 110동 104호(봉천동, 관악드림타운)",
          CRTELNO: "02-886-6985",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "83",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.48892019949905",
          LO: "126.95183659288435",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001057",
          CRNAME: "태릉해링턴어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01817",
          CRADDR: "서울특별시 노원구 공릉로34길 86 공릉동, 태릉해링턴플레이스아파트 내",
          CRTELNO: "02-977-5003",
          CRFAXNO: "02-977-5003",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "231",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "11",
          CRCAPAT: "76",
          CRCHCNT: "55",
          LA: "37.62596922599265",
          LO: "127.08345917647446",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 7.0,
          CHILD_CNT_05: 12.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000542",
          CRNAME: "구립하랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05416",
          CRADDR: "서울특별시 강동구 고덕로98길 161 강동리엔파크13단지",
          CRTELNO: "02-3013-7725",
          CRFAXNO: "02-3103-7726",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "197",
          PLGRDCO: "0",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "10",
          CRCAPAT: "66",
          CRCHCNT: "61",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 61.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000478",
          CRNAME: "삼성해뜰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04131",
          CRADDR: "서울특별시 마포구 마포대로 173-15 공덕5차래미안 관리동",
          CRTELNO: "02-702-7955",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "160",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "16",
          CRCAPAT: "60",
          CRCHCNT: "57",
          LA: "37.55067749067492",
          LO: "126.95255792369752",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 5.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 24.0,
          CHILD_CNT_02: 27.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 57.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000460",
          CRNAME: "서초구립 서초교대e편한세상어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06603",
          CRADDR: "서울특별시 서초구 서초중앙로24길 33 교대e편한세상아파트 관리동",
          CRTELNO: "02-591-1011",
          CRFAXNO: "02-592-1101",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "91",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "12",
          CRCAPAT: "33",
          CRCHCNT: "33",
          LA: "37.49646122679468",
          LO: "127.01691175474131",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000543",
          CRNAME: "구립강동한별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05304",
          CRADDR: "서울특별시 강동구 천중로53길 19 1~4층",
          CRTELNO: "02-2041-7890",
          CRFAXNO: "02-472-7572",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "227",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "67",
          CRCHCNT: "44",
          LA: "37.541652983464246",
          LO: "127.14528211822028",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장,시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000348",
          CRNAME: "서울금천경찰서어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08611",
          CRADDR: "서울특별시 금천구 시흥대로73길 50",
          CRTELNO: "02-806-7234",
          CRFAXNO: "",
          CRHOME: "https://hansol-geumcheonpolice.kidsnote.ac/home/main",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "339",
          PLGRDCO: "2",
          CCTVINSTLCNT: "27",
          CHCRTESCNT: "16",
          CRCAPAT: "80",
          CRCHCNT: "35",
          LA: "37.45656131976247",
          LO: "126.89692196228132",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000682",
          CRNAME: "구립 새솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03442",
          CRADDR: "서울특별시 은평구 증산로17가길 14",
          CRTELNO: "02-375-3354",
          CRFAXNO: "02-375-3354",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "139",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "38",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000477",
          CRNAME: "중랑경찰서어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02055",
          CRADDR: "서울특별시 중랑구 신내역로3길 40-10",
          CRTELNO: "02-3423-3330",
          CRFAXNO: "02-3423-331",
          CRHOME: "http://www.puruni.com/smpajn",
          NRTRROOMCNT: "10",
          NRTRROOMSIZE: "312",
          PLGRDCO: "1",
          CCTVINSTLCNT: "30",
          CHCRTESCNT: "14",
          CRCAPAT: "100",
          CRCHCNT: "23",
          LA: "37.618109303971686",
          LO: "127.10458057846017",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 2.0,
          CHILD_CNT_04: 4.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000487",
          CRNAME: "코스콤푸르니어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07330",
          CRADDR: "서울특별시 영등포구 여의나루로4길 21 2층",
          CRTELNO: "02-761-9881",
          CRFAXNO: "02-761-9882",
          CRHOME: "www.puruni.com",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "322",
          PLGRDCO: "3",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "14",
          CRCAPAT: "80",
          CRCHCNT: "28",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 3.0,
          CHILD_CNT_05: 2.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000463",
          CRNAME: "무지개어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06796",
          CRADDR: "서울특별시 서초구 신흥말길 79-3 103동 1층(내곡동, 무지개아파트)",
          CRTELNO: "02-2226-9377",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "76",
          PLGRDCO: "0",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "6",
          CRCAPAT: "28",
          CRCHCNT: "10",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000746",
          CRNAME: "DYPNF 직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07792",
          CRADDR: "서울특별시 강서구 마곡중앙8로7길 39 2층",
          CRTELNO: "02-2106-8210",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "96",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "4",
          CRCAPAT: "32",
          CRCHCNT: "6",
          LA: "37.56437367029218",
          LO: "126.83892949223632",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 6.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 2.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 4.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000362",
          CRNAME: "구립 광진그랜드파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05022",
          CRADDR: "서울특별시 광진구 광나루로 458 어린이집",
          CRTELNO: "02-469-1956",
          CRFAXNO: "02-497-0681",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "176",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "15",
          CRCAPAT: "57",
          CRCHCNT: "54",
          LA: "37.54370562061723",
          LO: "127.08123440330459",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 19.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000820",
          CRNAME: "위례두리숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05847",
          CRADDR: "서울특별시 송파구 위례송파로 80 호반써밋송파2차아파트",
          CRTELNO: "02-408-8277",
          CRFAXNO: "02-409-8277",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "471",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "13",
          CRCAPAT: "84",
          CRCHCNT: "61",
          LA: "37.48411376638958",
          LO: "127.1425192412142",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 8.0,
          CHILD_CNT_05: 9.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 61.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000819",
          CRNAME: "위례하나숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05791",
          CRADDR: "서울특별시 송파구 위례송파로 40 호반써밋송파1차아파트",
          CRTELNO: "02-407-9931",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "357",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "12",
          CRCAPAT: "56",
          CRCHCNT: "44",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000153",
          CRNAME: "서머힐어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04392",
          CRADDR: "서울특별시 용산구 장문로 27 상가동, 102호 (이태원동, 청화아파트)",
          CRTELNO: "02-6241-0081",
          CRFAXNO: "070-4795-0081",
          CRHOME: "http://cafe.daum.net/summerhillyongsan",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.52910835195778",
          LO: "126.99367357174061",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-01-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 14.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000818",
          CRNAME: "송파롯데캐슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05767",
          CRADDR: "서울특별시 송파구 거마로 56 송파시그니처롯데캐슬",
          CRTELNO: "02-443-3004",
          CRFAXNO: "02-443-2004",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "295",
          PLGRDCO: "1",
          CCTVINSTLCNT: "26",
          CHCRTESCNT: "19",
          CRCAPAT: "91",
          CRCHCNT: "91",
          LA: "37.49606822887987",
          LO: "127.14773249280111",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-01-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 91.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000447",
          CRNAME: "구립까망돌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06973",
          CRADDR: "서울특별시 동작구 서달로 129",
          CRTELNO: "02-815-1516",
          CRFAXNO: "02-815-1518",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "153",
          PLGRDCO: "1",
          CCTVINSTLCNT: "26",
          CHCRTESCNT: "14",
          CRCAPAT: "51",
          CRCHCNT: "35",
          LA: "37.5051212964399",
          LO: "126.96061385005933",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000344",
          CRNAME: "새길과학놀이터",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08653",
          CRADDR: "서울특별시 금천구 시흥대로12길 82",
          CRTELNO: "02-894-5680",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "278",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2022-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000445",
          CRNAME: "구립숲속자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07056",
          CRADDR: "서울특별시 동작구 여의대방로22길 121",
          CRTELNO: "02-823-9447",
          CRFAXNO: "02-823-9448",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "242",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "16",
          CRCAPAT: "65",
          CRCHCNT: "60",
          LA: "37.498840545701114",
          LO: "126.9261649331774",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 60.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000446",
          CRNAME: "구립한결어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07055",
          CRADDR: "서울특별시 동작구 여의대방로24길 113",
          CRTELNO: "02-824-3351",
          CRFAXNO: "02-824-3352",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "101",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.499273088391455",
          LO: "126.92626063251256",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2022-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000647",
          CRNAME: "이음어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02730",
          CRADDR: "서울특별시 성북구 숭인로8길 80 111동",
          CRTELNO: "02-982-2203",
          CRFAXNO: "02-982-2204",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "137",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "9",
          CRCAPAT: "50",
          CRCHCNT: "42",
          LA: "37.60833188711268",
          LO: "127.0265239556219",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000648",
          CRNAME: "한울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02730",
          CRADDR: "서울특별시 성북구 숭인로8길 80",
          CRTELNO: "02-914-0100",
          CRFAXNO: "02-981-0081",
          CRHOME: "https://www.kidsnote.com",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "137",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "11",
          CRCAPAT: "50",
          CRCHCNT: "38",
          LA: "37.6071000067383",
          LO: "127.02551274791931",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000763",
          CRNAME: "송이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05676",
          CRADDR: "서울특별시 송파구 송파대로36길 5-8 송파아파트 106호",
          CRTELNO: "02-2202-6113",
          CRFAXNO: "02-2202-6103",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "114",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5003703765",
          LO: "127.1127282724",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000181",
          CRNAME: "청정원 종로 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03130",
          CRADDR: "서울특별시 종로구 창경궁로 120 종로플레이스 2층",
          CRTELNO: "02-2231-1896",
          CRFAXNO: "070-4035-6154",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "219",
          PLGRDCO: "1",
          CCTVINSTLCNT: "27",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "30",
          LA: "37.572961897751824",
          LO: "126.9981888022783",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 4.0,
          CHILD_CNT_05: 8.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000681",
          CRNAME: "구립 진달래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03302",
          CRADDR: "서울특별시 은평구 진관3로 70 827동",
          CRTELNO: "02-355-5525",
          CRFAXNO: "02-355-5526",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "79",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "7",
          CRCAPAT: "30",
          CRCHCNT: "13",
          LA: "37.64267323180988",
          LO: "126.92277093907015",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000680",
          CRNAME: "구립 e편안한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03475",
          CRADDR: "서울특별시 은평구 백련산로 112",
          CRTELNO: "02-354-5279",
          CRFAXNO: "02-354-5280",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "101",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "37",
          CRCHCNT: "34",
          LA: "37.59535390509565",
          LO: "126.92361250515401",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 34.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000495",
          CRNAME: "청계포레어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02587",
          CRADDR: "서울특별시 동대문구 무학로 89 (청계포레센트럴아파트)",
          CRTELNO: "02-6212-0770",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "250",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "74",
          CRCHCNT: "72",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 72.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000678",
          CRNAME: "구립 DMC물치어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03505",
          CRADDR: "서울특별시 은평구 수색로 216",
          CRTELNO: "02-6952-7517",
          CRFAXNO: "0504-328-5033",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "170",
          PLGRDCO: "1",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "16",
          CRCAPAT: "49",
          CRCHCNT: "47",
          LA: "37.581172940228726",
          LO: "126.90032791425577",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000118",
          CRNAME: "농협중앙회 별관 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04516",
          CRADDR: "서울특별시 중구 새문안로 16 농협중앙회 별관 2층",
          CRTELNO: "02-2080-8135",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "139",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "11",
          CRCAPAT: "40",
          CRCHCNT: "26",
          LA: "37.56631941482",
          LO: "126.96772109776006",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000505",
          CRNAME: "강남데시앙포레어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06362",
          CRADDR: "서울특별시 강남구 광평로34길 55 강남데시앙포레 아파트 키즈센터1층",
          CRTELNO: "02-459-2525",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "265",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "18",
          CRCAPAT: "91",
          CRCHCNT: "40",
          LA: "37.48356746310779",
          LO: "127.09425367351625",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000462",
          CRNAME: "스마트 서리풀노리학교",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06675",
          CRADDR: "서울특별시 서초구 방배천로24길 8 1층",
          CRTELNO: "02-523-9340",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "242",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-11-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000679",
          CRNAME: "구립 신사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03435",
          CRADDR: "서울특별시 은평구 갈현로5길 25-19",
          CRTELNO: "02-374-0106",
          CRFAXNO: "02-6941-0106",
          CRHOME: "https://cafe.naver.com/withshinsa",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "188",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "13",
          CRCAPAT: "60",
          CRCHCNT: "29",
          LA: "37.60160757518888",
          LO: "126.90886184490783",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000816",
          CRNAME: "아가세상어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05846",
          CRADDR: "서울특별시 송파구 위례송파로 123 1711동 101호",
          CRTELNO: "02-406-5955",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.48584944725292",
          LO: "127.14882043661532",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000815",
          CRNAME: "위례리슈빌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05847",
          CRADDR: "서울특별시 송파구 위례송파로 124",
          CRTELNO: "02-406-0103",
          CRFAXNO: "02-407-0106",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "160",
          PLGRDCO: "1",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "13",
          CRCAPAT: "59",
          CRCHCNT: "54",
          LA: "37.48404991916615",
          LO: "127.14683256805317",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000817",
          CRNAME: "위례고운별어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05846",
          CRADDR: "서울특별시 송파구 위례송파로 123 1715동 103호",
          CRTELNO: "02-407-1243",
          CRFAXNO: "02-407-1243",
          CRHOME: "https://cafe.naver.com/gounstar1715",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.48566147818651",
          LO: "127.14783071958497",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000504",
          CRNAME: "래미안라클래시어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06091",
          CRADDR: "서울특별시 강남구 삼성로 651",
          CRTELNO: "02-542-7177",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "194",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "16",
          CRCAPAT: "65",
          CRCHCNT: "46",
          LA: "37.518910047450106",
          LO: "127.05366325012066",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 46.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000474",
          CRNAME: "키즈어울림어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02063",
          CRADDR: "서울특별시 중랑구 양원역로 18 108동 107호 (망우동)",
          CRTELNO: "02-433-3401",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.60185770634747",
          LO: "127.10955752867191",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000458",
          CRNAME: "서초구립 반포센트레빌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06598",
          CRADDR: "서울특별시 서초구 사평대로 310-4",
          CRTELNO: "02-536-3104",
          CRFAXNO: "02-536-3105",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "87",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "26",
          LA: "37.50343063731091",
          LO: "127.01599160406121",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000397",
          CRNAME: "현대글로비스 서울숲 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04768",
          CRADDR: "서울특별시 성동구 서울숲4길 5",
          CRTELNO: "02-462-2111",
          CRFAXNO: "02-468-3111",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "7",
          CRCAPAT: "17",
          CRCHCNT: "13",
          LA: "37.54777508554885",
          LO: "127.04163928258353",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000459",
          CRNAME: "서초지빈어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06802",
          CRADDR: "서울특별시 서초구 청계산로11길 10 101호",
          CRTELNO: "02-578-5111",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "13",
          LA: "37.447366072393805",
          LO: "127.05716063023182",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000457",
          CRNAME: "서초구립 방배그랑자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06703",
          CRADDR: "서울특별시 서초구 방배로 21 방배그랑자이어린이집",
          CRTELNO: "02-523-2044",
          CRFAXNO: "02-523-2045",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "255",
          PLGRDCO: "1",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "15",
          CRCAPAT: "88",
          CRCHCNT: "60",
          LA: "37.48254632256565",
          LO: "126.99655156904073",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 15.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 60.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000456",
          CRNAME: "서초구립 서초그랑자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06630",
          CRADDR: "서울특별시 서초구 효령로 391",
          CRTELNO: "02-585-0334",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "335",
          PLGRDCO: "1",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "16",
          CRCAPAT: "88",
          CRCHCNT: "65",
          LA: "37.48857108453964",
          LO: "127.02677554166155",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 65.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000361",
          CRNAME: "구립 자양호반써밋어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05074",
          CRADDR: "서울특별시 광진구 능동로 69 어린이집(자양동,자양호반써밋)",
          CRTELNO: "02-466-7563",
          CRFAXNO: "02-466-7563",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "89",
          PLGRDCO: "2",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "11",
          CRCAPAT: "33",
          CRCHCNT: "32",
          LA: "37.537514751147654",
          LO: "127.06861188272049",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000567",
          CRNAME: "아이랑 신사점",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08761",
          CRADDR: "서울특별시 관악구 남부순환로 1491 관악가족행복센터 2층 아이랑 신사점",
          CRTELNO: "070-4144-7339",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "98",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000494",
          CRNAME: "탁트인 맘스가든",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07347",
          CRADDR: "서울특별시 영등포구 신길로 204 2층",
          CRTELNO: "02-833-6022",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "383",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000814",
          CRNAME: "마루별어린이집",
          CRTYPENAME: "사회복지법인",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05738",
          CRADDR: "서울특별시 송파구 마천로28길 3 1층",
          CRTELNO: "02-407-8870",
          CRFAXNO: "02-6455-8830",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "121",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "12",
          CRCAPAT: "28",
          CRCHCNT: "22",
          LA: "37.50214481959609",
          LO: "127.13997640545477",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2021-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000645",
          CRNAME: "구로행복어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08362",
          CRADDR: "서울특별시 구로구 부광로 88 1층",
          CRTELNO: "02-6341-2331",
          CRFAXNO: "02-6341-2333",
          CRHOME: "https://www.puruni.com/skecoplant",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "165",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "6",
          CRCAPAT: "49",
          CRCHCNT: "10",
          LA: "37.47726864014455",
          LO: "126.81682778984279",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000472",
          CRNAME: "삼성푸른숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04132",
          CRADDR: "서울특별시 마포구 마포대로11길 50 409동 1층(공덕동, 공덕래미안4차아파트)",
          CRTELNO: "02-3272-3438",
          CRFAXNO: "02-3272-3438",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "172",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "36",
          CRCHCNT: "28",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000473",
          CRNAME: "금강펜테리움어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02057",
          CRADDR: "서울특별시 중랑구 용마산로136길 160 관리동 (망우동)",
          CRTELNO: "02-2208-6366",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "111",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "12",
          CRCAPAT: "38",
          CRCHCNT: "35",
          LA: "37.60893230118773",
          LO: "127.11001525945691",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000813",
          CRNAME: "수협아라맘어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05510",
          CRADDR: "서울특별시 송파구 오금로 62 1층",
          CRTELNO: "02-425-3201",
          CRFAXNO: "02-425-3202",
          CRHOME: "https://www.puruni.com/suhyup",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "207",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "13",
          CRCAPAT: "40",
          CRCHCNT: "28",
          LA: "37.51616985794147",
          LO: "127.10550142867588",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-09-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000644",
          CRNAME: "비룡어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08245",
          CRADDR: "서울특별시 구로구 고척로33길 43",
          CRTELNO: "02-2619-9933",
          CRFAXNO: "02-2619-9965",
          CRHOME: "서울시 보육포털서비스 비룡어린이집",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "328",
          PLGRDCO: "2",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "12",
          CRCAPAT: "76",
          CRCHCNT: "66",
          LA: "37.50441547753706",
          LO: "126.84826724796043",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 14.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000501",
          CRNAME: "현대백화점 직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06181",
          CRADDR: "서울특별시 강남구 테헤란로98길 12 3층(대치동,현대백화점 본사)",
          CRTELNO: "02-6904-0992",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "279",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "10",
          CRCAPAT: "49",
          CRCHCNT: "14",
          LA: "37.50745186828743",
          LO: "127.06216023054153",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-08-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:13:36.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000502",
          CRNAME: "크래프톤 역삼 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06126",
          CRADDR: "서울특별시 강남구 논현로99길 21",
          CRTELNO: "02-555-6645",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "223",
          PLGRDCO: "1",
          CCTVINSTLCNT: "44",
          CHCRTESCNT: "9",
          CRCAPAT: "77",
          CRCHCNT: "9",
          LA: "37.50331317105016",
          LO: "127.03366402638468",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-08-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 9.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000342",
          CRNAME: "예솔어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08606",
          CRADDR: "서울특별시 금천구 벚꽃로 100 105동 102호",
          CRTELNO: "02-857-1113",
          CRFAXNO: "02-857-1113",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "18",
          LA: "37.46336891001242",
          LO: "126.89236863557484",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-08-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000455",
          CRNAME: "반포예원어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06592",
          CRADDR: "서울특별시 서초구 사평대로 240 502동 107호",
          CRTELNO: "02-537-3921",
          CRFAXNO: "0504-375-3921",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "35",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "4",
          CRCAPAT: "13",
          CRCHCNT: "4",
          LA: "37.50247076291691",
          LO: "127.00783030066789",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-08-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 4.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 4.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000454",
          CRNAME: "서초구립 라클라스어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06599",
          CRADDR: "서울특별시 서초구 서초중앙로 206",
          CRTELNO: "02-534-2122",
          CRFAXNO: "02-534-2123",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "232",
          PLGRDCO: "1",
          CCTVINSTLCNT: "26",
          CHCRTESCNT: "20",
          CRCAPAT: "68",
          CRCHCNT: "63",
          LA: "37.50035843588896",
          LO: "127.01420412430579",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-08-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 22.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 4.0,
          CHILD_CNT_TOT: 63.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 2.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000444",
          CRNAME: "구립푸른어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06995",
          CRADDR: "서울특별시 동작구 동작대로39길 39 이수푸르지오더프레티움 관리동",
          CRTELNO: "02-535-2133",
          CRFAXNO: "02-535-2134",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "172",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "11",
          CRCAPAT: "33",
          CRCHCNT: "30",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-08-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000503",
          CRNAME: "디에이치자이개포어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06346",
          CRADDR: "서울특별시 강남구 영동대로 22",
          CRTELNO: "02-459-6111",
          CRFAXNO: "02-459-6113",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "328",
          PLGRDCO: "0",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "15",
          CRCAPAT: "92",
          CRCHCNT: "64",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-08-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 11.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 64.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000812",
          CRNAME: "위례바른숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05790",
          CRADDR: "서울특별시 송파구 위례송파로 89",
          CRTELNO: "02-401-7001",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "186",
          PLGRDCO: "1",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "12",
          CRCAPAT: "70",
          CRCHCNT: "55",
          LA: "37.486054015993986",
          LO: "127.14369318594747",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-07-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 12.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000341",
          CRNAME: "봄빛어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08606",
          CRADDR: "서울특별시 금천구 벚꽃로 100 독산역롯데캐슬아파트 106동 103호",
          CRTELNO: "02-892-2006",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "18",
          LA: "37.55230972920235",
          LO: "127.2734716868043",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-07-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000677",
          CRNAME: "구립 푸른들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03473",
          CRADDR: "서울특별시 은평구 은평로 240",
          CRTELNO: "02-6748-0202",
          CRFAXNO: "02-6748-0203",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "133",
          PLGRDCO: "1",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "15",
          CRCAPAT: "49",
          CRCHCNT: "40",
          LA: "37.60041500308718",
          LO: "126.93448983111784",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000340",
          CRNAME: "구립독산롯데캐슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08606",
          CRADDR: "서울특별시 금천구 벚꽃로 100 독산역 롯데캐슬아파트 단지내",
          CRTELNO: "02-805-7605",
          CRFAXNO: "02-805-7604",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "258",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "16",
          CRCAPAT: "69",
          CRCHCNT: "58",
          LA: "37.463400089541444",
          LO: "126.89197862212811",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000471",
          CRNAME: "근로복지공단 마포어린이집",
          CRTYPENAME: "법인·단체등",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03977",
          CRADDR: "서울특별시 마포구 연남로 49-1",
          CRTELNO: "02-322-7333",
          CRFAXNO: "02-322-7334",
          CRHOME: "https://www.comwel.or.kr/kids-mapo/index.jsp",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "210",
          PLGRDCO: "2",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "15",
          CRCAPAT: "60",
          CRCHCNT: "36",
          LA: "37.563653681475365",
          LO: "126.92037806060591",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000493",
          CRNAME: "맘든든센터 공동육아방 6호점",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07377",
          CRADDR: "서울특별시 영등포구 도신로4길 20 1층",
          CRTELNO: "02-833-6022",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "180",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-06-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000811",
          CRNAME: "위례아이숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05846",
          CRADDR: "서울특별시 송파구 위례송파로 123 (거여동, 위례포레샤인 17단지)",
          CRTELNO: "02-448-1718",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "393",
          PLGRDCO: "1",
          CCTVINSTLCNT: "34",
          CHCRTESCNT: "24",
          CRCAPAT: "140",
          CRCHCNT: "138",
          LA: "37.4850749810388",
          LO: "127.14850231273313",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-06-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 30.0,
          CHILD_CNT_04: 40.0,
          CHILD_CNT_05: 38.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 138.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 18.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 24.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000359",
          CRNAME: "구립 중곡하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04905",
          CRADDR: "서울특별시 광진구 동일로76길 59",
          CRTELNO: "02-465-1004",
          CRFAXNO: "02-465-1005",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "110",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "11",
          CRCAPAT: "38",
          CRCHCNT: "29",
          LA: "37.56807935572433",
          LO: "127.08195133976879",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000360",
          CRNAME: "구립 자양도담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05054",
          CRADDR: "서울특별시 광진구 아차산로44가길 5 (자양동 231-51)",
          CRTELNO: "02-455-7000",
          CRFAXNO: "02-455-7887",
          CRHOME: "",
          NRTRROOMCNT: "11",
          NRTRROOMSIZE: "280",
          PLGRDCO: "3",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "11",
          CRCAPAT: "85",
          CRCHCNT: "56",
          LA: "37.536177520234595",
          LO: "127.07994629271573",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000676",
          CRNAME: "구립 꿈여울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03328",
          CRADDR: "서울특별시 은평구 통일로89길 5-6",
          CRTELNO: "02-358-2525",
          CRFAXNO: "02-359-2525",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "171",
          PLGRDCO: "1",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "15",
          CRCAPAT: "64",
          CRCHCNT: "41",
          LA: "37.62448889857442",
          LO: "126.91911955126096",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 6.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 17.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000745",
          CRNAME: "근로복지공단 곰달래어린이집",
          CRTYPENAME: "법인·단체등",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07740",
          CRADDR: "서울특별시 강서구 곰달래로53길 30-20",
          CRTELNO: "02-2646-7142",
          CRFAXNO: "02-2646-7144",
          CRHOME: "https://www.comwel.or.kr/kids-gomdallae/index.jsp",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "216",
          PLGRDCO: "1",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "19",
          CRCAPAT: "70",
          CRCHCNT: "61",
          LA: "37.53365200418015",
          LO: "126.86023202346953",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-05-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 61.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000643",
          CRNAME: "원진어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08241",
          CRADDR: "서울특별시 구로구 고척로55길 21 (고척동, 원진어린이집)",
          CRTELNO: "02-2684-7444",
          CRFAXNO: "02-2625-1608",
          CRHOME: "wonjin7475",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "598",
          PLGRDCO: "5",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "79",
          CRCHCNT: "71",
          LA: "37.50580780267555",
          LO: "126.85567519505748",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 71.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000744",
          CRNAME: "성민가정어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07550",
          CRADDR: "서울특별시 강서구 화곡로68길 115 101동 111호",
          CRTELNO: "02-6093-8643",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "47",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "17",
          CRCHCNT: "16",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000470",
          CRNAME: "해들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04121",
          CRADDR: "서울특별시 마포구 숭문16다길 10-5 마포프레스티지자이 2단지 내 203동 옆",
          CRTELNO: "02-716-2007",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "25",
          LA: "37.55399669589747",
          LO: "126.95019620109904",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000469",
          CRNAME: "산들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04124",
          CRADDR: "서울특별시 마포구 대흥로24길 24 마포프레스티지자이 1단지 내 104동 앞",
          CRTELNO: "02-2088-7212",
          CRFAXNO: "02-2088-2629",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "206",
          PLGRDCO: "1",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "13",
          CRCAPAT: "65",
          CRCHCNT: "64",
          LA: "37.55386760880803",
          LO: "126.94857511302197",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 64.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000180",
          CRNAME: "로카키즈어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03184",
          CRADDR: "서울특별시 종로구 새문안로2길 10 1층",
          CRTELNO: "02-739-8042",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "67",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "6",
          CRCAPAT: "25",
          CRCHCNT: "6",
          LA: "37.56870363599733",
          LO: "126.97197897091388",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 2.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 6.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 75.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000809",
          CRNAME: "위례봄어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05853",
          CRADDR: "서울특별시 송파구 위례광장로 121 2414동 101호",
          CRTELNO: "02-400-8544",
          CRFAXNO: "",
          CRHOME: "dana3918.wixsite.com/webom",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.47531086559839",
          LO: "127.1387746233247",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 83.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000623",
          CRNAME: "구립 아이샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08072",
          CRADDR: "서울특별시 양천구 중앙로43길 14 래미안목동아델리체",
          CRTELNO: "02-6953-2911",
          CRFAXNO: "02-6956-3723",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "28",
          LA: "37.51704501651429",
          LO: "126.85159271909454",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 88.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000374",
          CRNAME: "숲속별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03610",
          CRADDR: "서울특별시 서대문구 홍은중앙로3길 9 북한산두산위브아파트",
          CRTELNO: "02-395-9565",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "95",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "9",
          CRCAPAT: "27",
          CRCHCNT: "27",
          LA: "37.59821303890346",
          LO: "126.94520974654725",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000624",
          CRNAME: "구립 아이숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08072",
          CRADDR: "서울특별시 양천구 중앙로43길 14 래미안목동아델리체",
          CRTELNO: "02-2605-0061",
          CRFAXNO: "02-2605-1161",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "120",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "13",
          CRCAPAT: "45",
          CRCHCNT: "43",
          LA: "37.51913402052034",
          LO: "126.8523351632981",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 46.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000499",
          CRNAME: "도토리소풍넥슨 대치어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06187",
          CRADDR: "서울특별시 강남구 역삼로90길 25",
          CRTELNO: "02-565-7900",
          CRFAXNO: "",
          CRHOME: "https://blog.naver.com/dotorisopoong",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "198",
          PLGRDCO: "1",
          CCTVINSTLCNT: "35",
          CHCRTESCNT: "11",
          CRCAPAT: "49",
          CRCHCNT: "10",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 3.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000498",
          CRNAME: "쿠키즈(coukids) 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06212",
          CRADDR: "서울특별시 강남구 테헤란로 332 HJ타워 3층",
          CRTELNO: "02-6204-2114",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "188",
          PLGRDCO: "0",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "14",
          CRCAPAT: "49",
          CRCHCNT: "21",
          LA: "37.503890422413704",
          LO: "127.048167367398",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 1.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 78.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000486",
          CRNAME: "라온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07440",
          CRADDR: "서울특별시 영등포구 신길로 29",
          CRTELNO: "02-842-9376",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "97",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "35",
          CRCHCNT: "35",
          LA: "37.493813660292204",
          LO: "126.90234387138405",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000210",
          CRNAME: "삼각지어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04375",
          CRADDR: "서울특별시 용산구 백범로99길 40 1,2층",
          CRTELNO: "02-797-9424",
          CRFAXNO: "02-797-9425",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "207",
          PLGRDCO: "1",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "12",
          CRCAPAT: "48",
          CRCHCNT: "45",
          LA: "37.53582388324484",
          LO: "126.97164618985347",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000373",
          CRNAME: "늘푸른어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03609",
          CRADDR: "서울특별시 서대문구 홍은중앙로1길 100",
          CRTELNO: "02-6956-1530",
          CRFAXNO: "070-4855-1530",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "149",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.59990685116291",
          LO: "126.9451009258375",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000742",
          CRNAME: "근로복지공단 등촌어린이집",
          CRTYPENAME: "법인·단체등",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07580",
          CRADDR: "서울특별시 강서구 강서로56나길 128",
          CRTELNO: "02-2659-3370",
          CRFAXNO: "02-2659-3310",
          CRHOME: "https://www.comwel.or.kr/kids-deungchon/",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "198",
          PLGRDCO: "1",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "16",
          CRCAPAT: "73",
          CRCHCNT: "41",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000443",
          CRNAME: "해오름어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07026",
          CRADDR: "서울특별시 동작구 상도로 421 현대아파트 108-103",
          CRTELNO: "02-888-8646",
          CRFAXNO: "02-878-8646",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "5",
          CRCAPAT: "19",
          CRCHCNT: "11",
          LA: "37.49276103375512",
          LO: "126.95853969340467",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 11.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000552",
          CRNAME: "봄날어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "01467",
          CRADDR: "서울특별시 도봉구 덕릉로53길 55",
          CRTELNO: "02-6368-0825",
          CRFAXNO: "02-6397-0825",
          CRHOME: "https://cafe.naver.com/dobomnal",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "133",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "0",
          CRCAPAT: "43",
          CRCHCNT: "0",
          LA: "37.63947235599779",
          LO: "127.03480314033706",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-06-30",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 1.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000142",
          CRNAME: "태양하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02592",
          CRADDR: "서울특별시 동대문구 황물로 32",
          CRTELNO: "02-2245-9544",
          CRFAXNO: "02-2245-9544",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "570",
          PLGRDCO: "1",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "14",
          CRCAPAT: "125",
          CRCHCNT: "93",
          LA: "37.57399227",
          LO: "127.045324",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "야간연장,휴일보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 25.0,
          CHILD_CNT_04: 34.0,
          CHILD_CNT_05: 34.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 93.0,
          EM_CNT_0Y: 90.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 10.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000551",
          CRNAME: "느티나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01355",
          CRADDR: "서울특별시 도봉구 도당로13바길 19",
          CRTELNO: "02-3493-0228",
          CRFAXNO: "02-3493-2228",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "276",
          PLGRDCO: "2",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "58",
          CRCHCNT: "42",
          LA: "37.66753799001463",
          LO: "127.03471423248702",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000621",
          CRNAME: "구립 해든어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08102",
          CRADDR: "서울특별시 양천구 목동남로4길 100",
          CRTELNO: "02-6956-2454",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "87",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.510316075791906",
          LO: "126.87012134685159",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000453",
          CRNAME: "서초구립 허니비어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06567",
          CRADDR: "서울특별시 서초구 서초대로1길 30 105동 101호(방배동, 현대아파트)",
          CRTELNO: "02-535-7957",
          CRFAXNO: "050-8907-0633",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "56",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.48827117840567",
          LO: "126.98385898093359",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000553",
          CRNAME: "온유한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01475",
          CRADDR: "서울특별시 도봉구 덕릉로60자길 22",
          CRTELNO: "02-906-1842",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "246",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "8",
          CRCAPAT: "43",
          CRCHCNT: "20",
          LA: "37.63806348603211",
          LO: "127.04161880708972",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000620",
          CRNAME: "구립 목3동공원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07952",
          CRADDR: "서울특별시 양천구 목동중앙남로16나길 46",
          CRTELNO: "02-2645-3220",
          CRFAXNO: "02-2652-3220",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "166",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "14",
          CRCAPAT: "59",
          CRCHCNT: "49",
          LA: "37.5443837314812",
          LO: "126.86480897534586",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 49.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 83.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000642",
          CRNAME: "현대열린어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08329",
          CRADDR: "서울특별시 구로구 개봉로20길 6 현대아파트 1단지내(개봉역입구쪽)",
          CRTELNO: "02-6091-1004",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "164",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "14",
          CRCAPAT: "62",
          CRCHCNT: "62",
          LA: "37.49308490126599",
          LO: "126.85882066339077",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 12.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 82.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000468",
          CRNAME: "해솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04065",
          CRADDR: "서울특별시 마포구 서강로 75-16 창전동 청년주택 1층",
          CRTELNO: "02-6956-0015",
          CRFAXNO: "02-6956-0150",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "129",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.54960615525726",
          LO: "126.93137703532105",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000554",
          CRNAME: "도봉숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01330",
          CRADDR: "서울특별시 도봉구 마들로 684-10",
          CRTELNO: "02-956-7474",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "368",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "15",
          CRCAPAT: "79",
          CRCHCNT: "69",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 16.0,
          CHILD_CNT_04: 14.0,
          CHILD_CNT_05: 15.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 69.0,
          EM_CNT_0Y: 39.0,
          EM_CNT_1Y: 62.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000442",
          CRNAME: "구립아름어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07032",
          CRADDR: "서울특별시 동작구 양녕로 220 상도역롯데캐슬아파트 관리동",
          CRTELNO: "02-821-2021",
          CRFAXNO: "02-821-2022",
          CRHOME: "http://구립아름어린이집.com",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "142",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "48",
          CRCHCNT: "45",
          LA: "37.50069589777709",
          LO: "126.9455864258222",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 69.0,
          EM_CNT_1Y: 31.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000472",
          CRNAME: "신나라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02132",
          CRADDR: "서울특별시 중랑구 봉우재로2길 22 (면목동)",
          CRTELNO: "02-432-5799",
          CRFAXNO: "02-434-5799",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "148",
          PLGRDCO: "2",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "12",
          CRCAPAT: "54",
          CRCHCNT: "38",
          LA: "37.588354518354414",
          LO: "127.07431968006341",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000339",
          CRNAME: "구립지혜어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08624",
          CRADDR: "서울특별시 금천구 시흥대로76길 19 골드빌 101호",
          CRTELNO: "02-891-7942",
          CRFAXNO: "02-891-7942",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4583123428083",
          LO: "126.90049120485439",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000441",
          CRNAME: "구립트윈파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06902",
          CRADDR: "서울특별시 동작구 노량진로23가길 23 래미안트윈파크아파트 관리동",
          CRTELNO: "02-3280-2320",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "205",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "15",
          CRCAPAT: "49",
          CRCHCNT: "41",
          LA: "37.514321303565296",
          LO: "126.95062129517468",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,휴일보육",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000451",
          CRNAME: "서초구립 한신서래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06578",
          CRADDR: "서울특별시 서초구 사평대로28길 31 101동 108호",
          CRTELNO: "02-533-9631",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "58",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49860682955613",
          LO: "127.00087077390685",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000467",
          CRNAME: "새빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04147",
          CRADDR: "서울특별시 마포구 백범로31길 8 202동 1층",
          CRTELNO: "02-6951-1317",
          CRFAXNO: "02-6951-1316",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "120",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.54517349731557",
          LO: "126.94979187435778",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001056",
          CRNAME: "포레나아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01677",
          CRADDR: "서울특별시 노원구 노원로38길 76",
          CRTELNO: "02-937-3263",
          CRFAXNO: "02-937-3264",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "255",
          PLGRDCO: "3",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "79",
          CRCHCNT: "75",
          LA: "37.66451267214385",
          LO: "127.06266498880039",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 20.0,
          CHILD_CNT_04: 14.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 75.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000550",
          CRNAME: "늘봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01367",
          CRADDR: "서울특별시 도봉구 우이천로 487-1",
          CRTELNO: "02-996-5311",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "238",
          PLGRDCO: "2",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "9",
          CRCAPAT: "79",
          CRCHCNT: "28",
          LA: "37.65657040319446",
          LO: "127.01532176586804",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 71.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000452",
          CRNAME: "서초구립 서초3동하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06667",
          CRADDR: "서울특별시 서초구 명달로11길 16",
          CRTELNO: "02-523-6777",
          CRFAXNO: "02-523-6777",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "232",
          PLGRDCO: "2",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "13",
          CRCAPAT: "70",
          CRCHCNT: "54",
          LA: "37.48336173637013",
          LO: "127.0034173756871",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000741",
          CRNAME: "구립 라온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07735",
          CRADDR: "서울특별시 강서구 곰달래로53길 112",
          CRTELNO: "02-2655-0644",
          CRFAXNO: "070-7836-9078",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "180",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "67",
          CRCHCNT: "59",
          LA: "37.536036357366605",
          LO: "126.856543324376",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 59.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000622",
          CRNAME: "구립 아인어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07963",
          CRADDR: "서울특별시 양천구 목동중앙남로3길 23-1",
          CRTELNO: "02-2647-8798",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "107",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "9",
          CRCAPAT: "39",
          CRCHCNT: "24",
          LA: "37.53561204527303",
          LO: "126.86638618919066",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000641",
          CRNAME: "꿈동산어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08328",
          CRADDR: "서울특별시 구로구 남부순환로95길 16 101동 101호(개봉동, 삼호아파트)",
          CRTELNO: "02-2618-9382",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "11",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.49407618165247",
          LO: "126.85896580226314",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000541",
          CRNAME: "자이숲어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05275",
          CRADDR: "서울특별시 강동구 상일로 55 119동 103호(상일동, 고덕자이)",
          CRTELNO: "02-441-9002",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "6",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.552394431034855",
          LO: "127.17103185439653",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-02-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:36.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000497",
          CRNAME: "삼성서울병원2 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06341",
          CRADDR: "서울특별시 강남구 양재대로55길 12",
          CRTELNO: "02-3411-3140",
          CRFAXNO: "02-3411-3143",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "362",
          PLGRDCO: "2",
          CCTVINSTLCNT: "38",
          CHCRTESCNT: "23",
          CRCAPAT: "120",
          CRCHCNT: "66",
          LA: "37.49233423982776",
          LO: "127.08846378607494",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 6.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 21.0,
          CHILD_CNT_02: 24.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 9.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 31.0,
          EM_CNT_1Y: 69.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 23.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000485",
          CRNAME: "KB여의도어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07331",
          CRADDR: "서울특별시 영등포구 국제금융로8길 26 1층",
          CRTELNO: "02-6332-5051",
          CRFAXNO: "02-6332-5052",
          CRHOME: "http://www.puruni.com/kbyeouido",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "160",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "49",
          CRCHCNT: "31",
          LA: "37.52084865209161",
          LO: "126.92790228437903",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 4.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 64.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000808",
          CRNAME: "서울아산병원제2어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05535",
          CRADDR: "서울특별시 송파구 강동대로 13",
          CRTELNO: "02-2045-3935",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "16",
          NRTRROOMSIZE: "463",
          PLGRDCO: "1",
          CCTVINSTLCNT: "42",
          CHCRTESCNT: "37",
          CRCAPAT: "144",
          CRCHCNT: "125",
          LA: "37.52956299568485",
          LO: "127.11070749191293",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 13.0,
          CLASS_CNT_02: 8.0,
          CLASS_CNT_03: 4.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 25.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 46.0,
          CHILD_CNT_02: 42.0,
          CHILD_CNT_03: 37.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 125.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 30.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 4.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 37.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000675",
          CRNAME: "구립 은빛나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03403",
          CRADDR: "서울특별시 은평구 서오릉로9길 18",
          CRTELNO: "02-3157-2777",
          CRFAXNO: "02-388-2777",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "287",
          PLGRDCO: "4",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "17",
          CRCAPAT: "89",
          CRCHCNT: "79",
          LA: "37.60661620797975",
          LO: "126.92009304551857",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 79.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 54.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000492",
          CRNAME: "맘든든센터 공동육아방 5호점",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07295",
          CRADDR: "서울특별시 영등포구 문래로20길 60 602호",
          CRTELNO: "02-833-6022",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "102",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2021-02-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000540",
          CRNAME: "구립가래여울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05415",
          CRADDR: "서울특별시 강동구 아리수로93나길 88 강동리버스트8단지아파트관리동",
          CRTELNO: "02-441-3690",
          CRFAXNO: "02-442-1478",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "275",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "91",
          CRCHCNT: "78",
          LA: "37.571331901198846",
          LO: "127.17509931293615",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 15.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 78.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000539",
          CRNAME: "구립도로롱어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05286",
          CRADDR: "서울특별시 강동구 고덕로98길 160 강동리엔파크14단지아파트 관리동",
          CRTELNO: "02-441-0103",
          CRFAXNO: "02-441-0107",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "190",
          PLGRDCO: "1",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "15",
          CRCAPAT: "71",
          CRCHCNT: "69",
          LA: "37.55072962005525",
          LO: "127.18173356186382",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 15.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 69.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 75.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000806",
          CRNAME: "석촌새싹어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05690",
          CRADDR: "서울특별시 송파구 가락로11길 9-18",
          CRTELNO: "02-423-1860",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "212",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "14",
          CRCAPAT: "70",
          CRCHCNT: "47",
          LA: "37.50090617925909",
          LO: "127.1037072485326",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 73.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000807",
          CRNAME: "삼전하늘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05600",
          CRADDR: "서울특별시 송파구 삼전로10길 21",
          CRTELNO: "02-418-3721",
          CRFAXNO: "02-419-3721",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "344",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "14",
          CRCAPAT: "75",
          CRCHCNT: "71",
          LA: "37.505355579041925",
          LO: "127.09200214072298",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 71.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 64.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000538",
          CRNAME: "구립해뜨는어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05416",
          CRADDR: "서울특별시 강동구 고덕로98길 101 강동리엔파크11단지아파트 관리동",
          CRTELNO: "02-3426-7775",
          CRFAXNO: "02-3426-7774",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "210",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "60",
          CRCHCNT: "46",
          LA: "37.55424172502777",
          LO: "127.18069384012499",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 14.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 46.0,
          EM_CNT_0Y: 62.0,
          EM_CNT_1Y: 39.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000466",
          CRNAME: "꿈빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04147",
          CRADDR: "서울특별시 마포구 백범로31길 7 공덕SK리더스뷰 103동 1층",
          CRTELNO: "02-6953-3800",
          CRFAXNO: "02-6953-3900",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "120",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "28",
          LA: "37.54538934865785",
          LO: "126.94888646446877",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 63.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000372",
          CRNAME: "한나어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03710",
          CRADDR: "서울특별시 서대문구 가재울로 45 103동 105호",
          CRTELNO: "02-374-1005",
          CRFAXNO: "02-6351-0864",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "81",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.57495323960601",
          LO: "126.92030518485546",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 57.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000640",
          CRNAME: "하영어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08211",
          CRADDR: "서울특별시 구로구 신도림로 16 406동102호",
          CRTELNO: "02-2672-3331",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.50574820552755",
          LO: "126.87991084307384",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000639",
          CRNAME: "푸르니어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08211",
          CRADDR: "서울특별시 구로구 신도림로 16 302동 104호",
          CRTELNO: "02-2633-3389",
          CRFAXNO: "",
          CRHOME: "http://cafe.daum.net/puruni79",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.50598445334374",
          LO: "126.8807601177545",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 83.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000440",
          CRNAME: "구립새봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07003",
          CRADDR: "서울특별시 동작구 사당로9길 11-13",
          CRTELNO: "02-532-3330",
          CRFAXNO: "02-532-3370",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "184",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "9",
          CRCAPAT: "57",
          CRCHCNT: "34",
          LA: "37.48661974494564",
          LO: "126.97046626032558",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "휴일보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 34.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000471",
          CRNAME: "동심어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02180",
          CRADDR: "서울특별시 중랑구 용마공원로3길 40 (망우동)",
          CRTELNO: "02-432-6461",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "180",
          PLGRDCO: "2",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "15",
          CRCAPAT: "60",
          CRCHCNT: "41",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 73.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000739",
          CRNAME: "구립 우장숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07695",
          CRADDR: "서울특별시 강서구 화곡로41길 19",
          CRTELNO: "02-2691-3690",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "215",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "14",
          CRCAPAT: "72",
          CRCHCNT: "57",
          LA: "37.547093253916515",
          LO: "126.84279151029642",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 15.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 57.0,
          EM_CNT_0Y: 91.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000439",
          CRNAME: "구립은솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07039",
          CRADDR: "서울특별시 동작구 상도로 346-1 힐스테이트상도 111동 101호",
          CRTELNO: "02-824-2021",
          CRFAXNO: "02-824-2022",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2021-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000740",
          CRNAME: "마곡9 나인어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07600",
          CRADDR: "서울특별시 강서구 공항대로 103 엠밸리9단지 관리동",
          CRTELNO: "02-6956-5573",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "380",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "24",
          CRCAPAT: "122",
          CRCHCNT: "120",
          LA: "37.56232570929919",
          LO: "126.81991056228388",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 3.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 20.0,
          CHILD_CNT_03: 28.0,
          CHILD_CNT_04: 38.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 5.0,
          CHILD_CNT_TOT: 120.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 56.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 17.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 24.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000344",
          CRNAME: "도토리집공동육아어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01019",
          CRADDR: "서울특별시 강북구 삼각산로4길 36 나호",
          CRTELNO: "02-907-1300",
          CRFAXNO: "02-907-1303",
          CRHOME: "http://cafe.daum.net/dotorizip",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "52",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "6",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.63824060232649",
          LO: "127.00820283486324",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000566",
          CRNAME: "아이랑 보라매점",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08719",
          CRADDR: "서울특별시 관악구 봉천로23길 6 3층 아이랑 보라매점",
          CRTELNO: "02-877-2834",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "104",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2020-12-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000805",
          CRNAME: "송파든든어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05791",
          CRADDR: "서울특별시 송파구 위례서이로 25",
          CRTELNO: "02-407-0301",
          CRFAXNO: "02-404-0302",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "217",
          PLGRDCO: "2",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "17",
          CRCAPAT: "77",
          CRCHCNT: "54",
          LA: "37.482546681505134",
          LO: "127.1381633305819",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000537",
          CRNAME: "구립또바기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05275",
          CRADDR: "서울특별시 강동구 상일로 55 고덕자이아파트 관리동",
          CRTELNO: "02-441-3215",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "336",
          PLGRDCO: "1",
          CCTVINSTLCNT: "46",
          CHCRTESCNT: "25",
          CRCAPAT: "104",
          CRCHCNT: "95",
          LA: "37.55108149413264",
          LO: "127.17084778758054",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장,시간제보육",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 95.0,
          EM_CNT_0Y: 45.0,
          EM_CNT_1Y: 55.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 20.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 25.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000450",
          CRNAME: "서초구립 래미안리더스원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06629",
          CRADDR: "서울특별시 서초구 서운로 62",
          CRTELNO: "02-522-6260",
          CRFAXNO: "02-525-6260",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "654",
          PLGRDCO: "2",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "17",
          CRCAPAT: "80",
          CRCHCNT: "73",
          LA: "37.48914728780742",
          LO: "127.02865841702035",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 20.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 73.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000646",
          CRNAME: "자연아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02762",
          CRADDR: "서울특별시 성북구 돌곶이로40길 46",
          CRTELNO: "02-909-3567",
          CRFAXNO: "02-909-3569",
          CRHOME: "https://cafe.daum.net/jayeon-i",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "256",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "19",
          CRCAPAT: "85",
          CRCHCNT: "85",
          LA: "37.618264560786166",
          LO: "127.04969938677507",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 25.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 85.0,
          EM_CNT_0Y: 47.0,
          EM_CNT_1Y: 53.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000536",
          CRNAME: "구립가람슬기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05262",
          CRADDR: "서울특별시 강동구 올림픽로98가길 12-16",
          CRTELNO: "02-6012-8957",
          CRFAXNO: "02-6012-8957",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "270",
          PLGRDCO: "3",
          CCTVINSTLCNT: "30",
          CHCRTESCNT: "14",
          CRCAPAT: "85",
          CRCHCNT: "60",
          LA: "37.549598535462486",
          LO: "127.13094828902818",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 15.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 60.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000483",
          CRNAME: "신길파크자이솔숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07389",
          CRADDR: "서울특별시 영등포구 신길로28길 25",
          CRTELNO: "02-6269-1900",
          CRFAXNO: "02-6269-1906",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "77",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "11",
          CRCAPAT: "29",
          CRCHCNT: "29",
          LA: "37.50256734047092",
          LO: "126.91294770575835",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 56.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000638",
          CRNAME: "보배사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08218",
          CRADDR: "서울특별시 구로구 중앙로12길 7 101동 101호",
          CRTELNO: "02-2619-3377",
          CRFAXNO: "02-2619-3377",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.505720170148884",
          LO: "126.86149991896883",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 57.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000494",
          CRNAME: "삼성어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02624",
          CRADDR: "서울특별시 동대문구 한천로26길 43",
          CRTELNO: "02-2243-5033",
          CRFAXNO: "02-2245-4821",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "310",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "13",
          CRCAPAT: "66",
          CRCHCNT: "65",
          LA: "37.56486896282023",
          LO: "126.97822270386973",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 65.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000743",
          CRNAME: "구립 염창별하어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07562",
          CRADDR: "서울특별시 강서구 공항대로 543",
          CRTELNO: "02-3662-7942",
          CRFAXNO: "02-3662-7943",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "138",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "45",
          CRCHCNT: "42",
          LA: "37.55074888879517",
          LO: "126.86644121807556",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 91.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000810",
          CRNAME: "거여하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05744",
          CRADDR: "서울특별시 송파구 오금로 475",
          CRTELNO: "02-402-2010",
          CRFAXNO: "02-402-2013",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "394",
          PLGRDCO: "2",
          CCTVINSTLCNT: "45",
          CHCRTESCNT: "27",
          CRCAPAT: "137",
          CRCHCNT: "118",
          LA: "37.494507308313665",
          LO: "127.14216582092256",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 20.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 118.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 21.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 28.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000738",
          CRNAME: "구립 이든아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07674",
          CRADDR: "서울특별시 강서구 까치산로18나길 22-1",
          CRTELNO: "02-2605-0241",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "186",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "59",
          CRCHCNT: "45",
          LA: "37.546340171942234",
          LO: "126.84912436488083",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000535",
          CRNAME: "구립사랑그린어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05416",
          CRADDR: "서울특별시 강동구 고덕로98길 29 강동리엔파크9단지 관리동",
          CRTELNO: "02-441-9829",
          CRFAXNO: "02-441-9830",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "106",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "37",
          CRCHCNT: "37",
          LA: "37.557092144560926",
          LO: "127.18076438413571",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 60.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000371",
          CRNAME: "한별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03763",
          CRADDR: "서울특별시 서대문구 이화여대8길 123 힐스테이트신촌아파트 단지 내",
          CRTELNO: "02-392-6001",
          CRFAXNO: "02-392-6002",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "104",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "34",
          CRCHCNT: "31",
          LA: "37.56251594588798",
          LO: "126.95096584122223",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000534",
          CRNAME: "구립해봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05201",
          CRADDR: "서울특별시 강동구 아리수로93가길 70 강동리버스트7단지아파트 관리동",
          CRTELNO: "02-426-9370",
          CRFAXNO: "02-427-9370",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "269",
          PLGRDCO: "3",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "18",
          CRCAPAT: "92",
          CRCHCNT: "77",
          LA: "37.570764981025725",
          LO: "127.17462256085062",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 13.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 77.0,
          EM_CNT_0Y: 93.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 3.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000533",
          CRNAME: "구립강동해밀어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05201",
          CRADDR: "서울특별시 강동구 아리수로93가길 77 강동리버스트6단지아파트 관리동",
          CRTELNO: "02-426-8861",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "289",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "18",
          CRCAPAT: "98",
          CRCHCNT: "92",
          LA: "37.57094320360174",
          LO: "127.1698007988202",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 1.0,
          CHILD_CNT_TOT: 92.0,
          EM_CNT_0Y: 53.0,
          EM_CNT_1Y: 47.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000737",
          CRNAME: "구립대우주어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07703",
          CRADDR: "서울특별시 강서구 화곡로13길 107 135동 101호",
          CRTELNO: "02-2605-7313",
          CRFAXNO: "02-2605-7312",
          CRHOME: "daewooju2002@",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "97",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.54446280191979",
          LO: "126.83168788169064",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 7.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 44.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000449",
          CRNAME: "서초구립 센트럴아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06652",
          CRADDR: "서울특별시 서초구 반포대로18길 36",
          CRTELNO: "02-2088-7137",
          CRFAXNO: "02-2088-7139",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "92",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "11",
          CRCAPAT: "31",
          CRCHCNT: "31",
          LA: "37.48671742730503",
          LO: "127.0120532189087",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 44.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000484",
          CRNAME: "신길힐스테이트나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07388",
          CRADDR: "서울특별시 영등포구 신길로28길 9",
          CRTELNO: "02-6672-8330",
          CRFAXNO: "02-6672-8334",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "198",
          PLGRDCO: "2",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "14",
          CRCAPAT: "65",
          CRCHCNT: "54",
          LA: "37.504200634223174",
          LO: "126.9117286145243",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-10-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 46.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000804",
          CRNAME: "위례푸른숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05776",
          CRADDR: "서울특별시 송파구 위례북로4길 12",
          CRTELNO: "02-409-7942",
          CRFAXNO: "02-406-7942",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "188",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "13",
          CRCAPAT: "67",
          CRCHCNT: "67",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-10-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 67.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 46.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000495",
          CRNAME: "도토리소풍넥슨 강남어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06124",
          CRADDR: "서울특별시 강남구 강남대로110길 36 (역삼동)",
          CRTELNO: "02-538-1026",
          CRFAXNO: "",
          CRHOME: "https://blog.naver.com/dotorisopoong",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "240",
          PLGRDCO: "2",
          CCTVINSTLCNT: "37",
          CHCRTESCNT: "19",
          CRCAPAT: "74",
          CRCHCNT: "19",
          LA: "37.50391269055466",
          LO: "127.02800527855721",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2020-10-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 5.0,
          CHILD_CNT_05: 3.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 92.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000494",
          CRNAME: "현대오토에버 늘해랑어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06185",
          CRADDR: "서울특별시 강남구 삼성로84길 13",
          CRTELNO: "02-3453-0053",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "71",
          PLGRDCO: "0",
          CCTVINSTLCNT: "29",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "10",
          LA: "37.505585167041374",
          LO: "127.0587247438632",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-10-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 2.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 09:13:36.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000802",
          CRNAME: "쿠팡(위례)어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05849",
          CRADDR: "서울특별시 송파구 위례광장로 188 아이온스퀘어 2F",
          CRTELNO: "02-400-7790",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "291",
          PLGRDCO: "0",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "7",
          CRCAPAT: "49",
          CRCHCNT: "11",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-10-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 11.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000496",
          CRNAME: "포레스트어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06310",
          CRADDR: "서울특별시 강남구 개포로 264",
          CRTELNO: "02-2058-3788",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "191",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "17",
          CRCAPAT: "72",
          CRCHCNT: "50",
          LA: "37.479437194218946",
          LO: "127.05316299020794",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 18.0,
          CHILD_CNT_02: 24.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 50.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000358",
          CRNAME: "구립 샘물어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05105",
          CRADDR: "서울특별시 광진구 뚝섬로58길 56 101호",
          CRTELNO: "02-3437-7737",
          CRFAXNO: "02-3437-7737",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.52978908152651",
          LO: "127.08526669695727",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000803",
          CRNAME: "거여사과나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05735",
          CRADDR: "서울특별시 송파구 거마로 41 302동 101호(거여동, 현대3차아파트)",
          CRTELNO: "02-3402-3425",
          CRFAXNO: "02-3402-3425",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "18",
          LA: "37.49704432828737",
          LO: "127.14530308667383",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 13.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 57.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000493",
          CRNAME: "빛의숲어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06025",
          CRADDR: "서울특별시 강남구 논현로158길 19 1층",
          CRTELNO: "02-542-5857",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "76",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.52217217615748",
          LO: "127.02999599796587",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 10.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 88.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000801",
          CRNAME: "송파아이숲어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05764",
          CRADDR: "서울특별시 송파구 오금로 551 205동 104호",
          CRTELNO: "02-400-6079",
          CRFAXNO: "02-400-6079",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "48",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "17",
          CRCHCNT: "16",
          LA: "37.49397484907481",
          LO: "127.15014829068738",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000209",
          CRNAME: "큰나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04387",
          CRADDR: "서울특별시 용산구 서빙고로 17 102동 1,2,3층",
          CRTELNO: "02-797-7703",
          CRFAXNO: "02-797-7702",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "191",
          PLGRDCO: "3",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "18",
          CRCAPAT: "70",
          CRCHCNT: "59",
          LA: "37.52525530284135",
          LO: "126.9678957636705",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 5.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 16.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 25.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 5.0,
          CHILD_CNT_TOT: 59.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 2.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000532",
          CRNAME: "구립늘해랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05222",
          CRADDR: "서울특별시 강동구 고덕로 399 고덕센트럴푸르지오아파트 관리동",
          CRTELNO: "02-429-7942",
          CRFAXNO: "02-429-7952",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "215",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "14",
          CRCAPAT: "72",
          CRCHCNT: "59",
          LA: "37.557803334576164",
          LO: "127.16978653932865",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 59.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000645",
          CRNAME: "꿈빛 어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02802",
          CRADDR: "서울특별시 성북구 종암로21길 127 101동 101호",
          CRTELNO: "02-6227-4960",
          CRFAXNO: "02-6499-1422",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.602510737200355",
          LO: "127.0296927379172",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000482",
          CRNAME: "새솔아델포레어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07440",
          CRADDR: "서울특별시 영등포구 신길로 29",
          CRTELNO: "02-6334-0202",
          CRFAXNO: "02-6334-0203",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "148",
          PLGRDCO: "2",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "14",
          CRCAPAT: "51",
          CRCHCNT: "50",
          LA: "37.4943580052568",
          LO: "126.9069794865993",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 50.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 55.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000470",
          CRNAME: "사가정 아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02226",
          CRADDR: "서울특별시 중랑구 동일로92길 40 (면목동)",
          CRTELNO: "02-496-8077",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "204",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "10",
          CRCAPAT: "48",
          CRCHCNT: "48",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 48.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 86.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000469",
          CRNAME: "라온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02234",
          CRADDR: "서울특별시 중랑구 동일로91길 23 (면목동)",
          CRTELNO: "02-432-5592",
          CRFAXNO: "02-432-5598",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "8",
          CRCAPAT: "23",
          CRCHCNT: "21",
          LA: "37.582125753837964",
          LO: "127.07879675053024",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000674",
          CRNAME: "신아푸르지오 어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03305",
          CRADDR: "서울특별시 은평구 연서로 455 제각말 5단지 푸르지오 관리동(진관동)",
          CRTELNO: "02-358-0404",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "209",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "3",
          CRCAPAT: "48",
          CRCHCNT: "4",
          LA: "37.63618315913699",
          LO: "126.93260322441205",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 4.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 1.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 3.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000549",
          CRNAME: "서울도봉경찰서어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01415",
          CRADDR: "서울특별시 도봉구 노해로 403 서울도봉경찰서어린이집",
          CRTELNO: "02-906-8190",
          CRFAXNO: "02-906-8192",
          CRHOME: "https://hansol-sdbpolice.kidsnote.ac",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "462",
          PLGRDCO: "1",
          CCTVINSTLCNT: "35",
          CHCRTESCNT: "21",
          CRCAPAT: "100",
          CRCHCNT: "56",
          LA: "37.65338139600192",
          LO: "127.05273430906743",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-08-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 17.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 56.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000465",
          CRNAME: "중앙그룹직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03908",
          CRADDR: "서울특별시 마포구 월드컵북로 375 1,2층",
          CRTELNO: "070-8672-9249",
          CRFAXNO: "070-8230-9249",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "229",
          PLGRDCO: "0",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "20",
          CRCAPAT: "49",
          CRCHCNT: "35",
          LA: "37.577019374478915",
          LO: "126.89019019773008",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-08-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 73.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000564",
          CRNAME: "카페24직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08708",
          CRADDR: "서울특별시 관악구 보라매로3길 23 2층(카페24직장어린이집)",
          CRTELNO: "02-6279-2411",
          CRFAXNO: "02-6279-2410",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "143",
          PLGRDCO: "0",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "20",
          LA: "37.49110726306653",
          LO: "126.92553931933058",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-08-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 44.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000637",
          CRNAME: "별하어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08368",
          CRADDR: "서울특별시 구로구 항동로 68 하버라인9단지 관리동 내",
          CRTELNO: "02-2682-0996",
          CRFAXNO: "02-2682-0995",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "166",
          PLGRDCO: "2",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "43",
          LA: "37.480237703654495",
          LO: "126.82592750041213",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-08-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000481",
          CRNAME: "당산2동센트럴아이파크별하어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07215",
          CRADDR: "서울특별시 영등포구 영신로 247 107동 관리동",
          CRTELNO: "02-2135-2653",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "98",
          PLGRDCO: "2",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.52985378042614",
          LO: "126.90229690399766",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-08-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 11.0,
          EM_CNT_1Y: 89.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000800",
          CRNAME: "방이즐거운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05629",
          CRADDR: "서울특별시 송파구 가락로39길 6 (방이동)",
          CRTELNO: "02-413-5277",
          CRFAXNO: "02-413-5278",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "210",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "14",
          CRCAPAT: "73",
          CRCHCNT: "58",
          LA: "37.51180572815811",
          LO: "127.11845739079227",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-08-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 55.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000799",
          CRNAME: "송파파크센트럴어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05764",
          CRADDR: "서울특별시 송파구 오금로 551",
          CRTELNO: "02-403-7700",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "192",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "12",
          CRCAPAT: "65",
          CRCHCNT: "52",
          LA: "37.49377219502896",
          LO: "127.15009134492844",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 52.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 70.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000563",
          CRNAME: "구립키즈맘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08719",
          CRADDR: "서울특별시 관악구 봉천로23나길 35 101호",
          CRTELNO: "02-874-0761",
          CRFAXNO: "02-872-0761",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "94",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "11",
          CRCAPAT: "22",
          CRCHCNT: "20",
          LA: "37.48705735540585",
          LO: "126.93739873779566",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 63.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000492",
          CRNAME: "현대모비스모아어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06131",
          CRADDR: "서울특별시 강남구 테헤란로13길 34",
          CRTELNO: "02-3454-0062",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "143",
          PLGRDCO: "2",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "13",
          CRCAPAT: "49",
          CRCHCNT: "24",
          LA: "37.50187767268194",
          LO: "127.03193730838664",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 09:13:36.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000636",
          CRNAME: "해바라기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08368",
          CRADDR: "서울특별시 구로구 항동로 8 관리동",
          CRTELNO: "02-2060-5887",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "130",
          PLGRDCO: "2",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "45",
          CRCHCNT: "45",
          LA: "37.47697263973236",
          LO: "126.82063280511778",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 14.0,
          CHILD_CNT_05: 13.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000635",
          CRNAME: "참누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08274",
          CRADDR: "서울특별시 구로구 경인로 302 관리동 (개봉동,개봉역센트레빌레우스 임대아파트)",
          CRTELNO: "02-2612-2021",
          CRFAXNO: "02-2612-2022",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "259",
          PLGRDCO: "2",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "22",
          CRCAPAT: "94",
          CRCHCNT: "92",
          LA: "37.49577831712668",
          LO: "126.85461738089458",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 15.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 15.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 22.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 92.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 18.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 22.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000531",
          CRNAME: "구립강동든든어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05201",
          CRADDR: "서울특별시 강동구 아리수로93가길 110 강동리버스트 4단지 관리동",
          CRTELNO: "02-442-2807",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "270",
          PLGRDCO: "4",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "21",
          CRCAPAT: "95",
          CRCHCNT: "85",
          LA: "37.57279968725017",
          LO: "127.17260670088828",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 85.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 71.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 17.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000480",
          CRNAME: "당산2동은솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07215",
          CRADDR: "서울특별시 영등포구 당산로42길 23",
          CRTELNO: "02-2636-5630",
          CRFAXNO: "02-2635-5630",
          CRHOME: "",
          NRTRROOMCNT: "12",
          NRTRROOMSIZE: "465",
          PLGRDCO: "2",
          CCTVINSTLCNT: "29",
          CHCRTESCNT: "26",
          CRCAPAT: "150",
          CRCHCNT: "137",
          LA: "37.53015741513897",
          LO: "126.90175063111649",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 30.0,
          CHILD_CNT_04: 28.0,
          CHILD_CNT_05: 35.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 137.0,
          EM_CNT_0Y: 76.0,
          EM_CNT_1Y: 24.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 21.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 26.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000448",
          CRNAME: "서초구립 반포센트럴자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06509",
          CRADDR: "서울특별시 서초구 반포대로 310-6 (반포센트럴자이어린이집)",
          CRTELNO: "02-533-8801",
          CRFAXNO: "02-533-8803",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "247",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "19",
          CRCAPAT: "62",
          CRCHCNT: "54",
          LA: "37.50605363150327",
          LO: "127.00181523497761",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 2.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 81.0,
          EM_CNT_1Y: 19.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000644",
          CRNAME: "아이누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02726",
          CRADDR: "서울특별시 성북구 숭인로 16 103동 101호",
          CRTELNO: "02-982-3949",
          CRFAXNO: "02-6959-3949",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000179",
          CRNAME: "서울지방국세청 우리누리어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03151",
          CRADDR: "서울특별시 종로구 종로5길 86",
          CRTELNO: "02-739-5100",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "152",
          PLGRDCO: "2",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "8",
          CRCAPAT: "55",
          CRCHCNT: "20",
          LA: "37.57413147177976",
          LO: "126.97977086919582",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 100.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000468",
          CRNAME: "새우개 하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02052",
          CRADDR: "서울특별시 중랑구 용마산로139다길 17 (신내동)",
          CRTELNO: "02-438-1318",
          CRFAXNO: "02-438-1319",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "196",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "14",
          CRCAPAT: "68",
          CRCHCNT: "33",
          LA: "37.618858961284786",
          LO: "127.10248614533913",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 55.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000630",
          CRNAME: "공공형실내놀이터5색깔깔KIDS(양천구육아종합지원센터)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08102",
          CRADDR: "서울특별시 양천구 목동남로 106-23",
          CRTELNO: "02-2135-5946",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "457",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2020-06-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000619",
          CRNAME: "서울남부지방법원 직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08088",
          CRADDR: "서울특별시 양천구 신월로 386 별관 5층",
          CRTELNO: "02-2192-1930",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "377",
          PLGRDCO: "2",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "12",
          CRCAPAT: "60",
          CRCHCNT: "30",
          LA: "37.52115248417557",
          LO: "126.86376210788262",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 6.0,
          CHILD_CNT_05: 5.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 56.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000736",
          CRNAME: "두빛나래터발도르프어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07669",
          CRADDR: "서울특별시 강서구 등촌로39마길 52",
          CRTELNO: "02-2653-6986",
          CRFAXNO: "02-2653-6986",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "52",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "5",
          CRCAPAT: "15",
          CRCHCNT: "14",
          LA: "37.54411649879256",
          LO: "126.85783055285174",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 75.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000478",
          CRNAME: "아이키움문래어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07282",
          CRADDR: "서울특별시 영등포구 선유로9길 30 102동 1층(문래동6가)",
          CRTELNO: "02-6397-7955",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "280",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "15",
          CRCAPAT: "75",
          CRCHCNT: "70",
          LA: "37.51816857427777",
          LO: "126.8856160745003",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 70.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 55.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000673",
          CRNAME: "구립 물빛캐슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03487",
          CRADDR: "서울특별시 은평구 수색로 300",
          CRTELNO: "02-6951-2081",
          CRFAXNO: "02-6951-2082",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "244",
          PLGRDCO: "1",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "17",
          CRCAPAT: "88",
          CRCHCNT: "76",
          LA: "37.58539584468246",
          LO: "126.89207430641097",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 15.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 2.0,
          CHILD_CNT_TOT: 76.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 57.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000463",
          CRNAME: "다올어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04044",
          CRADDR: "서울특별시 마포구 양화로 72 1층",
          CRTELNO: "02-332-2322",
          CRFAXNO: "02-332-3733",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "240",
          PLGRDCO: "2",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "14",
          CRCAPAT: "57",
          CRCHCNT: "45",
          LA: "37.5506413489504",
          LO: "126.91596286811368",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 24.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 64.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000493",
          CRNAME: "늘봄어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02437",
          CRADDR: "서울특별시 동대문구 외대역동로1길 60-3 휘경해모로 관리동",
          CRTELNO: "02-3390-3094",
          CRFAXNO: "02-2212-3094",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "94",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "7",
          CRCAPAT: "32",
          CRCHCNT: "14",
          LA: "37.59111843409087",
          LO: "127.06244488137038",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 80.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000378",
          CRNAME: "한나무어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01422",
          CRADDR: "서울특별시 도봉구 노해로66길 21 103동 105호(창동, 삼성래미안아파트)",
          CRTELNO: "02-995-2447",
          CRFAXNO: "",
          CRHOME: "no042018@naver.com",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "71",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "17",
          CRCHCNT: "13",
          LA: "37.64890177",
          LO: "127.0484761",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 20.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000618",
          CRNAME: "구립 마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08067",
          CRADDR: "서울특별시 양천구 남부순환로83길 47 목동센트럴아이파크위브아파트 4단지",
          CRTELNO: "02-2604-4301",
          CRFAXNO: "02-2602-4301",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "181",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "52",
          LA: "37.51700144100649",
          LO: "126.84399712181549",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 52.0,
          EM_CNT_0Y: 92.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000617",
          CRNAME: "구립 나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08068",
          CRADDR: "서울특별시 양천구 남부순환로83길 18 목동센트럴아이파크위브아파트 2단지",
          CRTELNO: "02-2603-4110",
          CRFAXNO: "02-2607-4110",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "197",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "17",
          CRCAPAT: "68",
          CRCHCNT: "58",
          LA: "37.515882550791694",
          LO: "126.8427552027485",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 17.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 5.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000634",
          CRNAME: "날아라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08362",
          CRADDR: "서울특별시 구로구 부광로 96-16",
          CRTELNO: "02-2066-7114",
          CRFAXNO: "02-2066-7115",
          CRHOME: "https://iseoul.seoul.go.kr/portal/mainCall.do",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "118",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "12",
          CRCAPAT: "32",
          CRCHCNT: "32",
          LA: "37.475735191171125",
          LO: "126.81571230878866",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000616",
          CRNAME: "구립 가온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08066",
          CRADDR: "서울특별시 양천구 남부순환로83길 17 목동센트럴아이파크위브아파트 1단지",
          CRTELNO: "02-2602-2484",
          CRFAXNO: "02-2606-2484",
          CRHOME: "sej7799",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "195",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "65",
          CRCHCNT: "55",
          LA: "37.51608317983839",
          LO: "126.8411881560094",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 55.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000530",
          CRNAME: "구립에코포레어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05300",
          CRADDR: "서울특별시 강동구 천중로 253 이편한세상강동에코포레아파트 관리동 1층",
          CRTELNO: "02-470-0633",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "125",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 44.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000798",
          CRNAME: "거여키즈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05735",
          CRADDR: "서울특별시 송파구 거마로 41 303동 102호(거여동, 현대3차아파트)",
          CRTELNO: "02-408-6198",
          CRFAXNO: "02-408-6198",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49698159153477",
          LO: "127.14503156118054",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 57.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000438",
          CRNAME: "구립다움어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07029",
          CRADDR: "서울특별시 동작구 사당로 90 사당롯데캐슬골든포레 관리동 1층",
          CRTELNO: "02-582-2990",
          CRFAXNO: "02-582-2991",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000438",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "300",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "33",
          CRCHCNT: "33",
          LA: "37.49150538665857",
          LO: "126.96229453741421",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "휴일보육",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000479",
          CRNAME: "영등포든든어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07412",
          CRADDR: "서울특별시 영등포구 대림로35가길 9",
          CRTELNO: "02-842-2021",
          CRFAXNO: "02-842-2022",
          CRHOME: "http://cafe.daum.net/ydpdd",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "185",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "13",
          CRCAPAT: "65",
          CRCHCNT: "56",
          LA: "37.49808746253722",
          LO: "126.8979364066676",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 60.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000672",
          CRNAME: "구립 응암행복어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03472",
          CRADDR: "서울특별시 은평구 은평로 220",
          CRTELNO: "02-353-0701",
          CRFAXNO: "02-353-0702",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "261",
          PLGRDCO: "2",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "21",
          CRCAPAT: "98",
          CRCHCNT: "80",
          LA: "37.599214118587724",
          LO: "126.93001791989486",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 10.0,
          CHILD_CNT_05: 15.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 80.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 83.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 18.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000629",
          CRNAME: "방아다리장난감도서관공동육아방(양천구육아종합지원센터)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07904",
          CRADDR: "서울특별시 양천구 화곡로4길 10 6층",
          CRTELNO: "02-6959-4015",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "315",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2020-05-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000671",
          CRNAME: "구립 응암샛별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03472",
          CRADDR: "서울특별시 은평구 은평로 220",
          CRTELNO: "02-354-5208",
          CRFAXNO: "02-354-5207",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "299",
          PLGRDCO: "3",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "23",
          CRCAPAT: "111",
          CRCHCNT: "94",
          LA: "37.59763877139405",
          LO: "126.93239737677528",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 94.0,
          EM_CNT_0Y: 79.0,
          EM_CNT_1Y: 21.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 19.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 23.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000462",
          CRNAME: "신촌그랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04105",
          CRADDR: "서울특별시 마포구 대흥로 175 관리동",
          CRTELNO: "02-6949-0277",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "320",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "16",
          CRCAPAT: "71",
          CRCHCNT: "55",
          LA: "37.55465868433829",
          LO: "126.944590909634",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 21.0,
          EM_CNT_1Y: 79.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000529",
          CRNAME: "이삭숲어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05219",
          CRADDR: "서울특별시 강동구 동남로82길 29-8 이삭숲어린이집",
          CRTELNO: "02-441-2914",
          CRFAXNO: "02-442-2914",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "182",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "16",
          CRCAPAT: "62",
          CRCHCNT: "59",
          LA: "37.560939585343014",
          LO: "127.15869762027994",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2020-05-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 7.0,
          CLASS_CNT_02: 8.0,
          CLASS_CNT_03: 3.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 23.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 59.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 54.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:05:36.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000369",
          CRNAME: "서대문든든어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03689",
          CRADDR: "서울특별시 서대문구 거북골로 100 래미안루센티아아파트",
          CRTELNO: "02-306-2020",
          CRFAXNO: "02-306-2021",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "219",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "15",
          CRCAPAT: "71",
          CRCHCNT: "62",
          LA: "37.57617620957502",
          LO: "126.91685113835815",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 31.0,
          EM_CNT_1Y: 69.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000447",
          CRNAME: "한샘어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06552",
          CRADDR: "서울특별시 서초구 방배로 285 한샘빌딩",
          CRTELNO: "02-6908-4051",
          CRFAXNO: "02-591-3996",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "125",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "8",
          CRCAPAT: "42",
          CRCHCNT: "10",
          LA: "37.498146576665405",
          LO: "126.98675187832998",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000464",
          CRNAME: "행복타운어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04212",
          CRADDR: "서울특별시 마포구 마포대로 144 마포T타운 2층",
          CRTELNO: "070-7470-3598",
          CRFAXNO: "02-465-0110",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "201",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "35",
          CRCHCNT: "12",
          LA: "37.546999628546104",
          LO: "126.95372863761882",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 12.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000396",
          CRNAME: "모두의 숲 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04790",
          CRADDR: "서울특별시 성동구 상원6나길 22-7",
          CRTELNO: "02-463-0312",
          CRFAXNO: "02-463-0316",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "152",
          PLGRDCO: "0",
          CCTVINSTLCNT: "55",
          CHCRTESCNT: "16",
          CRCAPAT: "49",
          CRCHCNT: "39",
          LA: "37.54753875557011",
          LO: "127.04988720206629",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000477",
          CRNAME: "신길센트럴자이 솔빛 어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07397",
          CRADDR: "서울특별시 영등포구 신길로29길 17",
          CRTELNO: "02-848-1531",
          CRFAXNO: "02-848-1532",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "242",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "18",
          CRCAPAT: "75",
          CRCHCNT: "74",
          LA: "37.50299027294372",
          LO: "126.90778305559252",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 74.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 73.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000735",
          CRNAME: "구립 신태양어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07745",
          CRADDR: "서울특별시 강서구 곰달래로31다길 25",
          CRTELNO: "02-2699-1921",
          CRFAXNO: "02-844-3377",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "306",
          PLGRDCO: "1",
          CCTVINSTLCNT: "30",
          CHCRTESCNT: "16",
          CRCAPAT: "99",
          CRCHCNT: "75",
          LA: "37.5335999884826",
          LO: "126.8526488956395",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 16.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 18.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 75.0,
          EM_CNT_0Y: 31.0,
          EM_CNT_1Y: 39.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000670",
          CRNAME: "한국환경산업기술원 초록꿈나무 직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03367",
          CRADDR: "서울특별시 은평구 진흥로 215 A동",
          CRTELNO: "02-356-7071",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "196",
          PLGRDCO: "1",
          CCTVINSTLCNT: "29",
          CHCRTESCNT: "13",
          CRCAPAT: "40",
          CRCHCNT: "33",
          LA: "37.60984284099562",
          LO: "126.93267513409054",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 5.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 4.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000633",
          CRNAME: "엔젤어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08371",
          CRADDR: "서울특별시 구로구 디지털로31길 90 108동 103호",
          CRTELNO: "02-838-6157",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "86",
          PLGRDCO: "2",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000357",
          CRNAME: "구립 아이와나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04931",
          CRADDR: "서울특별시 광진구 천호대로123길 4-4",
          CRTELNO: "02-452-5579",
          CRFAXNO: "",
          CRHOME: "www.kidtree.or.kr",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "222",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "40",
          LA: "37.5552386575872",
          LO: "127.08718850385628",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000467",
          CRNAME: "꼬마사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02131",
          CRADDR: "서울특별시 중랑구 봉우재로6길 9 (면목동)",
          CRTELNO: "02-432-0097",
          CRFAXNO: "02-434-1097",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "143",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "13",
          CRCAPAT: "42",
          CRCHCNT: "41",
          LA: "37.589556087262416",
          LO: "127.07628815848594",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,휴일보육",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 30.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000562",
          CRNAME: "구립인헌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08798",
          CRADDR: "서울특별시 관악구 낙성대역14길 6",
          CRTELNO: "02-889-8586",
          CRFAXNO: "02-889-8587",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11620000562",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "162",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "15",
          CRCAPAT: "59",
          CRCHCNT: "46",
          LA: "37.47389803946412",
          LO: "126.9642761116863",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 17.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 7.0,
          CHILD_CNT_TOT: 46.0,
          EM_CNT_0Y: 77.0,
          EM_CNT_1Y: 23.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000669",
          CRNAME: "구립 이든어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03465",
          CRADDR: "서울특별시 은평구 응암로30길 15",
          CRTELNO: "02-356-9616",
          CRFAXNO: "02-356-9617",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "112",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "13",
          CRCAPAT: "42",
          CRCHCNT: "42",
          LA: "37.57306904776708",
          LO: "126.98476327738204",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000476",
          CRNAME: "서비스에이스 하람어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07298",
          CRADDR: "서울특별시 영등포구 문래로28길 25 에스타워 3층(문래동3가)",
          CRTELNO: "02-6256-0190",
          CRFAXNO: "02-6256-0193",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "182",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "14",
          CRCAPAT: "49",
          CRCHCNT: "31",
          LA: "37.51576899748815",
          LO: "126.89977021844858",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000207",
          CRNAME: "국립중앙박물관 해누림 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04383",
          CRADDR: "서울특별시 용산구 서빙고로 137 국립중앙박물관",
          CRTELNO: "02-2077-9048",
          CRFAXNO: "02-2077-9969",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "246",
          PLGRDCO: "0",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "10",
          CRCAPAT: "39",
          CRCHCNT: "20",
          LA: "37.5234949563665",
          LO: "126.97760123514483",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000797",
          CRNAME: "우아한어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05547",
          CRADDR: "서울특별시 송파구 올림픽로32길 37-22",
          CRTELNO: "02-422-9941",
          CRFAXNO: "02-422-9943",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "491",
          PLGRDCO: "0",
          CCTVINSTLCNT: "61",
          CHCRTESCNT: "16",
          CRCAPAT: "49",
          CRCHCNT: "33",
          LA: "37.51386944503875",
          LO: "127.11107170993934",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 1.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 58.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000208",
          CRNAME: "목멱어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04346",
          CRADDR: "서울특별시 용산구 회나무로12나길 10",
          CRTELNO: "02-6954-2057",
          CRFAXNO: "070-7543-1750",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "163",
          PLGRDCO: "2",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.53904801482917",
          LO: "126.99092548482404",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 11.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000491",
          CRNAME: "포스코 제2 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06194",
          CRADDR: "서울특별시 강남구 테헤란로 440 포스코센터 4층",
          CRTELNO: "02-3457-6591",
          CRFAXNO: "02-3457-6593",
          CRHOME: "www.puruni.com/posco4",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "321",
          PLGRDCO: "1",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "22",
          CRCAPAT: "100",
          CRCHCNT: "66",
          LA: "37.506272145575636",
          LO: "127.05649298914424",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 4.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 9.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 23.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 43.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 19.0,
          EM_CNT_2Y: 56.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 22.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000734",
          CRNAME: "구립 새하늘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07768",
          CRADDR: "서울특별시 강서구 강서로17다길 15-14",
          CRTELNO: "02-2603-2225",
          CRFAXNO: "02-2603-2273",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "245",
          PLGRDCO: "1",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "15",
          CRCAPAT: "92",
          CRCHCNT: "87",
          LA: "37.533292638547174",
          LO: "126.84143452083826",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 29.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 87.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000163",
          CRNAME: "한빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02449",
          CRADDR: "서울특별시 동대문구 천장산로7길 16 (이문동)",
          CRTELNO: "02-2135-5861",
          CRFAXNO: "02-2135-5863",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "16",
          LA: "37.598485672505454",
          LO: "127.05699152673695",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 16.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000460",
          CRNAME: "월드컵어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03902",
          CRADDR: "서울특별시 마포구 월드컵북로 501 관리동 1층",
          CRTELNO: "02-383-3201",
          CRFAXNO: "0504-189-1998",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "114",
          PLGRDCO: "2",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "13",
          CRCAPAT: "42",
          CRCHCNT: "42",
          LA: "37.58339153176849",
          LO: "126.87857058016193",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000457",
          CRNAME: "신촌숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04094",
          CRADDR: "서울특별시 마포구 광성로 17 관리동 1층",
          CRTELNO: "02-717-1357",
          CRFAXNO: "02-718-1357",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "426",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "19",
          CRCAPAT: "79",
          CRCHCNT: "75",
          LA: "37.550513974028064",
          LO: "126.93548412444123",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 75.0,
          EM_CNT_0Y: 73.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 2.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000444",
          CRNAME: "서초구립 롯데캐슬킨더어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06608",
          CRADDR: "서울특별시 서초구 서운로 197 1층",
          CRTELNO: "02-591-3009",
          CRFAXNO: "02-591-3911",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "215",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "16",
          CRCAPAT: "48",
          CRCHCNT: "46",
          LA: "37.50048803973917",
          LO: "127.02116486026872",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 46.0,
          EM_CNT_0Y: 15.0,
          EM_CNT_1Y: 54.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001054",
          CRNAME: "진주어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01618",
          CRADDR: "서울특별시 노원구 동일로227길 86 1614동 103호",
          CRTELNO: "02-930-0240",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "52",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "15",
          CRCHCNT: "15",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000366",
          CRNAME: "늘품자연어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03687",
          CRADDR: "서울특별시 서대문구 거북골로 84 DMC에코자이아파트 단지 내",
          CRTELNO: "02-306-0972",
          CRFAXNO: "02-306-0973",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "593",
          PLGRDCO: "2",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "17",
          CRCAPAT: "91",
          CRCHCNT: "86",
          LA: "37.57747559196733",
          LO: "126.91966853934444",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,시간제보육",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 86.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 21.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000463",
          CRNAME: "푸른숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02191",
          CRADDR: "서울특별시 중랑구 용마산로94길 94 (면목동)",
          CRTELNO: "02-2208-3004",
          CRFAXNO: "02-2208-3033",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "594",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "14",
          CRCAPAT: "75",
          CRCHCNT: "57",
          LA: "37.587342536144796",
          LO: "127.10225044186275",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 5.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 18.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 57.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000548",
          CRNAME: "무지개어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01480",
          CRADDR: "서울특별시 도봉구 덕릉로60길 121-20",
          CRTELNO: "02-999-8096",
          CRFAXNO: "",
          CRHOME: "https://WWW.kisnote.com",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "115",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "14",
          CRCAPAT: "43",
          CRCHCNT: "41",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000492",
          CRNAME: "웃음가득어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01318",
          CRADDR: "서울특별시 도봉구 마들로 859-19 106동 104호(도봉동, 도봉한신아파트)",
          CRTELNO: "02-955-1255",
          CRFAXNO: "02-955-1255",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "57",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "19",
          CRCHCNT: "17",
          LA: "37.686043",
          LO: "127.04676",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 20.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000459",
          CRNAME: "아름드리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03911",
          CRADDR: "서울특별시 마포구 월드컵로 338 관리동 1층",
          CRTELNO: "02-322-0714",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "138",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "11",
          CRCAPAT: "37",
          CRCHCNT: "27",
          LA: "37.57271199418254",
          LO: "126.88951732588158",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 10.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 78.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000668",
          CRNAME: "구립 내일어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03469",
          CRADDR: "서울특별시 은평구 응암로16길 20-9 구립 내일어린이집",
          CRTELNO: "02-306-3850",
          CRFAXNO: "02-306-3854",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11380000668",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "481",
          PLGRDCO: "4",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "15",
          CRCAPAT: "49",
          CRCHCNT: "45",
          LA: "38.27356621610019",
          LO: "126.12349990154604",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 20.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 42.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000343",
          CRNAME: "구립삼성어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01040",
          CRADDR: "서울특별시 강북구 한천로159길 8 삼성아파트 관리동",
          CRTELNO: "02-996-3737",
          CRFAXNO: "02-996-3737",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "127",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "45",
          CRCHCNT: "45",
          LA: "37.64482342455926",
          LO: "127.01822005848969",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000356",
          CRNAME: "구립 우리아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05036",
          CRADDR: "서울특별시 광진구 구의로4길 21 구의동",
          CRTELNO: "010-4697-9933",
          CRFAXNO: "02-454-6169",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "182",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "11",
          CRCAPAT: "42",
          CRCHCNT: "30",
          LA: "37.54012728673775",
          LO: "127.09083838447304",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000441",
          CRNAME: "서초구립 대우효령어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06696",
          CRADDR: "서울특별시 서초구 효령로 84",
          CRTELNO: "02-525-1116",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "50",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "7",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.47984316407856",
          LO: "126.99344539072645",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001053",
          CRNAME: "상계해솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01639",
          CRADDR: "서울특별시 노원구 수락산로 12 (상계역센트럴푸르지오A, 상계동)",
          CRTELNO: "02-931-0219",
          CRFAXNO: "02-3391-1141",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "188",
          PLGRDCO: "3",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "57",
          LA: "37.665253080542186",
          LO: "127.07532567245251",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 57.0,
          EM_CNT_0Y: 58.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001055",
          CRNAME: "호호어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01901",
          CRADDR: "서울특별시 노원구 석계로 49 현대아파트 단지내",
          CRTELNO: "02-943-8133",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "123",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "44",
          CRCHCNT: "31",
          LA: "37.61904228106277",
          LO: "127.06260131998363",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 56.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000733",
          CRNAME: "구립 해담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07609",
          CRADDR: "서울특별시 강서구 금낭화로11길 36",
          CRTELNO: "02-2662-3265",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "206",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "15",
          CRCAPAT: "73",
          CRCHCNT: "62",
          LA: "37.57003671366609",
          LO: "126.81031567726207",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 10.0,
          CHILD_CNT_05: 10.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 5.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 39.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 54.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000395",
          CRNAME: "구립 성수아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04795",
          CRADDR: "서울특별시 성동구 성수이로 137 관리동 1층 (성수동2가, 성수동아이파크)",
          CRTELNO: "02-469-5575",
          CRFAXNO: "02-474-6432",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "82",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "31",
          CRCHCNT: "25",
          LA: "37.54708974374037",
          LO: "127.05658035881122",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001052",
          CRNAME: "노원든든어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01879",
          CRADDR: "서울특별시 노원구 초안산로2라길 26 월계센트럴아이파크A, 월계동",
          CRTELNO: "02-998-0632",
          CRFAXNO: "02-998-0633",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "121",
          PLGRDCO: "0",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "12",
          CRCAPAT: "45",
          CRCHCNT: "37",
          LA: "37.630288784551375",
          LO: "127.05833417796677",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 70.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000465",
          CRNAME: "수자인어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02260",
          CRADDR: "서울특별시 중랑구 사가정로72길 26 한양수자인사가정파크 단지내 (면목동)",
          CRTELNO: "02-432-8366",
          CRFAXNO: "02-432-8365",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "23",
          CRCHCNT: "23",
          LA: "37.579916266560794",
          LO: "127.09391932502781",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000466",
          CRNAME: "보림어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02007",
          CRADDR: "서울특별시 중랑구 중랑천로 286 101동 101호(묵동, 현대아이파크)",
          CRTELNO: "02-948-0533",
          CRFAXNO: "02-948-0533",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.60997834008334",
          LO: "127.07425058726478",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000461",
          CRNAME: "GS예원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04093",
          CRADDR: "서울특별시 마포구 창전로 26 관리동 1층",
          CRTELNO: "02-712-7974",
          CRFAXNO: "02-716-7974",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "72",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "21",
          CRCHCNT: "21",
          LA: "37.54410985458978",
          LO: "126.9310199737591",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000443",
          CRNAME: "CJ키즈빌어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06761",
          CRADDR: "서울특별시 서초구 전원말4길 7",
          CRTELNO: "02-586-2022",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "356",
          PLGRDCO: "1",
          CCTVINSTLCNT: "82",
          CHCRTESCNT: "21",
          CRCAPAT: "120",
          CRCHCNT: "45",
          LA: "37.46552580887229",
          LO: "126.98931228795558",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 6.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 9.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 4.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000214",
          CRNAME: "단비어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01318",
          CRADDR: "서울특별시 도봉구  마들로 859-19 110동 106호(도봉동, 도봉한신아파트)",
          CRTELNO: "02-3494-0541",
          CRFAXNO: "02-3494-0541",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "56",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "5",
          CRCAPAT: "19",
          CRCHCNT: "12",
          LA: "37.6871570283429",
          LO: "127.0470668804918",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 12.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000178",
          CRNAME: "라이나생명 키즈나루 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03156",
          CRADDR: "서울특별시 종로구 삼봉로 48 시그나 빌딩 2층",
          CRTELNO: "02-3779-8170",
          CRFAXNO: "02-3779-8177",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "170",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "10",
          LA: "37.57209526383034",
          LO: "126.98000913689998",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 1.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 80.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000488",
          CRNAME: "신동아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06365",
          CRADDR: "서울특별시 강남구 헌릉로590길 10 관리동",
          CRTELNO: "02-451-1828",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "87",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "28",
          CRCHCNT: "28",
          LA: "37.464145909723534",
          LO: "127.10270695430392",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000368",
          CRNAME: "삼성영재어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03686",
          CRADDR: "서울특별시 서대문구 증가로 191 DMC래미안클라시스 108동 104호",
          CRTELNO: "02-374-6703",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.577986912494936",
          LO: "126.91643308758633",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000271",
          CRNAME: "나무어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01422",
          CRADDR: "서울특별시 도봉구 노해로66길 21 103동 106호(창동, 삼성래미안아파트)",
          CRTELNO: "02-900-8520",
          CRFAXNO: "02-900-8520",
          CRHOME: "서울시보육포털서비스",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "17",
          CRCHCNT: "16",
          LA: "37.64890177",
          LO: "127.0484761",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000394",
          CRNAME: "구립 왕십리하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04714",
          CRADDR: "서울특별시 성동구 무학봉16길 9-3",
          CRTELNO: "02-2296-3990",
          CRFAXNO: "02-2292-9326",
          CRHOME: "",
          NRTRROOMCNT: "10",
          NRTRROOMSIZE: "364",
          PLGRDCO: "2",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "22",
          CRCAPAT: "135",
          CRCHCNT: "126",
          LA: "37.56085493726033",
          LO: "127.03203886341048",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2020-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 3.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 27.0,
          CHILD_CNT_03: 40.0,
          CHILD_CNT_04: 25.0,
          CHILD_CNT_05: 34.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 126.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 86.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 2.0,
          EM_CNT_A7: 3.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 22.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000667",
          CRNAME: "서울소방학교 직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03312",
          CRADDR: "서울특별시 은평구 통일로 1031-21",
          CRTELNO: "02-354-3601",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "88",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "9",
          CRCAPAT: "30",
          CRCHCNT: "18",
          LA: "37.63390479410143",
          LO: "126.9135976809055",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000490",
          CRNAME: "다람패스트파이브공동직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06128",
          CRADDR: "서울특별시 강남구 봉은사로18길 45-1",
          CRTELNO: "02-3453-7734",
          CRFAXNO: "02-501-3137",
          CRHOME: "http://hansol-fastfive.kidsnote.ac",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "86",
          PLGRDCO: "1",
          CCTVINSTLCNT: "37",
          CHCRTESCNT: "8",
          CRCAPAT: "30",
          CRCHCNT: "10",
          LA: "37.50342806285197",
          LO: "127.02939333606257",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000458",
          CRNAME: "SK스토아 행복어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03925",
          CRADDR: "서울특별시 마포구 월드컵북로 402 2층(상암동,KGIT센터)",
          CRTELNO: "02-6393-5320",
          CRFAXNO: "02-6393-5321",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "216",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "12",
          CRCAPAT: "35",
          CRCHCNT: "32",
          LA: "37.58015376959722",
          LO: "126.88905348761143",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 73.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000206",
          CRNAME: "용산소방서직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04375",
          CRADDR: "서울특별시 용산구 한강대로 167 용산소방서",
          CRTELNO: "02-749-6034",
          CRFAXNO: "02-749-6035",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "99",
          PLGRDCO: "0",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "8",
          CRCAPAT: "18",
          CRCHCNT: "16",
          LA: "37.53408944063891",
          LO: "126.97157896186299",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 7.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000489",
          CRNAME: "블랭크어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06148",
          CRADDR: "서울특별시 강남구 선릉로93길 40 1층",
          CRTELNO: "02-6230-0100",
          CRFAXNO: "02-6230-0201",
          CRHOME: "www.puruni.com/blank",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "93",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "6",
          CRCAPAT: "25",
          CRCHCNT: "6",
          LA: "37.504643824265265",
          LO: "127.04548746162761",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 6.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000732",
          CRNAME: "LG이노텍 서울어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07796",
          CRADDR: "서울특별시 강서구 마곡중앙10로 30 E3",
          CRTELNO: "02-2135-1236",
          CRFAXNO: "02-2136-1936",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "97",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "24",
          LA: "37.56198781378141",
          LO: "126.83212383386143",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 4.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000526",
          CRNAME: "아이뜰어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05276",
          CRADDR: "서울특별시 강동구 고덕로80길 99 517동 103호(상일동, 고덕센트럴아이파크아파트)",
          CRTELNO: "02-427-0511",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.55253856812231",
          LO: "127.1679087240219",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:36.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000117",
          CRNAME: "키즈일레븐어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04637",
          CRADDR: "서울특별시 중구 한강대로 416 2층",
          CRTELNO: "02-6456-8560",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "161",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "7",
          CRCAPAT: "49",
          CRCHCNT: "11",
          LA: "37.55583997172427",
          LO: "126.9733362169908",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 11.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000527",
          CRNAME: "구립아르테온보나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05274",
          CRADDR: "서울특별시 강동구 고덕로 360 고덕아르테온 339동 인근 관리동",
          CRTELNO: "02-442-2022",
          CRFAXNO: "02-442-2022",
          CRHOME: "서울시보육포털서비스",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "56",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "21",
          CRCHCNT: "21",
          LA: "37.55564120343328",
          LO: "127.16402534518398",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000437",
          CRNAME: "유한버들새싹어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06927",
          CRADDR: "서울특별시 동작구 노량진로 74 유한양행",
          CRTELNO: "02-828-2506",
          CRFAXNO: "02-828-2058",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "148",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "11",
          CRCAPAT: "49",
          CRCHCNT: "13",
          LA: "37.51270278676103",
          LO: "126.93426117790129",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000731",
          CRNAME: "구립 엠밸리큰나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07795",
          CRADDR: "서울특별시 강서구 마곡중앙8로1길 10",
          CRTELNO: "02-3663-9599",
          CRFAXNO: "02-3662-9599",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "230",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "14",
          CRCAPAT: "70",
          CRCHCNT: "43",
          LA: "37.561844739744444",
          LO: "126.83610253425331",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 18.0,
          EM_CNT_1Y: 46.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000528",
          CRNAME: "구립아르테온보예어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05274",
          CRADDR: "서울특별시 강동구 고덕로 360 고덕아르테온아파트 319동 1층(상일동)",
          CRTELNO: "02-6925-5642",
          CRFAXNO: "02-6925-5641",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "350",
          PLGRDCO: "2",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "19",
          CRCAPAT: "85",
          CRCHCNT: "84",
          LA: "37.55543466754922",
          LO: "127.16833396270029",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 15.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 84.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 73.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000355",
          CRNAME: "KB구의 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04977",
          CRADDR: "서울특별시 광진구 광나루로 525 3층",
          CRTELNO: "02-6235-7977",
          CRFAXNO: "02-6235-7976",
          CRHOME: "https://www.puruni.com/kbguui",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "174",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "49",
          CRCHCNT: "29",
          LA: "37.545115339002464",
          LO: "127.08800276377305",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 3.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000436",
          CRNAME: "구립가온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06951",
          CRADDR: "서울특별시 동작구 상도로15가길 16",
          CRTELNO: "02-3280-0217",
          CRFAXNO: "02-3280-0218",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000436",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "200",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "11",
          CRCAPAT: "59",
          CRCHCNT: "38",
          LA: "37.50193920691273",
          LO: "126.93235369763712",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000442",
          CRNAME: "동고어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06762",
          CRADDR: "서울특별시 서초구 바우뫼로7길 29 105동 102호",
          CRTELNO: "02-6241-1852",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "86",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "15",
          CRCHCNT: "15",
          LA: "37.471062951837524",
          LO: "127.02334117505731",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000475",
          CRNAME: "늘봄보라매SK뷰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07391",
          CRADDR: "서울특별시 영등포구 여의대방로35가길 19",
          CRTELNO: "02-2135-7941",
          CRFAXNO: "02-832-7941",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "182",
          PLGRDCO: "2",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "13",
          CRCAPAT: "68",
          CRCHCNT: "67",
          LA: "37.50352258203092",
          LO: "126.91791287656861",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 67.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000205",
          CRNAME: "용산캐슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04317",
          CRADDR: "서울특별시 용산구 백범로 313 키즈클럽(효창동,롯데캐슬센터포레)",
          CRTELNO: "02-712-7942",
          CRFAXNO: "02-712-7943",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "171",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "10",
          CRCAPAT: "24",
          CRCHCNT: "24",
          LA: "37.53981745015118",
          LO: "126.96307358592341",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 13.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000338",
          CRNAME: "구립독산e편한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08603",
          CRADDR: "서울특별시 금천구 범안로 1212",
          CRTELNO: "02-892-0700",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "281",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "14",
          CRCAPAT: "65",
          CRCHCNT: "49",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 15.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 49.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 8.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000435",
          CRNAME: "구립꿈담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06969",
          CRADDR: "서울특별시 동작구 상도로47아길 44-1 2층",
          CRTELNO: "02-813-4246",
          CRFAXNO: "02-813-4247",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000435",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "103",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "9",
          CRCAPAT: "39",
          CRCHCNT: "27",
          LA: "37.50401952076813",
          LO: "126.95359401478522",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000794",
          CRNAME: "가락아이들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05832",
          CRADDR: "서울특별시 송파구 중대로12길 34 (가락동)",
          CRTELNO: "02-400-3188",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "220",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "15",
          CRCAPAT: "66",
          CRCHCNT: "47",
          LA: "37.491967848929264",
          LO: "127.12500998848313",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 19.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 39.0,
          EM_CNT_1Y: 23.0,
          EM_CNT_2Y: 39.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000632",
          CRNAME: "새빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08362",
          CRADDR: "서울특별시 구로구 연동로 233",
          CRTELNO: "02-2688-3688",
          CRFAXNO: "02-2689-3688",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "141",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "12",
          CRCAPAT: "44",
          CRCHCNT: "44",
          LA: "37.480522856569365",
          LO: "126.82079390945905",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 56.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000393",
          CRNAME: "구립 행당한신어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04746",
          CRADDR: "서울특별시 성동구 고산자로 164 관리동 2층(행당동, 행당한신)",
          CRTELNO: "02-2291-0079",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "106",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "9",
          CRCAPAT: "40",
          CRCHCNT: "29",
          LA: "37.55620480381817",
          LO: "127.03549435337253",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000631",
          CRNAME: "항동하랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08368",
          CRADDR: "서울특별시 구로구 항동로 42",
          CRTELNO: "02-2612-0081",
          CRFAXNO: "02-2612-0087",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "285",
          PLGRDCO: "3",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "11",
          CRCAPAT: "69",
          CRCHCNT: "69",
          LA: "37.47820771030077",
          LO: "126.82560717140872",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 69.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000795",
          CRNAME: "삼성아트어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05794",
          CRADDR: "서울특별시 송파구 문정로 83",
          CRTELNO: "02-401-7245",
          CRFAXNO: "02-401-7246",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "108",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "12",
          CRCAPAT: "40",
          CRCHCNT: "40",
          LA: "37.49032779381247",
          LO: "127.13144122066737",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 20.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000796",
          CRNAME: "파인13어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05813",
          CRADDR: "서울특별시 송파구 송파대로8길 10 (장지동, 송파파인타운13단지)",
          CRTELNO: "02-400-0609",
          CRFAXNO: "02-409-0609",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "22",
          CRCHCNT: "22",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 83.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000116",
          CRNAME: "아이다움어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04581",
          CRADDR: "서울특별시 중구 난계로 130 102동 102호",
          CRTELNO: "02-2233-7942",
          CRFAXNO: "",
          CRHOME: "cafe.naver.com/idaum2020",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "42",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "15",
          CRCHCNT: "15",
          LA: "37.56350229819328",
          LO: "127.02447778826442",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000793",
          CRNAME: "잠실올림픽아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05506",
          CRADDR: "서울특별시 송파구 올림픽로43길 34 관리동 1층(풍납동, 잠실올림픽공원아이파크)",
          CRTELNO: "02-473-8613",
          CRFAXNO: "02-473-8612",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "180",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "17",
          CRCAPAT: "66",
          CRCHCNT: "58",
          LA: "37.52526618777239",
          LO: "127.1144173868104",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 16.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000729",
          CRNAME: "구립 아이나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07711",
          CRADDR: "서울특별시 강서구 화곡로13가길 5",
          CRTELNO: "02-6949-1305",
          CRFAXNO: "02-6949-1304",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "130",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "13",
          CRCAPAT: "48",
          CRCHCNT: "43",
          LA: "37.54136831937572",
          LO: "126.83359296213726",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000730",
          CRNAME: "구립 하늘마음어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07724",
          CRADDR: "서울특별시 강서구 초록마을로 106",
          CRTELNO: "02-6959-7736",
          CRFAXNO: "070-8228-7400",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11500000730",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "154",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "17",
          CRCAPAT: "51",
          CRCHCNT: "41",
          LA: "37.538972939903324",
          LO: "126.85144177936739",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000666",
          CRNAME: "구립 가람슬기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03335",
          CRADDR: "서울특별시 은평구 연서로19길 28-1",
          CRTELNO: "02-353-2235",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "163",
          PLGRDCO: "3",
          CCTVINSTLCNT: "28",
          CHCRTESCNT: "15",
          CRCAPAT: "61",
          CRCHCNT: "53",
          LA: "37.61432294994962",
          LO: "126.91512107076598",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 18.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 53.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000479",
          CRNAME: "면목공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02232",
          CRADDR: "서울특별시 중랑구 동일로 591",
          CRTELNO: "02-439-6722",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "202",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2020-01-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000480",
          CRNAME: "중화공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02110",
          CRADDR: "서울특별시 중랑구 중랑역로3길 28",
          CRTELNO: "02-436-3681",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "100",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2020-01-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000486",
          CRNAME: "아이신나공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02243",
          CRADDR: "서울특별시 중랑구 면목로31길 60",
          CRTELNO: "02-436-1123",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "88",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2020-01-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000434",
          CRNAME: "구립도레미어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06909",
          CRADDR: "서울특별시 동작구 흑석로13길 25",
          CRTELNO: "02-813-2031",
          CRFAXNO: "02-813-2032",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000434",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "316",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "18",
          CRCAPAT: "95",
          CRCHCNT: "48",
          LA: "37.509884867504226",
          LO: "126.95916360932294",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2020-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 19.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 48.0,
          EM_CNT_0Y: 53.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000476",
          CRNAME: "마포구육아종합지원센터(모아뜰공동육아방)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03965",
          CRADDR: "서울특별시 마포구 성산로4길 15",
          CRTELNO: "02-3144-1733",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-12-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000643",
          CRNAME: "바람아래발도르프어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02721",
          CRADDR: "서울특별시 성북구 길음로9길 40 108동 101호",
          CRTELNO: "02-942-5090",
          CRFAXNO: "",
          CRHOME: "http://cafe.daum.net/baramarae",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "6",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.60572346309294",
          LO: "127.02124985032637",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000346",
          CRNAME: "금천구육아종합지원센터(독산점)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08584",
          CRADDR: "서울특별시 금천구 두산로 70 T동 L층 101호",
          CRTELNO: "02-2169-2057",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "145",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-12-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000347",
          CRNAME: "금천구육아종합지원센터(아이세상놀이터)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08584",
          CRADDR: "서울특별시 금천구 두산로 70 T동 1층 103호",
          CRTELNO: "02-894-2264",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "181",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-12-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000343",
          CRNAME: "서울 금천구육아종합지원센터",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08611",
          CRADDR: "서울특별시 금천구 시흥동 시흥대로73길 70 지하1층",
          CRTELNO: "02-894-2264",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "368",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-12-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000642",
          CRNAME: "키움누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02715",
          CRADDR: "서울특별시 성북구 서경로 60 길음뉴타운 11단지 롯데캐슬골든힐스 단지 내",
          CRTELNO: "02-943-1525",
          CRFAXNO: "02-943-1524",
          CRHOME: "http://cafe.daum.net/kiumnuri2020",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "137",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "11",
          CRCAPAT: "23",
          CRCHCNT: "22",
          LA: "37.60948702918029",
          LO: "127.01615019039325",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000523",
          CRNAME: "구립힐스아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05242",
          CRADDR: "서울특별시 강동구 올림픽로91길 30 관리동(구립힐스아이어린이집)",
          CRTELNO: "02-429-6351",
          CRFAXNO: "02-429-6352",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "116",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "12",
          CRCAPAT: "34",
          CRCHCNT: "33",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000525",
          CRNAME: "구립롯데캐슬베네루체어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05281",
          CRADDR: "서울특별시 강동구 구천면로 630 고덕롯데캐슬베네루체 관리동(구립롯데캐슬베네루체어린이집)",
          CRTELNO: "02-442-7675",
          CRFAXNO: "02-442-7674",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "276",
          PLGRDCO: "1",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "18",
          CRCAPAT: "91",
          CRCHCNT: "88",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 2.0,
          CHILD_CNT_TOT: 88.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 21.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000524",
          CRNAME: "구립센트럴아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05276",
          CRADDR: "서울특별시 강동구 고덕로80길 99 관리동(구립센트럴아이파크어린이집)",
          CRTELNO: "02-6013-0320",
          CRFAXNO: "02-6013-0320",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "285",
          PLGRDCO: "1",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "22",
          CRCAPAT: "95",
          CRCHCNT: "93",
          LA: "37.55200401645151",
          LO: "127.16682111172932",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 93.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 39.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 18.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 22.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000464",
          CRNAME: "우리들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02034",
          CRADDR: "서울특별시 중랑구 공릉로4길 18-13 (묵동)",
          CRTELNO: "02-973-0577",
          CRFAXNO: "02-973-0570",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "284",
          PLGRDCO: "2",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "10",
          CRCAPAT: "60",
          CRCHCNT: "42",
          LA: "37.612626285949325",
          LO: "127.07919418419396",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000337",
          CRNAME: "구립소나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08561",
          CRADDR: "서울특별시 금천구 독산로58나길 81",
          CRTELNO: "02-802-7902",
          CRFAXNO: "02-853-1902",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "290",
          PLGRDCO: "2",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "12",
          CRCAPAT: "79",
          CRCHCNT: "56",
          LA: "37.46656727368943",
          LO: "126.9066733997631",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 11.0,
          CHILD_CNT_05: 12.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000492",
          CRNAME: "데시앙어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02530",
          CRADDR: "서울특별시 동대문구 장한로27길 37 관리동(장안동, 더퍼스트데시앙아파트)",
          CRTELNO: "02-6053-6601",
          CRFAXNO: "02-6053-6602",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "163",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "10",
          CRCAPAT: "26",
          CRCHCNT: "26",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000342",
          CRNAME: "구립꿈의숲해링턴어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01155",
          CRADDR: "서울특별시 강북구 오현로 45 꿈의숲해링턴플레이스아파트 114동 (지하1층)",
          CRTELNO: "02-989-1467",
          CRFAXNO: "02-988-1467",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "131",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "14",
          CRCAPAT: "45",
          CRCHCNT: "42",
          LA: "37.61880824666077",
          LO: "127.03476235683237",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000665",
          CRNAME: "구립 숲속향기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03308",
          CRADDR: "서울특별시 은평구 연서로48길 12 510동 1층",
          CRTELNO: "02-384-4466",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "96",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "8",
          CRCAPAT: "36",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 4.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 100.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000370",
          CRNAME: "자람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03711",
          CRADDR: "서울특별시 서대문구 가재울미래로 2 DMC파크뷰자이 4단지 내 402동 1층",
          CRTELNO: "02-6954-1909",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.57181375855997",
          LO: "126.91455806735786",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000522",
          CRNAME: "베베키즈어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05224",
          CRADDR: "서울특별시 강동구 고덕로 333 112동 105호(고덕동, 고덕그라시움아파트)",
          CRTELNO: "02-428-1566",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.556900320472856",
          LO: "127.16076865241996",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000615",
          CRNAME: "두산로다어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08063",
          CRADDR: "서울특별시 양천구 신월로20길 7 신정뉴타운 두산위브 관리동",
          CRTELNO: "02-6408-0705",
          CRFAXNO: "02-6408-0702",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.519233548932185",
          LO: "126.84561572591212",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000664",
          CRNAME: "구립 가온누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03321",
          CRADDR: "서울특별시 은평구 갈현로31길 14-9",
          CRTELNO: "02-356-7713",
          CRFAXNO: "02-356-7716",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "93",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "35",
          CRCHCNT: "21",
          LA: "37.62044913902612",
          LO: "126.91438916706758",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000640",
          CRNAME: "하이키즈어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02760",
          CRADDR: "서울특별시 성북구 한천로 713 513동 102호 (래미안장위퍼스트하이)",
          CRTELNO: "02-942-1101",
          CRFAXNO: "02-942-1101",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "57",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.61871651628014",
          LO: "127.05154314350857",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000641",
          CRNAME: "초롱어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "02779",
          CRADDR: "서울특별시 성북구 한천로90길 49 1층",
          CRTELNO: "02-942-0130",
          CRFAXNO: "02-942-0130",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "0",
          CRCAPAT: "17",
          CRCHCNT: "0",
          LA: "37.61474361910828",
          LO: "127.03853212777156",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-11-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-07-31",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000663",
          CRNAME: "구립 움찬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03364",
          CRADDR: "서울특별시 은평구 불광로 64 불광 롯데캐슬",
          CRTELNO: "02-6959-9950",
          CRFAXNO: "02-6959-6885",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "96",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "36",
          CRCHCNT: "36",
          LA: "37.613344097129406",
          LO: "126.93429727340641",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 30.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000570",
          CRNAME: "아이랑 난향점",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08859",
          CRADDR: "서울특별시 관악구 난곡로9길 29-2 3층 아이랑 난향점",
          CRTELNO: "02-867-2856",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "101",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-10-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000662",
          CRNAME: "구립 한빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03468",
          CRADDR: "서울특별시 은평구 백련산로 67 (백련산파크자이)",
          CRTELNO: "02-2135-4662",
          CRFAXNO: "02-2135-4663",
          CRHOME: "키즈노트",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "109",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "10",
          CRCAPAT: "41",
          CRCHCNT: "30",
          LA: "37.59198290735191",
          LO: "126.92164577250592",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 63.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000384",
          CRNAME: "어울림어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05224",
          CRADDR: "서울특별시 강동구 고덕로 333 127동 104호(고덕그라시움)",
          CRTELNO: "02-481-0045",
          CRFAXNO: "0504-418-4574",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "48",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "17",
          CRCHCNT: "17",
          LA: "37.56100375",
          LO: "127.1716909",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:36.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000792",
          CRNAME: "더나은어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05792",
          CRADDR: "서울특별시 송파구 충민로 152 306동 104호(송파파인타운3단지)",
          CRTELNO: "02-3012-2334",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "69",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.483949373842286",
          LO: "127.13281792287571",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 38.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000440",
          CRNAME: "LG전자 서초어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06772",
          CRADDR: "서울특별시 서초구 양재대로11길 19 고객센터3층",
          CRTELNO: "02-503-4013",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "216",
          PLGRDCO: "1",
          CCTVINSTLCNT: "26",
          CHCRTESCNT: "20",
          CRCAPAT: "80",
          CRCHCNT: "49",
          LA: "37.46097319874313",
          LO: "127.03518084225241",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 3.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 15.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 49.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 19.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000462",
          CRNAME: "서일대학교부설어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02192",
          CRADDR: "서울특별시 중랑구 용마산로90길 28-5 (면목동)",
          CRTELNO: "02-492-3993",
          CRFAXNO: "02-433-7591",
          CRHOME: "",
          NRTRROOMCNT: "10",
          NRTRROOMSIZE: "439",
          PLGRDCO: "3",
          CCTVINSTLCNT: "22",
          CHCRTESCNT: "26",
          CRCAPAT: "162",
          CRCHCNT: "111",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 17.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 17.0,
          CHILD_CNT_03: 23.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 26.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 111.0,
          EM_CNT_0Y: 35.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 20.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 26.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000438",
          CRNAME: "서초구립 나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06768",
          CRADDR: "서울특별시 서초구 양재대로2길 33 지상1층",
          CRTELNO: "02-529-2019",
          CRFAXNO: "02-577-2019",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "93",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.45873020551138",
          LO: "127.02409745094296",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000336",
          CRNAME: "구립초록빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08622",
          CRADDR: "서울특별시 금천구 시흥대로68길 89",
          CRTELNO: "02-891-1381",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "232",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "7",
          CRCAPAT: "62",
          CRCHCNT: "20",
          LA: "37.45874281873249",
          LO: "126.90349998950887",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000461",
          CRNAME: "꿈터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02241",
          CRADDR: "서울특별시 중랑구 사가정로42길 90 두산아파트 관리동(면목동)",
          CRTELNO: "02-435-3382",
          CRFAXNO: "02-435-3382",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "100",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "30",
          CRCHCNT: "28",
          LA: "37.57794351988769",
          LO: "127.08119233936484",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 70.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 10.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000439",
          CRNAME: "서초구립 신반포리오센트어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06516",
          CRADDR: "서울특별시 서초구 잠원로14길 32",
          CRTELNO: "02-595-5532",
          CRFAXNO: "02-595-5538",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/community/newsLetterList.do?stCode=11650000439",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "195",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "14",
          CRCAPAT: "68",
          CRCHCNT: "48",
          LA: "37.51904534349191",
          LO: "127.013596826604",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 48.0,
          EM_CNT_0Y: 18.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 46.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000456",
          CRNAME: "마포한강아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04016",
          CRADDR: "서울특별시 마포구 희우정로 77 102동 1층",
          CRTELNO: "02-334-0000",
          CRFAXNO: "02-334-4200",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "8",
          CRCAPAT: "21",
          CRCHCNT: "21",
          LA: "37.55239281854454",
          LO: "126.90294650067713",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000455",
          CRNAME: "마포자이 더 센트리지어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04127",
          CRADDR: "서울특별시 마포구 숭문길 98 관리동 1층",
          CRTELNO: "02-714-0005",
          CRFAXNO: "02-714-0700",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "187",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "14",
          CRCAPAT: "65",
          CRCHCNT: "50",
          LA: "37.55051607378568",
          LO: "126.94898481298705",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 50.0,
          EM_CNT_0Y: 18.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 64.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000489",
          CRNAME: "도란도란공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02097",
          CRADDR: "서울특별시 중랑구 봉화산로30길 89",
          CRTELNO: "02-491-1123",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "67",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-09-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000661",
          CRNAME: "구립 매바위어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03466",
          CRADDR: "서울특별시 은평구 응암로30길 16 백련산SK뷰아이파크",
          CRTELNO: "02-6959-0097",
          CRFAXNO: "02-6959-0720",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "233",
          PLGRDCO: "2",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "20",
          CRCAPAT: "88",
          CRCHCNT: "87",
          LA: "37.59509103976381",
          LO: "126.92121222696346",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 8.0,
          CHILD_CNT_TOT: 87.0,
          EM_CNT_0Y: 47.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000728",
          CRNAME: "이화의료원어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07804",
          CRADDR: "서울특별시 강서구 공항대로 260 B관 4층",
          CRTELNO: "02-6986-5950",
          CRFAXNO: "02-6986-5955",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "92",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "15",
          LA: "37.557048658920614",
          LO: "126.83653320401757",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000639",
          CRNAME: "그린나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02760",
          CRADDR: "서울특별시 성북구 한천로 713 506동 1층",
          CRTELNO: "02-6949-1609",
          CRFAXNO: "02-6949-1608",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "125",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "45",
          CRCHCNT: "39",
          LA: "37.62005465275997",
          LO: "127.05115328162691",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000660",
          CRNAME: "구립 꿈터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03319",
          CRADDR: "서울특별시 은평구 갈현로33길 24 갈현동현대아파트",
          CRTELNO: "02-2135-5448",
          CRFAXNO: "02-2135-5449",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "148",
          PLGRDCO: "2",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "56",
          CRCHCNT: "34",
          LA: "37.622503083491914",
          LO: "126.9139676945806",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 34.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000491",
          CRNAME: "아름다운어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02605",
          CRADDR: "서울특별시 동대문구 황물로7길 21",
          CRTELNO: "02-2215-6363",
          CRFAXNO: "",
          CRHOME: "https://blog.naver.com/wedbew",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "49",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "5",
          CRCAPAT: "14",
          CRCHCNT: "9",
          LA: "37.568068056576095",
          LO: "127.05478797400337",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 9.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000460",
          CRNAME: "신사임당어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02076",
          CRADDR: "서울특별시 중랑구 신내로 51 104동 103호(신내동, 성원아파트)",
          CRTELNO: "02-494-2179",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "16",
          LA: "37.60473837321414",
          LO: "127.09418834457914",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000487",
          CRNAME: "지혜어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06327",
          CRADDR: "서울특별시 강남구 삼성로 11",
          CRTELNO: "02-576-0060",
          CRFAXNO: "02-579-0090",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "386",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "17",
          CRCAPAT: "88",
          CRCHCNT: "49",
          LA: "37.48444245417045",
          LO: "127.06622850372233",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 4.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 49.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 58.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000520",
          CRNAME: "구립그라시움별빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05224",
          CRADDR: "서울특별시 강동구 고덕로 333 140동 1층(고덕동, 고덕그라시움아파트)",
          CRTELNO: "02-3013-3375",
          CRFAXNO: "02-3013-3376",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "220",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "64",
          CRCHCNT: "58",
          LA: "37.55713261493213",
          LO: "127.16545179974162",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-08-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 42.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 58.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000521",
          CRNAME: "구립그라시움물빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05224",
          CRADDR: "서울특별시 강동구 고덕로 333 119동 1층(고덕동, 고덕그라시움아파트)",
          CRTELNO: "02-3427-0257",
          CRFAXNO: "02-3427-0258",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "320",
          PLGRDCO: "1",
          CCTVINSTLCNT: "34",
          CHCRTESCNT: "19",
          CRCAPAT: "94",
          CRCHCNT: "91",
          LA: "37.55789211431927",
          LO: "127.16354078882997",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-08-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 91.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000519",
          CRNAME: "구립그라시움은빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05224",
          CRADDR: "서울특별시 강동구 고덕로 333 113동 1층(고덕동, 고덕그라시움아파트)",
          CRTELNO: "02-2135-7268",
          CRFAXNO: "02-2135-7269",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "127",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "48",
          CRCHCNT: "36",
          LA: "37.55691240579364",
          LO: "127.16016318967632",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-08-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 3.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 9.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000727",
          CRNAME: "N젤어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07594",
          CRADDR: "서울특별시 강서구 마곡중앙로 177",
          CRTELNO: "02-6340-8131",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "98",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "27",
          LA: "37.56988037672422",
          LO: "126.82733211917669",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-08-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000459",
          CRNAME: "대상어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "02154",
          CRADDR: "서울특별시 중랑구 면목로 470 대상빌딩 내 1층(상봉동)",
          CRTELNO: "02-6406-9911",
          CRFAXNO: "02-6406-9915",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "212",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "0",
          CRCAPAT: "60",
          CRCHCNT: "0",
          LA: "37.59359871476893",
          LO: "127.08689354495931",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-08-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-12-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000726",
          CRNAME: "구립 아이편한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07560",
          CRADDR: "서울특별시 강서구 공항대로 583 염창동, e편한세상 염창아파트 관리동",
          CRTELNO: "02-2662-3401",
          CRFAXNO: "02-3663-3401",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "262",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "55",
          LA: "37.5493614806028",
          LO: "126.8706024735916",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-08-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 4.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 2.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000627",
          CRNAME: "햇살어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08219",
          CRADDR: "서울특별시 구로구 경인로47다길 34-7 우성꿈동산 아파트 우성상가(고척동)",
          CRTELNO: "02-2611-7618",
          CRFAXNO: "02-6737-7618",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "400",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "17",
          CRCAPAT: "94",
          CRCHCNT: "70",
          LA: "37.50344356243832",
          LO: "126.86599681274583",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-08-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 4.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 9.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 70.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 21.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000629",
          CRNAME: "늘사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08206",
          CRADDR: "서울특별시 구로구 구로중앙로40길 24",
          CRTELNO: "02-3667-1235",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "250",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "53",
          CRCHCNT: "53",
          LA: "37.506710798042974",
          LO: "126.87737162711771",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 2.0,
          CHILD_CNT_TOT: 53.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000628",
          CRNAME: "꽃망울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08368",
          CRADDR: "서울특별시 구로구 항동로 72 관리동(항동, 하버라인 4단지)",
          CRTELNO: "02-2618-1007",
          CRFAXNO: "02-2618-1008",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "261",
          PLGRDCO: "3",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "17",
          CRCAPAT: "55",
          CRCHCNT: "55",
          LA: "37.48108090833357",
          LO: "126.82644562479552",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000630",
          CRNAME: "자연숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08362",
          CRADDR: "서울특별시 구로구 연동로 234 관리동(항동, 하버라인 2단지)",
          CRTELNO: "02-2688-2611",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "269",
          PLGRDCO: "2",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "14",
          CRCAPAT: "77",
          CRCHCNT: "76",
          LA: "37.482223478892244",
          LO: "126.82226531586894",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 76.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000335",
          CRNAME: "꾸미어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08610",
          CRADDR: "서울특별시 금천구 시흥대로77길 23 시흥베르빌 아파트 101동 104호",
          CRTELNO: "02-6348-1108",
          CRFAXNO: "02-6348-1108",
          CRHOME: "http://cafe.naver.com/ggumilove",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.45760708234384",
          LO: "126.89759868120622",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000177",
          CRNAME: "선재어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03144",
          CRADDR: "서울특별시 종로구 우정국로 51-4",
          CRTELNO: "02-720-9770",
          CRFAXNO: "02-720-9771",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "274",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "20",
          CRCAPAT: "97",
          CRCHCNT: "61",
          LA: "37.57347189187701",
          LO: "126.98225014135957",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 61.0,
          EM_CNT_0Y: 53.0,
          EM_CNT_1Y: 12.0,
          EM_CNT_2Y: 35.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 17.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000659",
          CRNAME: "구립 솔찬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03437",
          CRADDR: "서울특별시 은평구 가좌로 334",
          CRTELNO: "02-2135-7477",
          CRFAXNO: "070-8224-7477",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "112",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "11",
          CRCAPAT: "42",
          CRCHCNT: "42",
          LA: "37.598398072147916",
          LO: "126.9092196296517",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 11.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000561",
          CRNAME: "구립e편한2단지어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08830",
          CRADDR: "서울특별시 관악구 청룡16길 43 서울대입구e편한세상2단지 206동 앞",
          CRTELNO: "02-883-0903",
          CRFAXNO: "02-883-0904",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "162",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "14",
          CRCAPAT: "59",
          CRCHCNT: "44",
          LA: "37.4763695670297",
          LO: "126.94268162236952",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000560",
          CRNAME: "구립e편한1단지어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08830",
          CRADDR: "서울특별시 관악구 청룡10길 45 서울대입구e편한세상1단지 105동 앞",
          CRTELNO: "02-883-8083",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "179",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "60",
          CRCHCNT: "45",
          LA: "37.478478043322",
          LO: "126.94291743202088",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 22.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000559",
          CRNAME: "구립신사어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08703",
          CRADDR: "서울특별시 관악구 관천로21길 16",
          CRTELNO: "02-857-7490",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "124",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "11",
          CRCAPAT: "46",
          CRCHCNT: "40",
          LA: "37.48779998876579",
          LO: "126.92117805374444",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000437",
          CRNAME: "서초구립 누리아미어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06609",
          CRADDR: "서울특별시 서초구 서운로26길 3 서초4동 열린문화센터 내",
          CRTELNO: "02-3477-1232",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "174",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "9",
          CRCAPAT: "65",
          CRCHCNT: "41",
          LA: "37.502690813280346",
          LO: "127.02217767046316",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 17.0,
          CHILD_CNT_04: 11.0,
          CHILD_CNT_05: 13.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000518",
          CRNAME: "구립래미안솔베뉴어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05266",
          CRADDR: "서울특별시 강동구 양재대로 1650 구립래미안솔베뉴어린이집",
          CRTELNO: "02-6925-0850",
          CRFAXNO: "02-6925-0851",
          CRHOME: "chungkids@hanmail.net",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "419",
          PLGRDCO: "2",
          CCTVINSTLCNT: "29",
          CHCRTESCNT: "19",
          CRCAPAT: "95",
          CRCHCNT: "86",
          LA: "37.55409039426842",
          LO: "127.14598528632066",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장,시간제보육",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 86.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000365",
          CRNAME: "은파어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "03617",
          CRADDR: "서울특별시 서대문구 간호대로 12-11 (홍제동)",
          CRTELNO: "02-395-1992",
          CRFAXNO: "02-395-1910",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "0",
          CRCAPAT: "32",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-03-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000490",
          CRNAME: "휘경SK뷰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02434",
          CRADDR: "서울특별시 동대문구 휘경로 60 휘경SK뷰아파트, 관리동",
          CRTELNO: "02-6949-3393",
          CRFAXNO: "02-6949-3394",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "110",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "29",
          LA: "37.5935220071109",
          LO: "127.06625145045373",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000725",
          CRNAME: "지니어스Bebe어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07595",
          CRADDR: "서울특별시 강서구 양천로30길 108 1동 112호",
          CRTELNO: "02-2664-5656",
          CRFAXNO: "02-2664-5657",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "0",
          CRCAPAT: "19",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-06-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-08-12",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000115",
          CRNAME: "신당하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04580",
          CRADDR: "서울특별시 중구 왕십리로 407 신당파인힐하나유보라 103동 1층",
          CRTELNO: "02-2256-7646",
          CRFAXNO: "02-2256-7647",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "136",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "13",
          CRCAPAT: "33",
          CRCHCNT: "30",
          LA: "37.564300664888684",
          LO: "127.02515009579787",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000626",
          CRNAME: "예크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08330",
          CRADDR: "서울특별시 구로구 개봉로20길 158 현대홈타운 2단지아파트 관리동 1층",
          CRTELNO: "070-4200-0713",
          CRFAXNO: "02-2616-0713",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "112",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "26",
          CRCHCNT: "26",
          LA: "37.49132211756044",
          LO: "126.86151520076234",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000114",
          CRNAME: "푸르지오비씨 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04548",
          CRADDR: "서울특별시 중구 을지로4가 을지로 170",
          CRTELNO: "02-2288-2761",
          CRFAXNO: "02-2288-2763",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "229",
          PLGRDCO: "1",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "18",
          CRCAPAT: "70",
          CRCHCNT: "37",
          LA: "37.56632830333276",
          LO: "126.99737682595429",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 7.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000637",
          CRNAME: "아름드리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02763",
          CRADDR: "서울특별시 성북구 장월로 160 래미안장위포레카운티 104동 1층",
          CRTELNO: "02-943-9933",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "119",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "45",
          CRCHCNT: "39",
          LA: "37.61821586408752",
          LO: "127.05290768234798",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 10.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000486",
          CRNAME: "강남구육아종합지원센터",
          CRTYPENAME: "법인·단체등",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "06269",
          CRADDR: "서울특별시 강남구 도곡로18길 57",
          CRTELNO: "02-000-0000",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "1",
          NRTRROOMSIZE: "1",
          PLGRDCO: "1",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-05-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-06-04",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000658",
          CRNAME: "구립 늘봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03373",
          CRADDR: "서울특별시 은평구 통일로 610 힐스테이트녹번 106동 1층",
          CRTELNO: "02-353-7554",
          CRFAXNO: "02-353-7555",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "147",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "14",
          CRCAPAT: "55",
          CRCHCNT: "39",
          LA: "37.6020647026523",
          LO: "126.9361077726464",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 19.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000113",
          CRNAME: "교원&하나투어 공동직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04539",
          CRADDR: "서울특별시 중구 을지로2가 을지로 55 교원명동빌딩 3층",
          CRTELNO: "02-779-6118",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "193",
          PLGRDCO: "1",
          CCTVINSTLCNT: "22",
          CHCRTESCNT: "10",
          CRCAPAT: "60",
          CRCHCNT: "16",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 2.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000657",
          CRNAME: "구립 향림어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03339",
          CRADDR: "서울특별시 은평구 연서로41가길 24-1",
          CRTELNO: "02-353-1966",
          CRFAXNO: "070-8233-3361",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "74",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "12",
          CRCAPAT: "27",
          CRCHCNT: "23",
          LA: "37.62672773600907",
          LO: "126.92580072326242",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 89.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000790",
          CRNAME: "사랑해어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "05742",
          CRADDR: "서울특별시 송파구 동남로24길 37 1층",
          CRTELNO: "02-2135-4591",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.50840957792124",
          LO: "127.13468219463394",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-04-15",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000436",
          CRNAME: "KCC직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06608",
          CRADDR: "서울특별시 서초구 사평대로 334-2 1층",
          CRTELNO: "02-3447-9280",
          CRFAXNO: "02-3447-9281",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "312",
          PLGRDCO: "0",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "13",
          CRCAPAT: "47",
          CRCHCNT: "24",
          LA: "37.5036911100922",
          LO: "127.02119403822182",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000613",
          CRNAME: "구립 봄샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08102",
          CRADDR: "서울특별시 양천구 목동남로4길 80 목동파크자이아파트",
          CRTELNO: "02-2651-1905",
          CRFAXNO: "02-2651-1906",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "258",
          PLGRDCO: "3",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "28",
          LA: "37.50981537764101",
          LO: "126.8695397269831",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000614",
          CRNAME: "구립 이든샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08049",
          CRADDR: "서울특별시 양천구 신정로7길 75 이든채아파트",
          CRTELNO: "02-6347-1817",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "316",
          PLGRDCO: "2",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "11",
          CRCAPAT: "45",
          CRCHCNT: "38",
          LA: "37.51282197738323",
          LO: "126.83492883622685",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000358",
          CRNAME: "예솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03670",
          CRADDR: "서울특별시 서대문구 증가로 150 DMC2차아이파크 아파트",
          CRTELNO: "02-3152-6579",
          CRFAXNO: "02-3152-6576",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "206",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "40",
          CRCHCNT: "34",
          LA: "37.57809368904639",
          LO: "126.92102636648754",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 34.0,
          EM_CNT_0Y: 70.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000655",
          CRNAME: "구립 맑은별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03427",
          CRADDR: "서울특별시 은평구 서오릉로21길 47 갈현이편한세상 103-104",
          CRTELNO: "02-357-7942",
          CRFAXNO: "02-357-7942",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.61178414724301",
          LO: "126.90585939948551",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000656",
          CRNAME: "구립 내숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03446",
          CRADDR: "서울특별시 은평구 은평터널로 121-6 이랜드타운아파트 101-102",
          CRTELNO: "02-302-1630",
          CRFAXNO: "02-305-1630",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "57",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.59048553038333",
          LO: "126.90404913544378",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000791",
          CRNAME: "헬리오마음어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 , 510동 앞(가락동, 헬리오시티)",
          CRTELNO: "02-400-7751",
          CRFAXNO: "02-400-7761",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "298",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "18",
          CRCAPAT: "77",
          CRCHCNT: "60",
          LA: "37.49982802246255",
          LO: "127.11028755527708",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 5.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 60.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000359",
          CRNAME: "키움어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "03695",
          CRADDR: "서울특별시 서대문구 홍제천로 136 연희파크푸르지오",
          CRTELNO: "02-336-2146",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "47",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-02-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000789",
          CRNAME: "사랑별어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 201동 102호(가락동, 헬리오시티)",
          CRTELNO: "070-8160-0000",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.496380082289356",
          LO: "127.10460848934971",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000625",
          CRNAME: "느티나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08368",
          CRADDR: "서울특별시 구로구 항동로 43 1층 관리동",
          CRTELNO: "02-2060-2010",
          CRFAXNO: "02-2060-2226",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "573",
          PLGRDCO: "2",
          CCTVINSTLCNT: "26",
          CHCRTESCNT: "21",
          CRCAPAT: "128",
          CRCHCNT: "115",
          LA: "37.47795481636066",
          LO: "126.82367732356282",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 30.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 32.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 115.0,
          EM_CNT_0Y: 77.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 6.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 17.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 22.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000485",
          CRNAME: "어린왕자어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06372",
          CRADDR: "서울특별시 강남구 자곡로7길 8-16",
          CRTELNO: "02-3412-0612",
          CRFAXNO: "02-3412-0613",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "207",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "15",
          CRCAPAT: "49",
          CRCHCNT: "48",
          LA: "37.47452983251421",
          LO: "127.10034426096374",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2019-04-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 8.0,
          CLASS_CNT_02: 7.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 12.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 34.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 48.0,
          EM_CNT_0Y: 91.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000484",
          CRNAME: "천사어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06284",
          CRADDR: "서울특별시 강남구 삼성로 212 17동 115호",
          CRTELNO: "02-576-4938",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.49794528650747",
          LO: "127.06186821987258",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2019-04-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000654",
          CRNAME: "자이안어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03306",
          CRADDR: "서울특별시 은평구 통일로 1034",
          CRTELNO: "02-6402-7007",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "142",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "13",
          CRCAPAT: "49",
          CRCHCNT: "41",
          LA: "37.6347777150706",
          LO: "126.91847395685036",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 5.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 20.0,
          CHILD_CNT_00: 11.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 20.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000473",
          CRNAME: "여의도 하나금융그룹 직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07327",
          CRADDR: "서울특별시 영등포구 여의나루로 53-1 3층",
          CRTELNO: "02-780-3220",
          CRFAXNO: "",
          CRHOME: "https://www.puruni.com/hanayu",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "220",
          PLGRDCO: "3",
          CCTVINSTLCNT: "31",
          CHCRTESCNT: "23",
          CRCAPAT: "70",
          CRCHCNT: "65",
          LA: "37.52297813694364",
          LO: "126.9256660309019",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 4.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 11.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 26.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 65.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 56.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 18.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 23.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000474",
          CRNAME: "신길햇살아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07394",
          CRADDR: "서울특별시 영등포구 가마산로 426",
          CRTELNO: "02-849-9501",
          CRFAXNO: "02-849-9502",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "157",
          PLGRDCO: "2",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "16",
          CRCAPAT: "57",
          CRCHCNT: "41",
          LA: "37.50465084078794",
          LO: "126.90552190861179",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 77.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 23.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000787",
          CRNAME: "오금물빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05738",
          CRADDR: "서울특별시 송파구 성내천로 103",
          CRTELNO: "02-406-4001",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "100",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "28",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000610",
          CRNAME: "구립 기자촌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03309",
          CRADDR: "서울특별시 은평구 연서로46길 7 1105동 1층",
          CRTELNO: "02-389-6878",
          CRFAXNO: "02-389-6879",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "220",
          PLGRDCO: "0",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "10",
          CRCAPAT: "40",
          CRCHCNT: "29",
          LA: "37.63402236170676",
          LO: "126.9333798128",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000623",
          CRNAME: "푸르지오아이숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08240",
          CRADDR: "서울특별시 구로구 중앙로 121 고척파크푸르지오 관리동",
          CRTELNO: "02-2613-9280",
          CRFAXNO: "02-2617-9280",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "101",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "23",
          CRCHCNT: "22",
          LA: "37.50769407914164",
          LO: "126.85736383934905",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000624",
          CRNAME: "꿈나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08325",
          CRADDR: "서울특별시 구로구 구일로4길 46 204동 105호(구로동,현대연예인아파트)",
          CRTELNO: "02-838-3934",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "14",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 83.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000364",
          CRNAME: "키움어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03695",
          CRADDR: "서울특별시 서대문구 홍제천로 136 103동 1층(연희동, 연희파크푸르지오)",
          CRTELNO: "02-336-2146",
          CRFAXNO: "02-336-2147",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "45",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "17",
          CRCHCNT: "17",
          LA: "37.57580542913849",
          LO: "126.92851157655656",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000652",
          CRNAME: "은평성모병원어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03312",
          CRADDR: "서울특별시 은평구 통일로 1021 별관2층",
          CRTELNO: "02-2030-4988",
          CRFAXNO: "0504-228-4498",
          CRHOME: "https://moamom115.kiznet.co.kr",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "140",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "9",
          CRCAPAT: "30",
          CRCHCNT: "22",
          LA: "37.63385636226329",
          LO: "126.91514417462281",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000636",
          CRNAME: "가온누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02727",
          CRADDR: "서울특별시 성북구 숭인로 50 122동 1층",
          CRTELNO: "02-988-5100",
          CRFAXNO: "02-988-9500",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "249",
          PLGRDCO: "1",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "20",
          CRCAPAT: "88",
          CRCHCNT: "66",
          LA: "37.61088179080211",
          LO: "127.02605767479385",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 19.0,
          EM_CNT_2Y: 19.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000392",
          CRNAME: "구립 해온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04768",
          CRADDR: "서울특별시 성동구 성수동1가 왕십리로5길 3",
          CRTELNO: "02-462-6738",
          CRFAXNO: "02-462-6739",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "69",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "26",
          CRCHCNT: "23",
          LA: "37.54632010842336",
          LO: "127.04435854597291",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000724",
          CRNAME: "EMS어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07590",
          CRADDR: "서울특별시 강서구 화곡로63길 65 예원교회 교육관 1층",
          CRTELNO: "02-6342-8291",
          CRFAXNO: "02-6342-8297",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "225",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "49",
          CRCHCNT: "0",
          LA: "37.55807576929031",
          LO: "126.84920822402068",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-04-30",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000786",
          CRNAME: "헬리오사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 , 201동 앞(가락동, 헬리오시티)",
          CRTELNO: "02-400-2021",
          CRFAXNO: "02-400-2081",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "119",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "12",
          CRCAPAT: "36",
          CRCHCNT: "36",
          LA: "37.496505851772284",
          LO: "127.10502707670071",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000785",
          CRNAME: "헬리오바른어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 , 515동 앞(가락동, 헬리오시티)",
          CRTELNO: "02-401-7715",
          CRFAXNO: "02-430-775",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.497931226902025",
          LO: "127.10804282683526",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000461",
          CRNAME: "서리풀노리학교",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06636",
          CRADDR: "서울특별시 서초구 사임당로 115 1층",
          CRTELNO: "02-525-9340",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "236",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-03-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000357",
          CRNAME: "가재울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03711",
          CRADDR: "서울특별시 서대문구 모래내로15길 31",
          CRTELNO: "02-304-7002",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "581",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "18",
          CRCAPAT: "72",
          CRCHCNT: "70",
          LA: "37.57306548510788",
          LO: "126.92005249654745",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 70.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 39.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 2.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000653",
          CRNAME: "구립 은뜨락어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03311",
          CRADDR: "서울특별시 은평구 통일로 972",
          CRTELNO: "02-388-7676",
          CRFAXNO: "02-385-7676",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "14",
          CRCAPAT: "49",
          CRCHCNT: "41",
          LA: "37.629769323721916",
          LO: "126.92006543110939",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 46.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000788",
          CRNAME: "거여리본타운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05744",
          CRADDR: "서울특별시 송파구 오금로53길 14",
          CRTELNO: "02-402-1900",
          CRFAXNO: "02-402-1909",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "217",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "14",
          CRCAPAT: "33",
          CRCHCNT: "32",
          LA: "37.495644574044164",
          LO: "127.14237718017723",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000784",
          CRNAME: "가나안어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 514동 103호(가락동, 헬리오시티)",
          CRTELNO: "02-579-4300",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.49871229105391",
          LO: "127.10865179815423",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-03-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000783",
          CRNAME: "동화숲어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 406동 104호(가락동, 헬리오시티)",
          CRTELNO: "02-3402-2010",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49765917263695",
          LO: "127.10994228031516",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000782",
          CRNAME: "헬리오어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 206동 103호(가락동, 헬리오시티)",
          CRTELNO: "02-409-0320",
          CRFAXNO: "02-409-0320",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49658346276946",
          LO: "127.10639833396952",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000723",
          CRNAME: "아장닷컴어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07678",
          CRADDR: "서울특별시 강서구 화곡로42나길 30-17",
          CRTELNO: "02-2602-8554",
          CRFAXNO: "02-2602-3999",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "78",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "6",
          CRCAPAT: "18",
          CRCHCNT: "15",
          LA: "37.54948316623522",
          LO: "126.8479637546559",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000332",
          CRNAME: "구립해맑은어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08625",
          CRADDR: "서울특별시 금천구 독산로35길 15-6 한백아트 101호",
          CRTELNO: "02-803-1227",
          CRFAXNO: "02-803-1226",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "14",
          LA: "37.45946229336071",
          LO: "126.90746353981825",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 80.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000333",
          CRNAME: "구립번동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01059",
          CRADDR: "서울특별시 강북구 한천로124나길 34",
          CRTELNO: "02-902-1889",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "224",
          PLGRDCO: "4",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "18",
          CRCAPAT: "81",
          CRCHCNT: "80",
          LA: "37.63836965525972",
          LO: "127.0312082147032",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 18.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 80.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 47.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000354",
          CRNAME: "구립 사랑모아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05118",
          CRADDR: "서울특별시 광진구 광나루로56길 32 구의현대아파트 202동 103호",
          CRTELNO: "02-457-0348",
          CRFAXNO: "02-457-0348",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "14",
          LA: "37.539567049782164",
          LO: "127.09711607733155",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000336",
          CRNAME: "구립킨더어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01213",
          CRADDR: "서울특별시 강북구 숭인로 39 관리동 1층(미아동,송천센트레빌아파트)",
          CRTELNO: "02-6015-2345",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "74",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "28",
          CRCHCNT: "27",
          LA: "37.61266803875207",
          LO: "127.02588840802184",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000485",
          CRNAME: "아이뜰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02533",
          CRADDR: "서울특별시 동대문구 사가정로 190 13동 101호(전농동,전농우성아파트)",
          CRTELNO: "02-2215-6395",
          CRFAXNO: "02-2216-6395",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "78",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.576696256850155",
          LO: "127.06572711566107",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000488",
          CRNAME: "아이랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02429",
          CRADDR: "서울특별시 동대문구 한천로55길 9 102동 109호(이문동,이문동삼익아파트)",
          CRTELNO: "02-960-0057",
          CRFAXNO: "02-960-0087",
          CRHOME: "cafe.naver.com/airang2012",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "78",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.596066513459924",
          LO: "127.0676521564817",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000340",
          CRNAME: "구립무지개어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01198",
          CRADDR: "서울특별시 강북구 삼양로19길 113 101동 101호(미아동, 삼각산아이원아파트)",
          CRTELNO: "02-6228-7326",
          CRFAXNO: "02-6228-7326",
          CRHOME: "https://cafe.naver.com/rainbowchildren1",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "105",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "14",
          LA: "37.616136097786764",
          LO: "127.01774583712048",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 12.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000486",
          CRNAME: "예닮어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02588",
          CRADDR: "서울특별시 동대문구 무학로26길 30 1동 103호(용두동,신동아아파트)",
          CRTELNO: "02-6462-2842",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "78",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.573096094093415",
          LO: "127.0320313717531",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000489",
          CRNAME: "이화어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02639",
          CRADDR: "서울특별시 동대문구 장한로26다길 38",
          CRTELNO: "02-2212-6717",
          CRFAXNO: "02-2212-6782",
          CRHOME: "ew22@hanmail.net",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "199",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "8",
          CRCAPAT: "49",
          CRCHCNT: "17",
          LA: "37.56422030975272",
          LO: "127.06865900497166",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000487",
          CRNAME: "자연어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02535",
          CRADDR: "서울특별시 동대문구 한천로37길 33 104동 104호(답십리동,래미안엘파인아파트)",
          CRTELNO: "02-2213-1566",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.57585882087399",
          LO: "127.06484338665497",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000555",
          CRNAME: "구립희아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08734",
          CRADDR: "서울특별시 관악구 관악로30길 27 관악푸르지오아파트 122-101",
          CRTELNO: "02-886-0801",
          CRFAXNO: "02-886-0801",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "127",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.486292325718445",
          LO: "126.96006969928243",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000335",
          CRNAME: "구립숲사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01164",
          CRADDR: "서울특별시 강북구 도봉로22길 7",
          CRTELNO: "02-985-3465",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "89",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "10",
          CRCAPAT: "32",
          CRCHCNT: "29",
          LA: "37.619018971870084",
          LO: "127.03024016436663",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000332",
          CRNAME: "구립아이땅어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01192",
          CRADDR: "서울특별시 강북구 솔샘로 174 140동 101호(미아동, 에스케이북한산시티아파트)",
          CRTELNO: "02-984-0339",
          CRFAXNO: "02-984-0338",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "138",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.61600987070112",
          LO: "127.01832629067566",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000545",
          CRNAME: "창5동아이조아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01402",
          CRADDR: "서울특별시 도봉구 해등로 118 2동 110호",
          CRTELNO: "02-906-1732",
          CRFAXNO: "02-906-1732",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "49",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 7.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000541",
          CRNAME: "방학1동고은뜰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01337",
          CRADDR: "서울특별시 도봉구 마들로 616 203동 102호",
          CRTELNO: "02-954-3138",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.66510712321263",
          LO: "127.04877571629804",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 9.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 19.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000558",
          CRNAME: "구립드림타운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08862",
          CRADDR: "서울특별시 관악구 난곡로 55 관악산휴먼시아아파트 224-103",
          CRTELNO: "02-838-7974",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "114",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.458422013451894",
          LO: "126.92036684764333",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 100.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000535",
          CRNAME: "은행나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01383",
          CRADDR: "서울특별시 도봉구 방학로 187 관리동 1층",
          CRTELNO: "02-956-9568",
          CRFAXNO: "02-956-9568",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "23",
          CRCHCNT: "22",
          LA: "37.66089852187132",
          LO: "127.03202230935469",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 9.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001040",
          CRNAME: "작은별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01873",
          CRADDR: "서울특별시 노원구 덕릉로60길 252 101동 106호(월계동, 유원A)",
          CRTELNO: "02-995-5622",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "87",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "4",
          CRCAPAT: "19",
          CRCHCNT: "8",
          LA: "37.62958057569413",
          LO: "127.04504238382162",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 8.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 2.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 4.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001049",
          CRNAME: "꼬꼬마어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01816",
          CRADDR: "서울특별시 노원구 공릉로46길 32 107동 111호(공릉동, 삼익A)",
          CRTELNO: "02-6229-3165",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "18",
          LA: "37.62730524511294",
          LO: "127.08302453387013",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000350",
          CRNAME: "구립 물고기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05090",
          CRADDR: "서울특별시 광진구 뚝섬로34길 25-19 1006동 102호",
          CRTELNO: "070-8278-4030",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.5334410708222",
          LO: "127.07057678793771",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000610",
          CRNAME: "구립 벽산한마음어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07929",
          CRADDR: "서울특별시 양천구 월정로9길 20 양천벽산블루밍2단지 203동 106호",
          CRTELNO: "02-6347-3434",
          CRFAXNO: "02-6347-3434",
          CRHOME: "cafe.naver.com/love203106",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "62",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.52508063712373",
          LO: "126.8385671558495",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000353",
          CRNAME: "구립 하늘땅별땅어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04995",
          CRADDR: "서울특별시 광진구 동일로56길 15 (군자동)",
          CRTELNO: "02-498-3062",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "267",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "47",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001046",
          CRNAME: "보람자연어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01678",
          CRADDR: "서울특별시 노원구 한글비석로 479 102동 109호(상계동, 보람A)",
          CRTELNO: "02-933-7070",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.66353369781386",
          LO: "127.0652652554297",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 100.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000458",
          CRNAME: "아이숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02077",
          CRADDR: "서울특별시 중랑구 봉화산로48길 62 104동 105호(상봉동,건영아파트)",
          CRTELNO: "02-432-2890",
          CRFAXNO: "02-433-2890",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.60405492371118",
          LO: "127.09537091314166",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000337",
          CRNAME: "구립반짝반짝어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01197",
          CRADDR: "서울특별시 강북구 삼양로27길 95 301동 103호(미아동,두산위브아파트)",
          CRTELNO: "02-6338-4003",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "15",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 1.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000341",
          CRNAME: "구립어린왕자어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01059",
          CRADDR: "서울특별시 강북구 한천로124나길 10 101동 108호(번동,번동쌍용아파트)",
          CRTELNO: "02-906-1123",
          CRFAXNO: "02-906-1123",
          CRHOME: "https://blog.naver.com/cij3782a",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.637903069482206",
          LO: "127.03241747897145",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000553",
          CRNAME: "구립아이봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08751",
          CRADDR: "서울특별시 관악구 은천로 86 두산아파트 208-101",
          CRTELNO: "02-883-2081",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.48660631178124",
          LO: "126.94539312166282",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000538",
          CRNAME: "산들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01474",
          CRADDR: "서울특별시 도봉구 덕릉로62길 30",
          CRTELNO: "02-903-2978",
          CRFAXNO: "02-900-2977",
          CRHOME: "http://blog.naver.com/sdsd2978",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "148",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "10",
          CRCAPAT: "56",
          CRCHCNT: "37",
          LA: "37.64004230293288",
          LO: "127.04153635104042",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000546",
          CRNAME: "도봉2동다솜어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01318",
          CRADDR: "서울특별시 도봉구 마들로 859-19 124동 101호",
          CRTELNO: "02-955-0207",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "56",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.68667967260148",
          LO: "127.0466584379822",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000651",
          CRNAME: "구립 푸름어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03406",
          CRADDR: "서울특별시 은평구 진흥로1길 35-1",
          CRTELNO: "02-355-5008",
          CRFAXNO: "02-383-5007",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "297",
          PLGRDCO: "3",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "18",
          CRCAPAT: "80",
          CRCHCNT: "72",
          LA: "37.60356617363206",
          LO: "126.91818103191347",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 10.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 72.0,
          EM_CNT_0Y: 53.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000544",
          CRNAME: "창3동신도아이숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01481",
          CRADDR: "서울특별시 도봉구 우이천로4라길 11-14 102동 107호",
          CRTELNO: "02-998-9598",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "18",
          CRCHCNT: "17",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001043",
          CRNAME: "엄마사랑i어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01913",
          CRADDR: "서울특별시 노원구 마들로 31 103동 102호(월계동, 그랑빌A)",
          CRTELNO: "02-949-9077",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "80",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.6166756986729",
          LO: "127.06929619256614",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001048",
          CRNAME: "파랑새어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01690",
          CRADDR: "서울특별시 노원구 동일로 1456 710동 102호(상계동, 주공7단지A)",
          CRTELNO: "02-932-0333",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "44",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "15",
          CRCHCNT: "13",
          LA: "37.65903334553403",
          LO: "127.06096326033898",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000360",
          CRNAME: "꼬마박사어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03690",
          CRADDR: "서울특별시 서대문구 거북골로 120 203동 103호",
          CRTELNO: "02-309-8557",
          CRFAXNO: "02-309-8557",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.575970242561375",
          LO: "126.91545612339281",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000338",
          CRNAME: "구립두산위브어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01197",
          CRADDR: "서울특별시 강북구 삼양로27길 95 214동 103호(미아동, 두산위브아파트)",
          CRTELNO: "02-982-6804",
          CRFAXNO: "02-982-6804",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "17",
          CRCHCNT: "10",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000334",
          CRNAME: "구립튼튼어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01192",
          CRADDR: "서울특별시 강북구 솔샘로 174 116동 101호(미아동, SK북한산시티아파트)",
          CRTELNO: "02-945-9127",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "111",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001045",
          CRNAME: "꿈의숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01850",
          CRADDR: "서울특별시 노원구 섬밭로 139 105동 103호(공릉동, 풍림A)",
          CRTELNO: "02-978-1189",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "78",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.629245880842454",
          LO: "127.0668495740783",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000432",
          CRNAME: "구립롯데키즈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07064",
          CRADDR: "서울특별시 동작구 여의대방로10길 38 보라매롯데낙천대아파트 관리동 1층",
          CRTELNO: "02-847-5333",
          CRFAXNO: "02-847-5336",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "102",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.49354682098126",
          LO: "126.91404657006154",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000622",
          CRNAME: "해오름어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08289",
          CRADDR: "서울특별시 구로구 공원로6가길 67 3동 102호(구로동,구로우성아파트)",
          CRTELNO: "02-857-5110",
          CRFAXNO: "02-857-5110",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.50479460408028",
          LO: "126.88948742780278",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000621",
          CRNAME: "한진예닮어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08354",
          CRADDR: "서울특별시 구로구 개봉로3길 87 101동 101호(개봉동,한진타운아파트)",
          CRTELNO: "02-2613-3990",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.485614922222624",
          LO: "126.85097085309893",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001035",
          CRNAME: "행복이가득한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01660",
          CRADDR: "서울특별시 노원구 한글비석로24바길 17 (상계동)",
          CRTELNO: "02-951-7775",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "210",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "12",
          CRCAPAT: "45",
          CRCHCNT: "36",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 10.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 80.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001041",
          CRNAME: "현대아이들세상어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01901",
          CRADDR: "서울특별시 노원구 석계로 49 105동 102호(월계동, 현대A)",
          CRTELNO: "02-943-1565",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.61915737107874",
          LO: "127.06219647679447",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000649",
          CRNAME: "구립 베라힐즈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03372",
          CRADDR: "서울특별시 은평구 통일로 630 녹번래미안베라힐즈 단지내 어린이집",
          CRTELNO: "02-356-9987",
          CRFAXNO: "02-356-9986",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "257",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "17",
          CRCAPAT: "81",
          CRCHCNT: "75",
          LA: "37.60287327818018",
          LO: "126.93599100485313",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 15.0,
          CHILD_CNT_05: 18.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 75.0,
          EM_CNT_0Y: 54.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000650",
          CRNAME: "구립 산새소리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03425",
          CRADDR: "서울특별시 은평구 서오릉로17길 10-5 (구립 산새소리어린이집, 구산동)",
          CRTELNO: "02-356-9501",
          CRFAXNO: "02-356-9502",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "346",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "23",
          CRCAPAT: "98",
          CRCHCNT: "98",
          LA: "37.614115031926126",
          LO: "126.90818116723929",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 20.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 9.0,
          CHILD_CNT_TOT: 98.0,
          EM_CNT_0Y: 47.0,
          EM_CNT_1Y: 16.0,
          EM_CNT_2Y: 37.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 19.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 23.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000620",
          CRNAME: "우방어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08323",
          CRADDR: "서울특별시 구로구 구일로 154-17 101동 101호",
          CRTELNO: "02-858-0506",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.49799974015833",
          LO: "126.8746633148037",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000456",
          CRNAME: "이수어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02020",
          CRADDR: "서울특별시 중랑구 공릉로18길 59 105동107호(묵동,브라운스톤태릉아파트)",
          CRTELNO: "02-949-8915",
          CRFAXNO: "02-6213-3562",
          CRHOME: "http://cafe.naver.com/ilove724",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.61884820766656",
          LO: "127.08162191578563",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000619",
          CRNAME: "해가람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08201",
          CRADDR: "서울특별시 구로구 신도림로21길 25 301동 106호",
          CRTELNO: "02-2675-8330",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.513042936556815",
          LO: "126.8844023175487",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001050",
          CRNAME: "벧엘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01777",
          CRADDR: "서울특별시 노원구 동일로207길 18 119동 102호(중계동, 중계그린A)",
          CRTELNO: "02-971-5768",
          CRFAXNO: "02-971-5768",
          CRHOME: "http://iseoul.seoul.go.kr/portal/mainCall.do",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "46",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "15",
          CRCHCNT: "13",
          LA: "37.64080781171658",
          LO: "127.06267906303186",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000537",
          CRNAME: "다울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01330",
          CRADDR: "서울특별시 도봉구 마들로 672-26",
          CRTELNO: "02-3493-9674",
          CRFAXNO: "02-3493-9676",
          CRHOME: "https://cafe.daum.net/dawool9674",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "218",
          PLGRDCO: "3",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "76",
          CRCHCNT: "52",
          LA: "37.67319635003093",
          LO: "127.04710906954476",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 21.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 52.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 30.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000547",
          CRNAME: "도봉2동리틀포도나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01318",
          CRADDR: "서울특별시 도봉구 마들로 835 202동 102호",
          CRTELNO: "02-955-0040",
          CRFAXNO: "02-955-0040",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "48",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.684436660408764",
          LO: "127.05107559140145",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000361",
          CRNAME: "우리들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03612",
          CRADDR: "서울특별시 서대문구 세검정로1길 95 벽산아파트 107동 106호",
          CRTELNO: "02-379-7955",
          CRFAXNO: "",
          CRHOME: "우리들어린이집",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "18",
          LA: "37.596410453651636",
          LO: "126.94392584698723",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000542",
          CRNAME: "방학1동행복한천사어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01339",
          CRADDR: "서울특별시 도봉구 도당로 116 101동 102호",
          CRTELNO: "02-955-1951",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "134",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.66627051938155",
          LO: "127.03976016851841",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000543",
          CRNAME: "방학3동해니크레오어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01359",
          CRADDR: "서울특별시 도봉구 시루봉로 166 102동 104호",
          CRTELNO: "02-3493-1192",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "56",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "9",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 9.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000457",
          CRNAME: "우남어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02068",
          CRADDR: "서울특별시 중랑구 봉화산로56길 51 101동 101호(신내동,우남푸르미아아파트)",
          CRTELNO: "02-3422-5790",
          CRFAXNO: "02-3422-5792",
          CRHOME: "http://club.cyworld.com/woonam2012",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "88",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.60600409382302",
          LO: "127.09853448866775",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000540",
          CRNAME: "방학3동맑은샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01364",
          CRADDR: "서울특별시 도봉구 해등로 312-10",
          CRTELNO: "02-955-5528",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "132",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "47",
          CRCHCNT: "47",
          LA: "37.6576765160441",
          LO: "127.02152530376514",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 13.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000433",
          CRNAME: "구립바르니어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07005",
          CRADDR: "서울특별시 동작구 사당로17길 52 대림아파트 3-106",
          CRTELNO: "02-582-4701",
          CRFAXNO: "02-591-4701",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "51",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "16",
          LA: "37.485152015991446",
          LO: "126.9743846177337",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000536",
          CRNAME: "학마을어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01342",
          CRADDR: "서울특별시 도봉구 도봉로145길 95",
          CRTELNO: "02-954-3700",
          CRFAXNO: "02-954-7201",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "355",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "19",
          CRCAPAT: "99",
          CRCHCNT: "92",
          LA: "37.665235177208736",
          LO: "127.03735681170187",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 92.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 19.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000352",
          CRNAME: "구립 행복마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05107",
          CRADDR: "서울특별시 광진구 뚝섬로56가길 10 (자양2동 현대3차 301-105)",
          CRTELNO: "02-455-0516",
          CRFAXNO: "02-455-0516",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "90",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.52788128219277",
          LO: "127.08359159082292",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000539",
          CRNAME: "새나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01456",
          CRADDR: "서울특별시 도봉구 도봉로110바길 38",
          CRTELNO: "02-906-3334",
          CRFAXNO: "02-906-3335",
          CRHOME: "http://cafe.daum.net/saenakids",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "177",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "9",
          CRCAPAT: "41",
          CRCHCNT: "26",
          LA: "37.64805458051474",
          LO: "127.03733828994602",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000351",
          CRNAME: "구립 봄빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05086",
          CRADDR: "서울특별시 광진구 능동로 19 101동 103호(자양동,한강현대아파트)",
          CRTELNO: "02-467-4720",
          CRFAXNO: "0504-259-8035",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "83",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.533281139784364",
          LO: "127.06670725489302",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 11.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000349",
          CRNAME: "구립 베베아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04983",
          CRADDR: "서울특별시 광진구 아차산로 549 1008동 101호(광장동,현대파크빌)",
          CRTELNO: "02-455-1279",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "13",
          LA: "37.54390211580885",
          LO: "127.10098597306256",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 80.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001051",
          CRNAME: "공릉한보어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01813",
          CRADDR: "서울특별시 노원구 공릉로46길 19 102동 102호(공릉동, 한보에센시티A)",
          CRTELNO: "02-977-4659",
          CRFAXNO: "02-6228-4659",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "15",
          LA: "37.62802608912253",
          LO: "127.07967781453789",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001038",
          CRNAME: "솔바람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01703",
          CRADDR: "서울특별시 노원구 노원로 428 209동 104호(상계동, 상계2차중앙하이츠A)",
          CRTELNO: "02-933-3601",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "2",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.654597928533896",
          LO: "127.06776613594987",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000339",
          CRNAME: "구립꿈의숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01223",
          CRADDR: "서울특별시 강북구 오현로 180 101동 102호(번동, 한솔솔파크아파트)",
          CRTELNO: "02-981-2265",
          CRFAXNO: "",
          CRHOME: "http://cafe.daum.net/dreamforest2019",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "59",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.62746549432675",
          LO: "127.03874260273399",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000713",
          CRNAME: "구립 해뜰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07581",
          CRADDR: "서울특별시 강서구 강서로68길 36 등촌주공2단지아파트 근로복지관2층",
          CRTELNO: "02-3663-0218",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "94",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "13",
          CRCAPAT: "35",
          CRCHCNT: "31",
          LA: "37.56481146996662",
          LO: "126.84287879025352",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 7.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000718",
          CRNAME: "구립 한빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07783",
          CRADDR: "서울특별시 강서구 강서로8길 134",
          CRTELNO: "02-2697-6711",
          CRFAXNO: "02-2603-2012",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "566",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "28",
          CRCAPAT: "132",
          CRCHCNT: "104",
          LA: "37.53041401189942",
          LO: "126.8555344600512",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 4.0,
          CLASS_CNT_TOT: 16.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 23.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 18.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 12.0,
          CHILD_CNT_TOT: 104.0,
          EM_CNT_0Y: 52.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 26.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 22.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 28.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000721",
          CRNAME: "구립 피노키오어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07754",
          CRADDR: "서울특별시 강서구 강서로12길 73",
          CRTELNO: "02-2605-7829",
          CRFAXNO: "02-2606-7829",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "217",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "48",
          CRCHCNT: "26",
          LA: "37.532280345385246",
          LO: "126.85110998328876",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000722",
          CRNAME: "구립 푸른솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07703",
          CRADDR: "서울특별시 강서구 화곡로13길 107 104동 104호(화곡동,화곡푸르지오)",
          CRTELNO: "02-6342-0042",
          CRFAXNO: "02-6342-0042",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.542409762233746",
          LO: "126.83097680108957",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000484",
          CRNAME: "파크자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02616",
          CRADDR: "서울특별시 동대문구 답십리로56길 105 관리동(답십리동,파크자이아파트)",
          CRTELNO: "02-3394-7987",
          CRFAXNO: "02-3394-7984",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "99",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000719",
          CRNAME: "구립 청솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07638",
          CRADDR: "서울특별시 강서구 강서로47마길 71 107호",
          CRTELNO: "02-2606-7045",
          CRFAXNO: "02-2664-7046",
          CRHOME: "https://m.cafe.daum.net/cjdthfdjflsdlwlq/_rec",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "15",
          LA: "37.55009750005462",
          LO: "126.8325380961783",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000714",
          CRNAME: "구립 진로어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07587",
          CRADDR: "서울특별시 강서구 공항대로 351-21 102동 102호",
          CRTELNO: "02-2658-4979",
          CRFAXNO: "",
          CRHOME: "http//cafe.daum.net/jinro4979",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.559491797384794",
          LO: "126.84684558045977",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000715",
          CRNAME: "구립 엔젤아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07534",
          CRADDR: "서울특별시 강서구 양천로 507 106동 104호",
          CRTELNO: "02-6341-7373",
          CRFAXNO: "02-6341-7373",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "47",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.5608201869347",
          LO: "126.85716500387973",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000720",
          CRNAME: "구립 샛별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07730",
          CRADDR: "서울특별시 강서구 초록마을로 166",
          CRTELNO: "02-2606-5070",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "106",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.53619105162722",
          LO: "126.84612386589839",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000557",
          CRNAME: "구립건강한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08726",
          CRADDR: "서울특별시 관악구 관악로 285 성현동아아파트 107-103",
          CRTELNO: "02-6080-8058",
          CRFAXNO: "050-4473-1879",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.48966437593508",
          LO: "126.95395625310532",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000717",
          CRNAME: "구립 뜰아래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07535",
          CRADDR: "서울특별시 강서구 양천로67가길 49 201동 105호",
          CRTELNO: "02-3664-5637",
          CRFAXNO: "",
          CRHOME: "http://cafe.daum.net/i.mypepe.com",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.55398924414275",
          LO: "126.87061569217074",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000552",
          CRNAME: "구립별이랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08793",
          CRADDR: "서울특별시 관악구 낙성대역길 19 동원낙성대아파트 101-106",
          CRTELNO: "02-888-2829",
          CRFAXNO: "0504-052-8736",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.476336877025425",
          LO: "126.96219758452501",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000618",
          CRNAME: "하늘샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08332",
          CRADDR: "서울특별시 구로구 개봉로18길 17",
          CRTELNO: "02-2615-8825",
          CRFAXNO: "02-6405-8825",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "223",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "13",
          CRCAPAT: "52",
          CRCHCNT: "43",
          LA: "37.4914214862983",
          LO: "126.85700467453276",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000712",
          CRNAME: "구립 강변어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07525",
          CRADDR: "서울특별시 강서구 허준로 139",
          CRTELNO: "02-2659-9046",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "160",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "57",
          CRCHCNT: "45",
          LA: "37.564846074407356",
          LO: "126.85587829901267",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000716",
          CRNAME: "구립 가온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07552",
          CRADDR: "서울특별시 강서구 양천로 590 102동 102호",
          CRTELNO: "02-2658-0179",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.55576515081284",
          LO: "126.86442909043235",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000333",
          CRNAME: "구립별마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08553",
          CRADDR: "서울특별시 금천구 독산로94길 17",
          CRTELNO: "02-830-8992",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "579",
          PLGRDCO: "2",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "14",
          CRCAPAT: "90",
          CRCHCNT: "56",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 2.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000334",
          CRNAME: "구립캐슬아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08608",
          CRADDR: "서울특별시 금천구 벚꽃로 30 금천 롯데캐슬 골드파크 2차 관리동어린이집",
          CRTELNO: "02-804-7999",
          CRFAXNO: "02-804-7998",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "14",
          CRCAPAT: "49",
          CRCHCNT: "43",
          LA: "37.458238948519984",
          LO: "126.8938057753381",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 18.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 46.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001042",
          CRNAME: "동원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01867",
          CRADDR: "서울특별시 노원구 월계로53길 21 101동 101호(월계동, 동원베네스트A)",
          CRTELNO: "02-902-1222",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.63173599059128",
          LO: "127.05833955749992",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001047",
          CRNAME: "색종이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01618",
          CRADDR: "서울특별시 노원구 동일로227길 86 1603동 103호(상계동, 주공16단지A)",
          CRTELNO: "02-937-7949",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "52",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.66731557298456",
          LO: "127.05160790283082",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000554",
          CRNAME: "구립꼬꼬마어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08847",
          CRADDR: "서울특별시 관악구 호암로 399 삼성산주공아파트 306-101",
          CRTELNO: "02-6335-2677",
          CRFAXNO: "02-6335-2677",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "128",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.46290449709944",
          LO: "126.92727693068157",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001036",
          CRNAME: "우림해피어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01630",
          CRADDR: "서울특별시 노원구 동일로230가길 71 102동 103호(상계동, 우림루미아트A)",
          CRTELNO: "02-938-9706",
          CRFAXNO: "02-6224-9706",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "2",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.67428704481354",
          LO: "127.05622905609135",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 16.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 100.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001037",
          CRNAME: "자람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01601",
          CRADDR: "서울특별시 노원구 누원로 18 402동 103호(상계동, 수락리버시티4단지A)",
          CRTELNO: "02-930-3441",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "83",
          PLGRDCO: "3",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001039",
          CRNAME: "청구몬테소리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01775",
          CRADDR: "서울특별시 노원구 동일로207길 186 110동 103호(하계동, 학여울청구A)",
          CRTELNO: "02-949-2961",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "145",
          PLGRDCO: "2",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.635672517883854",
          LO: "127.0620742861473",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000556",
          CRNAME: "구립햇님몬테소리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08734",
          CRADDR: "서울특별시 관악구 관악로30길 27 관악푸르지오아파트 120-103",
          CRTELNO: "02-883-9277",
          CRFAXNO: "02-883-9277",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.48654872347646",
          LO: "126.95893321600682",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000648",
          CRNAME: "구립 다원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03325",
          CRADDR: "서울특별시 은평구 갈현로19길 16 다원어린이집",
          CRTELNO: "02-353-4477",
          CRFAXNO: "02-353-4499",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "506",
          PLGRDCO: "2",
          CCTVINSTLCNT: "31",
          CHCRTESCNT: "19",
          CRCAPAT: "98",
          CRCHCNT: "94",
          LA: "37.61549700769471",
          LO: "126.91123618747848",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 22.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 27.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 94.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000612",
          CRNAME: "구립 청마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08105",
          CRADDR: "서울특별시 양천구 목동남로2길 60-30 세양청마루아파트 106동 103호",
          CRTELNO: "02-2061-6540",
          CRFAXNO: "02-2643-6540",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000611",
          CRNAME: "구립 엄마품어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07943",
          CRADDR: "서울특별시 양천구 오목로35길 5 보람쉬움아파트 1동 105호",
          CRTELNO: "02-2690-7223",
          CRFAXNO: "02-2693-7223",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "18",
          LA: "37.52553069773496",
          LO: "126.85562589517293",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001044",
          CRNAME: "이레뜰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01841",
          CRADDR: "서울특별시 노원구 동일로192나길 26 101동 105호(공릉동, 신원A)",
          CRTELNO: "02-973-3533",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "52",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.62779039084191",
          LO: "127.07500464194687",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000435",
          CRNAME: "서초구립 방배아트자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06706",
          CRADDR: "서울특별시 서초구 명달로9길 57 관리동",
          CRTELNO: "02-522-7600",
          CRFAXNO: "02-522-3341",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "185",
          PLGRDCO: "2",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "14",
          CRCAPAT: "48",
          CRCHCNT: "40",
          LA: "37.480196972564876",
          LO: "127.0021424826466",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 55.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000433",
          CRNAME: "서초구립 삼호3차가온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06552",
          CRADDR: "서울특별시 서초구 방배로45길 2 13동 104호",
          CRTELNO: "070-7576-2425",
          CRFAXNO: "070-7543-2188",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49779971372075",
          LO: "126.98697245789695",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000363",
          CRNAME: "해피키즈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03625",
          CRADDR: "서울특별시 서대문구 문화촌길 6-24 101동 112호(홍제동, 문화촌현대아파트)",
          CRTELNO: "02-6371-1005",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.593003924797664",
          LO: "126.94969040466232",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000362",
          CRNAME: "햇살나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03648",
          CRADDR: "서울특별시 서대문구 연희로 377 202동 104호",
          CRTELNO: "02-396-0397",
          CRFAXNO: "0504-273-0397",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "47",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "17",
          CRCHCNT: "17",
          LA: "37.589451183416905",
          LO: "126.93677526039377",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000467",
          CRNAME: "나이스 가온 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07238",
          CRADDR: "서울특별시 영등포구 국회대로74길 19 1~2층",
          CRTELNO: "02-780-9370",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "196",
          PLGRDCO: "1",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "12",
          CRCAPAT: "62",
          CRCHCNT: "26",
          LA: "37.5291163217201",
          LO: "126.9189822330403",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000455",
          CRNAME: "너나들이어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02263",
          CRADDR: "서울특별시 중랑구 신내역로1길 145 102호(신내동,신내소행주)",
          CRTELNO: "070-7743-7772",
          CRFAXNO: "02-3421-7772",
          CRHOME: "https://cafe.naver.com/youieveryone",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "8",
          CRCAPAT: "26",
          CRCHCNT: "16",
          LA: "37.61810390526847",
          LO: "127.11050449828782",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 1.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 60.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000483",
          CRNAME: "한빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06362",
          CRADDR: "서울특별시 강남구 광평로34길 35 강남더샵포레스트 관리동",
          CRTELNO: "02-3411-0972",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "149",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "13",
          CRCAPAT: "35",
          CRCHCNT: "30",
          LA: "37.48130973460847",
          LO: "127.09512988994692",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 09:13:36.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000112",
          CRNAME: "명동하나금융그룹직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04538",
          CRADDR: "서울특별시 중구 을지로2가 을지로 66 하나금융그룹 명동사옥 2층",
          CRTELNO: "02-319-9606",
          CRFAXNO: "02-319-9609",
          CRHOME: "https://www.puruni.com/hanajg",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "213",
          PLGRDCO: "2",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "16",
          CRCAPAT: "65",
          CRCHCNT: "33",
          LA: "37.56555479225988",
          LO: "126.98513267110088",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 5.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000489",
          CRNAME: "맘든든센터 공동육아방 2호점",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07244",
          CRADDR: "서울특별시 영등포구 국회대로44길 4 1층",
          CRTELNO: "02-833-6022",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-02-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000482",
          CRNAME: "선혜어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06326",
          CRADDR: "서울특별시 강남구 선릉로 8 레미안블레스티지 관리동",
          CRTELNO: "02-2057-7004",
          CRFAXNO: "02-2057-6003",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "359",
          PLGRDCO: "1",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "20",
          CRCAPAT: "112",
          CRCHCNT: "82",
          LA: "37.481853977463814",
          LO: "127.06270432995576",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 20.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 82.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 53.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000781",
          CRNAME: "쌍용아이사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05705",
          CRADDR: "서울특별시 송파구 송이로15길 31 (가락동, 가락2차쌍용아파트)",
          CRTELNO: "02-430-8387",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "95",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.502125293963274",
          LO: "127.12203844528815",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 88.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000780",
          CRNAME: "거여초원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05788",
          CRADDR: "서울특별시 송파구 양산로4길 16 관리동 1층(거여동, 거여5단지)",
          CRTELNO: "02-402-2190",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "74",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "9",
          CRCAPAT: "28",
          CRCHCNT: "27",
          LA: "37.48908136891396",
          LO: "127.14555903658841",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000454",
          CRNAME: "우리에프아이에스어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03921",
          CRADDR: "서울특별시 마포구 월드컵북로60길 17 3층",
          CRTELNO: "02-302-6393",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "119",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "12",
          CRCAPAT: "39",
          CRCHCNT: "25",
          LA: "37.58332245771427",
          LO: "126.88610518266371",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 30.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000635",
          CRNAME: "도담어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07798",
          CRADDR: "서울특별시 강서구 마곡서1로 100 607-104(마곡동,마곡엠벨리6단지)",
          CRTELNO: "070-4233-1225",
          CRFAXNO: "070-4203-1225",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "76",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.56575310518382",
          LO: "126.8196221692863",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 33.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000453",
          CRNAME: "서울서부지방법원 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04118",
          CRADDR: "서울특별시 마포구 마포대로 199 4층",
          CRTELNO: "02-3271-9270",
          CRFAXNO: "02-3271-9277",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "294",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "23",
          LA: "37.551990465884096",
          LO: "126.95484450211702",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 2.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000635",
          CRNAME: "루나밸리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02794",
          CRADDR: "서울특별시 성북구 월곡로14길 26 관리동",
          CRTELNO: "02-913-7475",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.60023176612429",
          LO: "127.04264662038756",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 11.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000632",
          CRNAME: "꿈의숲코오롱하늘채어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02757",
          CRADDR: "서울특별시 성북구 돌곶이로 220",
          CRTELNO: "02-909-2700",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "246",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "17",
          CRCAPAT: "93",
          CRCHCNT: "86",
          LA: "37.61962998938885",
          LO: "127.04585051229348",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 29.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 86.0,
          EM_CNT_0Y: 7.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 64.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000391",
          CRNAME: "구립 성수롯데캐슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04794",
          CRADDR: "서울특별시 성동구 성수동2가 성수일로8길 47 관리동 (성수동2가, 성수동 롯데캐슬파크)",
          CRTELNO: "02-499-1177",
          CRFAXNO: "02-468-8846",
          CRHOME: "kidsnote",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.54624562624995",
          LO: "127.05538023082863",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000517",
          CRNAME: "구립꽃다비어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05332",
          CRADDR: "서울특별시 강동구 성안로31마길 9 (천호동)",
          CRTELNO: "02-473-0513",
          CRFAXNO: "02-477-0513",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "170",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "16",
          CRCAPAT: "44",
          CRCHCNT: "41",
          LA: "37.54024378595751",
          LO: "127.1340760910537",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 15.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 86.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 7.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000471",
          CRNAME: "큰나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07295",
          CRADDR: "서울특별시 영등포구 문래동3가 문래로20길 14 2동 103호(문래공원한신아파트)",
          CRTELNO: "02-6335-2903",
          CRFAXNO: "02-6335-2903",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.517339971017584",
          LO: "126.8931734699443",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000469",
          CRNAME: "아이존어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07264",
          CRADDR: "서울특별시 영등포구 당산동2가 당산로 95 105동 103호(현대아파트)",
          CRTELNO: "02-833-1446",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5238645625056",
          LO: "126.89465742522928",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-07-20",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000470",
          CRNAME: "자연어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07283",
          CRADDR: "서울특별시 영등포구 문래동6가 문래로4길 14 101동 104호(현대아파트)",
          CRTELNO: "02-2679-0671",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.5197178439263",
          LO: "126.88285359835161",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 7.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000472",
          CRNAME: "별이달이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07423",
          CRADDR: "서울특별시 영등포구 대림로22길 29 102동 103호(갑을명가아파트)",
          CRTELNO: "02-846-6549",
          CRFAXNO: "070-8210-6549",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "17",
          LA: "37.49590977344244",
          LO: "126.90389603893587",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 100.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000468",
          CRNAME: "아이숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07295",
          CRADDR: "서울특별시 영등포구 문래동3가 문래로 94-7 101동 107호(문래건영아파트)",
          CRTELNO: "02-6104-7912",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "46",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.51761021017889",
          LO: "126.89310521502723",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000434",
          CRNAME: "BSP어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06598",
          CRADDR: "서울특별시 서초구 고무래로 89 반포써밋푸르지오 아파트 단지 내",
          CRTELNO: "02-532-0800",
          CRFAXNO: "02-532-0801",
          CRHOME: "",
          NRTRROOMCNT: "11",
          NRTRROOMSIZE: "375",
          PLGRDCO: "2",
          CCTVINSTLCNT: "22",
          CHCRTESCNT: "20",
          CRCAPAT: "142",
          CRCHCNT: "72",
          LA: "37.500718225637115",
          LO: "127.01861472989183",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 8.0,
          CLASS_CNT_02: 5.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 34.0,
          CHILD_CNT_02: 26.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 72.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 31.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000776",
          CRNAME: "오금숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05661",
          CRADDR: "서울특별시 송파구 중대로27길 2",
          CRTELNO: "02-430-4399",
          CRFAXNO: "02-430-4390",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "500",
          PLGRDCO: "3",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "25",
          CRCAPAT: "122",
          CRCHCNT: "106",
          LA: "37.50353744971693",
          LO: "127.12856914610928",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 30.0,
          CHILD_CNT_04: 27.0,
          CHILD_CNT_05: 18.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 106.0,
          EM_CNT_0Y: 47.0,
          EM_CNT_1Y: 16.0,
          EM_CNT_2Y: 37.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 19.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 2.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 26.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000331",
          CRNAME: "롯데가온어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08608",
          CRADDR: "서울특별시 금천구 시흥대로 291",
          CRTELNO: "02-805-2176",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "11",
          NRTRROOMSIZE: "412",
          PLGRDCO: "3",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "31",
          CRCAPAT: "156",
          CRCHCNT: "156",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 7.0,
          CLASS_CNT_02: 8.0,
          CLASS_CNT_03: 3.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 22.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 42.0,
          CHILD_CNT_03: 40.0,
          CHILD_CNT_04: 34.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 156.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 28.0,
          EM_CNT_2Y: 28.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 25.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 32.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000778",
          CRNAME: "파인3어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05792",
          CRADDR: "서울특별시 송파구 충민로 152 관리동 1층(장지동, 송파파인타운3단지)",
          CRTELNO: "02-403-1218",
          CRFAXNO: "02-403-1218",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "24",
          CRCHCNT: "24",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000617",
          CRNAME: "항동라온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08368",
          CRADDR: "서울특별시 구로구 서해안로 2036 803동 1층",
          CRTELNO: "02-2066-5700",
          CRFAXNO: "02-2066-2800",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "150",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "8",
          CRCAPAT: "42",
          CRCHCNT: "27",
          LA: "37.47461172436583",
          LO: "126.81751258150562",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000774",
          CRNAME: "헬리오라온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 ,414동 앞(가락동,헬리오시티)",
          CRTELNO: "02-430-4030",
          CRFAXNO: "02-430-4031",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "230",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "18",
          CRCAPAT: "78",
          CRCHCNT: "78",
          LA: "37.497172313802736",
          LO: "127.11028082247331",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 13.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 78.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000771",
          CRNAME: "베르디움어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05730",
          CRADDR: "서울특별시 송파구 동남로 342 101동 1층",
          CRTELNO: "02-408-2280",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "113",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 75.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000773",
          CRNAME: "헬리오다올어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 306동 앞(가락동,헬리오시티)",
          CRTELNO: "02-400-2120",
          CRFAXNO: "02-400-2130",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "230",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "14",
          CRCAPAT: "77",
          CRCHCNT: "58",
          LA: "37.498365243345084",
          LO: "127.10635279993462",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 9.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000775",
          CRNAME: "헬리오나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 , 209동 뒤(가락동,헬리오시티)",
          CRTELNO: "02-403-6909",
          CRFAXNO: "02-403-6910",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "230",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "15",
          CRCAPAT: "77",
          CRCHCNT: "77",
          LA: "37.49192574725414",
          LO: "127.11314527393183",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 77.0,
          EM_CNT_0Y: 42.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000772",
          CRNAME: "헬리오가람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 송파대로 345 , 103동 앞(가락동,헬리오시티)",
          CRTELNO: "02-402-5005",
          CRFAXNO: "02-402-6699",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "230",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "17",
          CRCAPAT: "78",
          CRCHCNT: "68",
          LA: "37.497179192903324",
          LO: "127.10264757373055",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 10.0,
          CHILD_CNT_05: 10.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 68.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000634",
          CRNAME: "아트리치어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02786",
          CRADDR: "서울특별시 성북구 돌곶이로8길 22 1층 2층",
          CRTELNO: "02-964-1964",
          CRFAXNO: "0504-092-1966",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "384",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "21",
          CRCAPAT: "107",
          CRCHCNT: "98",
          LA: "37.61078974903606",
          LO: "127.05713257592346",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 17.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 15.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 98.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 31.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000633",
          CRNAME: "새봄빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02727",
          CRADDR: "서울특별시 성북구 숭인로 50 112동 1층",
          CRTELNO: "02-945-2800",
          CRFAXNO: "02-945-2900",
          CRHOME: "https://nbombit.kidsnote.ac/home/main",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "191",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "62",
          LA: "37.611343187580104",
          LO: "127.02764061638258",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 58.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000466",
          CRNAME: "문래동제2어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07285",
          CRADDR: "서울특별시 영등포구 문래동5가 선유로5길 8",
          CRTELNO: "02-2069-4911",
          CRFAXNO: "02-2069-0911",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "235",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "18",
          CRCAPAT: "85",
          CRCHCNT: "77",
          LA: "37.51640668306202",
          LO: "126.88751342856407",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 77.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 21.0,
          EM_CNT_2Y: 7.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000777",
          CRNAME: "방이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05633",
          CRADDR: "서울특별시 송파구 오금로23길 27",
          CRTELNO: "02-412-0008",
          CRFAXNO: "070-7720-0000",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "220",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "18",
          CRCAPAT: "57",
          CRCHCNT: "55",
          LA: "37.51090635620651",
          LO: "127.1168187599302",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000478",
          CRNAME: "소담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06344",
          CRADDR: "서울특별시 강남구 개포로110길 50",
          CRTELNO: "02-445-1601",
          CRFAXNO: "02-445-6104",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "132",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "17",
          CRCAPAT: "45",
          CRCHCNT: "40",
          LA: "37.48962616392031",
          LO: "127.07974259094635",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 16.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 62.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 39.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000430",
          CRNAME: "구립이솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06973",
          CRADDR: "서울특별시 동작구 서달로 123",
          CRTELNO: "02-815-0492",
          CRFAXNO: "02-815-0493",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "149",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "10",
          CRCAPAT: "43",
          CRCHCNT: "28",
          LA: "37.504286433804665",
          LO: "126.95970527890138",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000480",
          CRNAME: "초롱어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06094",
          CRADDR: "서울특별시 강남구 삼성로 629",
          CRTELNO: "02-517-7550",
          CRFAXNO: "02-518-7551",
          CRHOME: "http://gncare.go.kr/chorong",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "128",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "35",
          CRCHCNT: "31",
          LA: "37.51528672416402",
          LO: "127.05150020352869",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000427",
          CRNAME: "구립솔빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "",
          ZIPCODE: "06928",
          CRADDR: "서울특별시 동작구 장승배기로 161",
          CRTELNO: "02-9378-8055",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "79",
          PLGRDCO: "1",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000429",
          CRNAME: "구립노블어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06919",
          CRADDR: "서울특별시 동작구 만양로 6 e편한세상상도노빌리티 관리동",
          CRTELNO: "02-812-0668",
          CRFAXNO: "02-812-0669",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000429",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "291",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "24",
          CRCAPAT: "95",
          CRCHCNT: "88",
          LA: "37.50497881302003",
          LO: "126.94754555251973",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 20.0,
          CHILD_CNT_04: 11.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 88.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 19.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 24.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000428",
          CRNAME: "구립강마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06909",
          CRADDR: "서울특별시 동작구 현충로 52 흑석아크로리버하임 아파트",
          CRTELNO: "02-814-3200",
          CRFAXNO: "02-814-3202",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "238",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "10",
          CRCAPAT: "69",
          CRCHCNT: "30",
          LA: "37.5102189012405",
          LO: "126.96112579961141",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000606",
          CRNAME: "구립 목2동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07973",
          CRADDR: "서울특별시 양천구 목동중앙본로 104-1",
          CRTELNO: "02-6741-1002",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "212",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "19",
          CRCAPAT: "77",
          CRCHCNT: "71",
          LA: "37.5449245291",
          LO: "126.8710276937",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 14.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 71.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 2.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000431",
          CRNAME: "구립꿈마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06909",
          CRADDR: "서울특별시 동작구 현충로 52 흑석아크로리버하임 아파트 관리동",
          CRTELNO: "02-6277-6990",
          CRFAXNO: "02-6277-6992",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000431",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "153",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "30",
          CRCHCNT: "19",
          LA: "37.5108177277938",
          LO: "126.96010188035075",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000479",
          CRNAME: "현대오토에버 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06171",
          CRADDR: "서울특별시 강남구 테헤란로113길 12",
          CRTELNO: "02-6200-4055",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "73",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "9",
          LA: "37.50926015037279",
          LO: "127.0671609078589",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 9.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 09:13:36.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000481",
          CRNAME: "해솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06366",
          CRADDR: "서울특별시 강남구 헌릉로590길 88",
          CRTELNO: "02-3411-6227",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "81",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "26",
          CRCHCNT: "24",
          LA: "37.46248212676547",
          LO: "127.10174107180047",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:13:36.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000647",
          CRNAME: "연세어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "03303",
          CRADDR: "서울특별시 은평구 진관4로 48-8 상림마을 716동 1층",
          CRTELNO: "02-383-9696",
          CRFAXNO: "02-383-9696",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "0",
          CRCAPAT: "23",
          CRCHCNT: "0",
          LA: "37.6439560659",
          LO: "126.9282129023",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2019-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-03-30",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 2.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000465",
          CRNAME: "늘해랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07208",
          CRADDR: "서울특별시 영등포구 양평동4가 선유로47길 30 (양평동)",
          CRTELNO: "02-2069-2780",
          CRFAXNO: "02-2069-2781",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "225",
          PLGRDCO: "2",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "17",
          CRCAPAT: "85",
          CRCHCNT: "77",
          LA: "37.5363197924",
          LO: "126.8944226699",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 77.0,
          EM_CNT_0Y: 23.0,
          EM_CNT_1Y: 23.0,
          EM_CNT_2Y: 54.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000779",
          CRNAME: "리버빌꿈마을어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05532",
          CRADDR: "서울특별시 송파구 토성로 37",
          CRTELNO: "02-474-1411",
          CRFAXNO: "02-474-1417",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "95",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "34",
          CRCHCNT: "25",
          LA: "37.53135281326427",
          LO: "127.1163528394377",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 18.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000616",
          CRNAME: "하늘빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08228",
          CRADDR: "서울특별시 구로구 고척로52나길 25 1층 어린이집",
          CRTELNO: "02-2685-1324",
          CRFAXNO: "02-2686-1324",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "180",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "11",
          CRCAPAT: "49",
          CRCHCNT: "43",
          LA: "37.5051277907",
          LO: "126.8573616533",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000711",
          CRNAME: "근로복지공단 강서어린이집",
          CRTYPENAME: "법인·단체등",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07707",
          CRADDR: "서울특별시 강서구 강서로33가길 42",
          CRTELNO: "02-2690-2600",
          CRFAXNO: "02-2690-2605",
          CRHOME: "https://www.comwel.or.kr/kids-gangseo/index.jsp",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "441",
          PLGRDCO: "1",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "26",
          CRCAPAT: "114",
          CRCHCNT: "92",
          LA: "37.543554695075244",
          LO: "126.8378766869164",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 6.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 18.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 60.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 92.0,
          EM_CNT_0Y: 32.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 58.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 19.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 26.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000464",
          CRNAME: "문래힐스테이트어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07295",
          CRADDR: "서울특별시 영등포구 문래동3가 문래로 82 문래동 힐스테이트 관리동",
          CRTELNO: "02-2633-2233",
          CRFAXNO: "02-2633-2235",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "121",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "13",
          CRCAPAT: "45",
          CRCHCNT: "42",
          LA: "37.5191940837",
          LO: "126.8910351489",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 10.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 80.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000615",
          CRNAME: "해봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08366",
          CRADDR: "서울특별시 구로구 금오로 882 어린이집",
          CRTELNO: "02-2689-7879",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "148",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "9",
          CRCAPAT: "30",
          CRCHCNT: "22",
          LA: "37.4760025474",
          LO: "126.8423176204",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000551",
          CRNAME: "구립난곡어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08858",
          CRADDR: "서울특별시 관악구 난곡로31길 14",
          CRTELNO: "02-838-3766",
          CRFAXNO: "02-838-3765",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "10",
          CRCAPAT: "49",
          CRCHCNT: "46",
          LA: "37.47129650988322",
          LO: "126.91896272159776",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 46.0,
          EM_CNT_0Y: 88.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000608",
          CRNAME: "구립 신트리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08078",
          CRADDR: "서울특별시 양천구 신정로 293 신트리1단지아파트 관리동",
          CRTELNO: "02-2065-1400",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "90",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "34",
          CRCHCNT: "26",
          LA: "37.5143116016",
          LO: "126.8550412342",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000348",
          CRNAME: "구립 미래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04984",
          CRADDR: "서울특별시 광진구 아차산로 503-23 104동 113호(광장동, 청구아파트)",
          CRTELNO: "02-447-4191",
          CRFAXNO: "02-447-4192",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "91",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5431614673",
          LO: "127.0956067292",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 75.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000607",
          CRNAME: "구립 꿈동산어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08109",
          CRADDR: "서울특별시 양천구 신정로14길 6 학마을1단지아파트 관리동",
          CRTELNO: "02-2060-6637",
          CRFAXNO: "02-2682-6637",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11470000607",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "27",
          CRCHCNT: "25",
          LA: "37.5085352598",
          LO: "126.8444117317",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000609",
          CRNAME: "구립 그린나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08110",
          CRADDR: "서울특별시 양천구 신정로 170 신정현대아파트 관리동",
          CRTELNO: "02-2060-5783",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "131",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "12",
          CRCAPAT: "35",
          CRCHCNT: "32",
          LA: "37.5086478889",
          LO: "126.8423756519",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000330",
          CRNAME: "구립슬기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08597",
          CRADDR: "서울특별시 금천구 한내로 69-54 1402동 101호(독산동, 주공14단지아파트)",
          CRTELNO: "02-805-2004",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "76",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4602164251",
          LO: "126.8858129147",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000454",
          CRNAME: "다솜어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02071",
          CRADDR: "서울특별시 중랑구 봉화산로56길 145-1 5동 103호(신내동, 중앙하이츠아파트)",
          CRTELNO: "02-6212-0330",
          CRFAXNO: "02-6212-0330",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.601923138",
          LO: "127.0970815687",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000453",
          CRNAME: "예슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02084",
          CRADDR: "서울특별시 중랑구 신내로7나길 24 212동 102호(상봉동, 건영2차아파트)",
          CRTELNO: "02-434-6563",
          CRFAXNO: "02-434-6563",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "109",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.6013571562",
          LO: "127.0928002543",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000605",
          CRNAME: "구립 보금자리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07940",
          CRADDR: "서울특별시 양천구 오목로29길 25 101-102",
          CRTELNO: "02-2608-3614",
          CRFAXNO: "02-2608-3614",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.5268698348",
          LO: "126.853632225",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000770",
          CRNAME: "가락1동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05698",
          CRADDR: "서울특별시 송파구 양재대로 921 구립가락1동어린이집",
          CRTELNO: "02-400-9210",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "10",
          NRTRROOMSIZE: "600",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "29",
          CRCAPAT: "152",
          CRCHCNT: "123",
          LA: "37.49598470388708",
          LO: "127.10842450649757",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-11-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 16.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 30.0,
          CHILD_CNT_04: 25.0,
          CHILD_CNT_05: 25.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 123.0,
          EM_CNT_0Y: 52.0,
          EM_CNT_1Y: 35.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 22.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 2.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 30.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000710",
          CRNAME: "강서햇빛발도르프어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07662",
          CRADDR: "서울특별시 강서구 까치산로18길 35 강서햇빛발도르프어린이집",
          CRTELNO: "02-2653-2462",
          CRFAXNO: "02-2653-2463",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "94",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "6",
          CRCAPAT: "35",
          CRCHCNT: "19",
          LA: "37.5499161745",
          LO: "126.8585392666",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-11-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000709",
          CRNAME: "고양이뜰어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07634",
          CRADDR: "서울특별시 강서구 강서로47길 108 103동 104호(내발산동,마곡수명산파크1단지)",
          CRTELNO: "02-6052-2629",
          CRFAXNO: "",
          CRHOME: "http://cafe.daum.net/smwaldorf",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5535661829",
          LO: "126.8305340094",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-11-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-03-16",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000329",
          CRNAME: "벽산에덴어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08646",
          CRADDR: "서울특별시 금천구 금하로 816 512동 103호(시흥동, 관악산벽산타운아파트)",
          CRTELNO: "02-809-1556",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "10",
          LA: "37.4497783639",
          LO: "126.9200222775",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000514",
          CRNAME: "금빛어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05236",
          CRADDR: "서울특별시 강동구 고덕로27길 36 107동 101호(암사동, 현대홈타운)",
          CRTELNO: "02-477-6775",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "5",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.556889874",
          LO: "127.1384362862",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2018-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000432",
          CRNAME: "서초구립 반포래미안아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06599",
          CRADDR: "서울특별시 서초구 서초중앙로 220 112동(반포래미안아이파크)",
          CRTELNO: "02-595-3366",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "273",
          PLGRDCO: "1",
          CCTVINSTLCNT: "27",
          CHCRTESCNT: "17",
          CRCAPAT: "85",
          CRCHCNT: "59",
          LA: "37.50240835422989",
          LO: "127.01307923476689",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 5.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 22.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 59.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000481",
          CRNAME: "미드카운티어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02540",
          CRADDR: "서울특별시 동대문구 답십리로 141 (답십리동,래미안미드카운티아파트)",
          CRTELNO: "02-6713-1410",
          CRFAXNO: "070-8250-1410",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "139",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "50",
          CRCHCNT: "45",
          LA: "37.57451643492074",
          LO: "127.05584264823102",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 69.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 15.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000482",
          CRNAME: "노블레스어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02551",
          CRADDR: "서울특별시 동대문구 답십리로23길 30 관리동(전농동,롯데캐슬노블레스아파트)",
          CRTELNO: "02-6933-7336",
          CRFAXNO: "070-8224-7336",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "170",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "45",
          CRCHCNT: "41",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 42.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000390",
          CRNAME: "구립 스위첸숲속어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04711",
          CRADDR: "서울특별시 성동구 무학봉길 35",
          CRTELNO: "02-2282-2847",
          CRFAXNO: "02-2282-2840",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "57",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5606043973",
          LO: "127.0268737341",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000515",
          CRNAME: "구립별가득어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05376",
          CRADDR: "서울특별시 강동구 양재대로97길 17",
          CRTELNO: "02-473-1903",
          CRFAXNO: "02-473-1905",
          CRHOME: "http://fullstar.kkmom.com/",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "179",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "11",
          CRCAPAT: "33",
          CRCHCNT: "26",
          LA: "37.5311240695",
          LO: "127.1360625639",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 56.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000516",
          CRNAME: "구립꿈이찬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05312",
          CRADDR: "서울특별시 강동구 천중로27길 70 청운캐슬 106동 101호",
          CRTELNO: "02-478-2220",
          CRFAXNO: "02-478-2221",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "202",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "11",
          CRCAPAT: "43",
          CRCHCNT: "24",
          LA: "37.54546503422336",
          LO: "127.13705442942809",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000346",
          CRNAME: "구립 파크스위트어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04978",
          CRADDR: "서울특별시 광진구 광나루로 545 110동 1층(구의동, 래미안파크스위트)",
          CRTELNO: "02-456-8546",
          CRFAXNO: "02-457-8546",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "343",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "13",
          CRCAPAT: "73",
          CRCHCNT: "56",
          LA: "37.5452305351672",
          LO: "127.09056026719227",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 11.0,
          CHILD_CNT_05: 9.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 30.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000769",
          CRNAME: "파인12어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05813",
          CRADDR: "서울특별시 송파구 송파대로8길 42 구립파인12어린이집(장지동, 송파파인타운12단지)",
          CRTELNO: "02-402-7942",
          CRFAXNO: "02-402-7943",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "86",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "22",
          CRCHCNT: "22",
          LA: "37.478915738211235",
          LO: "127.13215045195031",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000768",
          CRNAME: "거여새싹어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05779",
          CRADDR: "서울특별시 송파구 양산로8길 8 관리동 1층(거여동, 거여1단지아파트)",
          CRTELNO: "02-3401-5427",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "90",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "29",
          LA: "37.4909147866",
          LO: "127.1445652655",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000604",
          CRNAME: "구립 아이누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07952",
          CRADDR: "서울특별시 양천구 목동중앙북로8길 71 목동롯데캐슬마에스트로",
          CRTELNO: "02-2654-7780",
          CRFAXNO: "02-2654-7789",
          CRHOME: "www.hangloo.co.kr",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "198",
          PLGRDCO: "3",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "29",
          LA: "37.5455888082",
          LO: "126.8655904209",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "영아전담,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000483",
          CRNAME: "가람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02575",
          CRADDR: "서울특별시 동대문구 왕산로23길 89 101동 101호(제기동,이수브라운스톤아파트)",
          CRTELNO: "02-922-2018",
          CRFAXNO: "02-922-2019",
          CRHOME: "x",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.5826694964",
          LO: "127.0348112107",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000474",
          CRNAME: "마포구육아종합지원센터(아현점)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04128",
          CRADDR: "서울특별시 마포구 마포대로11길 44-81",
          CRTELNO: "02-363-0202",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "377",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2018-09-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000442",
          CRNAME: "가람슬기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04128",
          CRADDR: "서울특별시 마포구 마포대로11길 44-81 아현문화건강센터 1층",
          CRTELNO: "02-312-3001",
          CRFAXNO: "02-312-3002",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "317",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "21",
          CRCAPAT: "91",
          CRCHCNT: "88",
          LA: "37.552210980710264",
          LO: "126.9514280963349",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 88.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000203",
          CRNAME: "동부이촌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04421",
          CRADDR: "서울특별시 용산구 이촌로 193 관리동 1층",
          CRTELNO: "02-797-7857",
          CRFAXNO: "02-790-7857",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "22",
          CRCHCNT: "22",
          LA: "37.5215935377",
          LO: "126.9683936564",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000602",
          CRNAME: "구립 양천SOS어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07913",
          CRADDR: "서울특별시 양천구 가로공원로58길 32 1층",
          CRTELNO: "02-2699-9014",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "260",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "11",
          CRCAPAT: "84",
          CRCHCNT: "51",
          LA: "37.5316780734",
          LO: "126.8248723742",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 51.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001034",
          CRNAME: "화랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01800",
          CRADDR: "서울특별시 노원구 화랑로51길 17 관리동 1층 (공릉동, 화랑타운아파트)",
          CRTELNO: "02-949-1939",
          CRFAXNO: "02-949-1939",
          CRHOME: "http://cafe.daum.net/029491939",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "87",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "8",
          CRCAPAT: "31",
          CRCHCNT: "23",
          LA: "37.6230772379",
          LO: "127.0893655403",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000204",
          CRNAME: "해늘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04381",
          CRADDR: "서울특별시 용산구 이촌로34길 29 이촌동, 현대한강아파트 관리동",
          CRTELNO: "02-711-7847",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "82",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "8",
          CRCAPAT: "31",
          CRCHCNT: "22",
          LA: "37.5236368943",
          LO: "126.9566639649",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000431",
          CRNAME: "서초구립 신반포아크로빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06508",
          CRADDR: "서울특별시 서초구 잠원로 117 신반포아크로리버뷰아파트 104동",
          CRTELNO: "02-532-2001",
          CRFAXNO: "02-532-3001",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "186",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "54",
          CRCHCNT: "45",
          LA: "37.515333755779736",
          LO: "127.00746544186887",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000451",
          CRNAME: "하늘채어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02256",
          CRADDR: "서울특별시 중랑구 용마산로 210 102동(면목동,용마산하늘채)",
          CRTELNO: "02-491-0901",
          CRFAXNO: "02-493-0901",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "144",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "13",
          CRCAPAT: "48",
          CRCHCNT: "39",
          LA: "37.5718558153",
          LO: "127.0870720341",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 19.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 10.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000345",
          CRNAME: "구립 자양1동 봄뜰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05058",
          CRADDR: "서울특별시 광진구 자양로9길 30 (자양동 629-40)",
          CRTELNO: "02-453-2260",
          CRFAXNO: "02-447-0136",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "174",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "9",
          CRCAPAT: "65",
          CRCHCNT: "43",
          LA: "37.533569421467725",
          LO: "127.08278332918297",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 30.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000430",
          CRNAME: "서초구립 신반포자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06521",
          CRADDR: "서울특별시 서초구 잠원로 60",
          CRTELNO: "02-535-5128",
          CRFAXNO: "02-535-5126",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "190",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "12",
          CRCAPAT: "43",
          CRCHCNT: "42",
          LA: "37.51019800408927",
          LO: "127.00789472936513",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 44.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001029",
          CRNAME: "점프어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01606",
          CRADDR: "서울특별시 노원구 동일로241길 53 109동 104호 (상계동, 두산아파트)",
          CRTELNO: "02-6221-4570",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "55",
          PLGRDCO: "2",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.6780159301",
          LO: "127.0529115772",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001033",
          CRNAME: "비선어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01799",
          CRADDR: "서울특별시 노원구 화랑로51길 78 관리동 (공릉동, 비선아파트)",
          CRTELNO: "02-948-2166",
          CRFAXNO: "02-948-2166",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "148",
          PLGRDCO: "5",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "15",
          CRCAPAT: "56",
          CRCHCNT: "39",
          LA: "37.6258173921",
          LO: "127.0878282137",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 4.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 62.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 23.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001032",
          CRNAME: "미키미니어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01882",
          CRADDR: "서울특별시 노원구 초안산로1길 18 2단지 내 관리동 (월계동, 월계주공2단지)",
          CRTELNO: "02-906-8886",
          CRFAXNO: "02-907-3593",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "113",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "42",
          CRCHCNT: "29",
          LA: "37.629161633",
          LO: "127.0516035999",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000603",
          CRNAME: "구립 초록나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07943",
          CRADDR: "서울특별시 양천구 오목로35길 22 101호",
          CRTELNO: "02-2608-3654",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.526811073",
          LO: "126.8556686796",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000091",
          CRNAME: "구립솔샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01120",
          CRADDR: "서울특별시 강북구 삼양로74길 8 102동 102호(미아동, 경남아너스빌)",
          CRTELNO: "02-989-5321",
          CRFAXNO: "02-989-5321",
          CRHOME: "http://cafe.daum.net/9895321",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "71",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.62891621016676",
          LO: "127.01857761104526",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 33.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001028",
          CRNAME: "또래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01604",
          CRADDR: "서울특별시 노원구 동일로245가길 41 202동 106호 (상계동, 은빛아파트)",
          CRTELNO: "02-952-5880",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "45",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.6806824238",
          LO: "127.0538022395",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000452",
          CRNAME: "마포센트럴아이파크어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04201",
          CRADDR: "서울특별시 마포구 마포대로 246 아현아이파크아파트 103동 1층",
          CRTELNO: "02-365-2003",
          CRFAXNO: "02-365-2004",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "25",
          LA: "37.5553491829",
          LO: "126.9585921867",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000631",
          CRNAME: "푸른샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02755",
          CRADDR: "서울특별시 성북구 장위로19길 35",
          CRTELNO: "02-909-8558",
          CRFAXNO: "02-909-8555",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "177",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "10",
          CRCAPAT: "65",
          CRCHCNT: "65",
          LA: "37.61500755029576",
          LO: "127.04386131432392",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 18.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 65.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000614",
          CRNAME: "경선어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08329",
          CRADDR: "서울특별시 구로구 개봉로20길 6 118동 102호",
          CRTELNO: "02-6095-5915",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4928800523",
          LO: "126.8593072878",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000480",
          CRNAME: "청아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02597",
          CRADDR: "서울특별시 동대문구 천호대로55길 11 (답십리동,힐스테이트청계아파트 내)",
          CRTELNO: "02-3394-9025",
          CRFAXNO: "02-3394-9026",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "156",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "8",
          CRCAPAT: "39",
          CRCHCNT: "29",
          LA: "37.57172496478119",
          LO: "127.04696301284568",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000479",
          CRNAME: "청솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02536",
          CRADDR: "서울특별시 동대문구 전농로10길 20 (답십리동)",
          CRTELNO: "02-3394-5026",
          CRFAXNO: "02-3394-5029",
          CRHOME: "cheongsol5026@naver.com",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "111",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "35",
          CRCHCNT: "30",
          LA: "37.574605268412014",
          LO: "127.05845768840063",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001030",
          CRNAME: "청암아이들세상어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01645",
          CRADDR: "서울특별시 노원구 덕릉로112길 24 관리동 1층 (상계동, 청암1단지아파트)",
          CRTELNO: "02-2091-0336",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "87",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "31",
          CRCHCNT: "27",
          LA: "37.6659599106",
          LO: "127.0800957726",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000347",
          CRNAME: "구립 아띠어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05118",
          CRADDR: "서울특별시 광진구 광나루로56길 32 (구의동, 구의현대2단지아파트 213동 102호)",
          CRTELNO: "02-454-7911",
          CRFAXNO: "02-454-7933",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.53781082437571",
          LO: "127.09623125571322",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000452",
          CRNAME: "유린어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02069",
          CRADDR: "서울특별시 중랑구 신내로 56 (신내동)",
          CRTELNO: "02-438-4014",
          CRFAXNO: "02-438-4015",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "188",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "7",
          CRCAPAT: "62",
          CRCHCNT: "15",
          LA: "37.6044720906",
          LO: "127.0959161664",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000344",
          CRNAME: "구립 군자동 꿈모음어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05004",
          CRADDR: "서울특별시 광진구 군자로12길 6-4 (군자동 363-28)",
          CRTELNO: "02-499-0011",
          CRFAXNO: "02-499-0014",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "179",
          PLGRDCO: "3",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "13",
          CRCAPAT: "65",
          CRCHCNT: "56",
          LA: "37.5508568417898",
          LO: "127.07149005029927",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001031",
          CRNAME: "수락예지어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01600",
          CRADDR: "서울특별시 노원구 누원로 28 304동 1층(상계동, 수락리버시티3단지)",
          CRTELNO: "02-936-3050",
          CRFAXNO: "02-937-3070",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "96",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "35",
          CRCHCNT: "15",
          LA: "37.6874759102",
          LO: "127.0535531896",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000111",
          CRNAME: "신한꿈나무어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04542",
          CRADDR: "서울특별시 중구 을지로2가 삼일대로 358 신한L타워 3층",
          CRTELNO: "02-6250-8091",
          CRFAXNO: "02-6250-2093",
          CRHOME: "www.puruni.com/shinhan",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "219",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "14",
          CRCAPAT: "62",
          CRCHCNT: "43",
          LA: "37.5664885611",
          LO: "126.9881059884",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-08-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 8.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 55.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000708",
          CRNAME: "롯데중앙연구소 mom편한 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07594",
          CRADDR: "서울특별시 강서구 마곡중앙로 201",
          CRTELNO: "02-6309-3148",
          CRFAXNO: "",
          CRHOME: "www.puruni.com/lotternd",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "149",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "10",
          CRCAPAT: "36",
          CRCHCNT: "21",
          LA: "37.57112829511681",
          LO: "126.82736036741355",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-08-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 38.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000646",
          CRNAME: "구립 해맞이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03428",
          CRADDR: "서울특별시 은평구 갈현로15길 11-4",
          CRTELNO: "02-356-6800",
          CRFAXNO: "02-356-8804",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "147",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "13",
          CRCAPAT: "45",
          CRCHCNT: "40",
          LA: "37.6074169113",
          LO: "126.909126562",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-08-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 70.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000767",
          CRNAME: "송파꿈꾸는어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05721",
          CRADDR: "서울특별시 송파구 동남로 341 (오금동, 송파레미니스2단지)",
          CRTELNO: "02-6953-6366",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "246",
          PLGRDCO: "2",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "17",
          CRCAPAT: "85",
          CRCHCNT: "67",
          LA: "37.50549110915348",
          LO: "127.1379058943227",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-08-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 67.0,
          EM_CNT_0Y: 85.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000645",
          CRNAME: "구립 다래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03478",
          CRADDR: "서울특별시 은평구 응암로4길 5",
          CRTELNO: "02-302-5800",
          CRFAXNO: "02-302-5799",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "10",
          CRCAPAT: "27",
          CRCHCNT: "26",
          LA: "37.585744167842215",
          LO: "126.91601399698015",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000766",
          CRNAME: "참좋은어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05721",
          CRADDR: "서울특별시 송파구 동남로 341 206동 103호(오금동, 송파레미니스2단지)",
          CRTELNO: "02-402-5955",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "5",
          CRCAPAT: "17",
          CRCHCNT: "15",
          LA: "37.506018887395115",
          LO: "127.13731309743274",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 3.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 5.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000425",
          CRNAME: "구립로이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07001",
          CRADDR: "서울특별시 동작구 사당로23길 112",
          CRTELNO: "02-535-5277",
          CRFAXNO: "02-535-5279",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000425",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "150",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.4877494012",
          LO: "126.9733830512",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000426",
          CRNAME: "구립리가어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07000",
          CRADDR: "서울특별시 동작구 사당로27길 130 105동 키즈클럽(사당동,이수역 리가아파트)",
          CRTELNO: "02-536-1292",
          CRFAXNO: "02-536-1295",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000426",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "90",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4898288129",
          LO: "126.9728802636",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000424",
          CRNAME: "구립아리아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07071",
          CRADDR: "서울특별시 동작구 보라매로5길 51 102호",
          CRTELNO: "02-836-9300",
          CRFAXNO: "02-836-9301",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000424",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "103",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "12",
          CRCAPAT: "33",
          CRCHCNT: "28",
          LA: "37.490797151466765",
          LO: "126.92317069084328",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,휴일보육,시간제보육",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 70.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000513",
          CRNAME: "구립성내2동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05390",
          CRADDR: "서울특별시 강동구 성안로13길 21-14 (성내동)",
          CRTELNO: "02-476-0510",
          CRFAXNO: "02-476-0512",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "221",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "12",
          CRCAPAT: "60",
          CRCHCNT: "40",
          LA: "37.53101894991802",
          LO: "127.13081539147866",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000601",
          CRNAME: "래미안어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "08016",
          CRADDR: "서울특별시 양천구 신목로 7 104동 106호(신정동, 목동삼성아파트)",
          CRTELNO: "02-6092-8870",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "19",
          CRCHCNT: "0",
          LA: "37.51568431662272",
          LO: "126.87691014821648",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-02-28",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000765",
          CRNAME: "가락라온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05705",
          CRADDR: "서울특별시 송파구 송이로15길 31 가락2차쌍용아파트 102동 102호",
          CRTELNO: "02-401-6805",
          CRFAXNO: "02-401-6805",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5021305293",
          LO: "127.1222035692",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000423",
          CRNAME: "구립열린어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06999",
          CRADDR: "서울특별시 동작구 동작대로29길 91",
          CRTELNO: "02-594-8153",
          CRFAXNO: "02-595-8153",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000423",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "8",
          CRCAPAT: "21",
          CRCHCNT: "20",
          LA: "37.487049264956255",
          LO: "126.9774594764912",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000764",
          CRNAME: "거여다온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05771",
          CRADDR: "서울특별시 송파구 오금로56길 16 우방1차아파트 102동 101호",
          CRTELNO: "02-415-7036",
          CRFAXNO: "02-415-7036",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4924958743",
          LO: "127.1424876737",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000600",
          CRNAME: "이글아이영아어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07900",
          CRADDR: "서울특별시 양천구 화곡로3길 27-8 101동 103호(신월동, 제일아파트)",
          CRTELNO: "02-2602-2902",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "44",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "7",
          CRCAPAT: "16",
          CRCHCNT: "12",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 12.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000599",
          CRNAME: "혜림어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07946",
          CRADDR: "서울특별시 양천구 목동중앙북로7가길 24-6",
          CRTELNO: "02-2642-8023",
          CRFAXNO: "02-2642-8023",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "3",
          CRCAPAT: "20",
          CRCHCNT: "4",
          LA: "37.54916303975295",
          LO: "126.86635917491625",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 4.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 1.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 3.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000487",
          CRNAME: "두루놀이장난감도서관",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02263",
          CRADDR: "서울특별시 중랑구 신내역로1길 142",
          CRTELNO: "02-3421-0030",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "141",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2018-06-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000463",
          CRNAME: "자연과아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07258",
          CRADDR: "서울특별시 영등포구 당산동3가 양산로25길 12",
          CRTELNO: "02-2068-2914",
          CRFAXNO: "02-2677-2914",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "127",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "10",
          CRCAPAT: "48",
          CRCHCNT: "30",
          LA: "37.5246215398",
          LO: "126.8989370763",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 86.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000451",
          CRNAME: "다해어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03907",
          CRADDR: "서울특별시 마포구 상암산로1길 24",
          CRTELNO: "02-305-6555",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "111",
          PLGRDCO: "2",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "37",
          CRCHCNT: "32",
          LA: "37.5776672984",
          LO: "126.8893424584",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 19.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000478",
          CRNAME: "솔향기어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02639",
          CRADDR: "서울특별시 동대문구 장한로26다길 77",
          CRTELNO: "02-2213-1095",
          CRFAXNO: "02-2213-1096",
          CRHOME: "http://cafe.naver.com/solaroma",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "199",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "40",
          LA: "37.56833136418697",
          LO: "127.07200196671871",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000627",
          CRNAME: "통통어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02780",
          CRADDR: "서울특별시 성북구 화랑로48길 16",
          CRTELNO: "02-965-6619",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "167",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "35",
          CRCHCNT: "34",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 34.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000630",
          CRNAME: "엔젤어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02702",
          CRADDR: "서울특별시 성북구 보국문로 116 , 단지내 1층(정릉동)",
          CRTELNO: "02-918-4477",
          CRFAXNO: "02-918-4477",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "102",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "10",
          CRCAPAT: "24",
          CRCHCNT: "24",
          LA: "37.61449739340687",
          LO: "127.00752064931105",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000629",
          CRNAME: "파아란어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02712",
          CRADDR: "서울특별시 성북구 솔샘로24길 15 , 단지내 1층(정릉동)",
          CRTELNO: "02-916-7942",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "183",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "11",
          CRCAPAT: "49",
          CRCHCNT: "41",
          LA: "37.615481531746106",
          LO: "127.0100890160502",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 89.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000628",
          CRNAME: "동아라온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02753",
          CRADDR: "서울특별시 성북구 장월로1길 28 단지내 1층",
          CRTELNO: "02-6224-7942",
          CRFAXNO: "0504-007-6932",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "129",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "28",
          CRCHCNT: "26",
          LA: "37.607763180349906",
          LO: "127.04497259778426",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000640",
          CRNAME: "구립 백련산힐4차어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03469",
          CRADDR: "서울특별시 은평구 백련산로 37 백련산힐스테이트4차아파트 407동 1층",
          CRTELNO: "02-307-9622",
          CRFAXNO: "02-307-9623",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "116",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "13",
          CRCAPAT: "40",
          CRCHCNT: "40",
          LA: "37.5894136931",
          LO: "126.9222734665",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 19.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000297",
          CRNAME: "구립참행복한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08637",
          CRADDR: "서울특별시 금천구 시흥대로 165 남서울힐스테이트아파트 212동 102호",
          CRTELNO: "02-895-2737",
          CRFAXNO: "02-895-2737",
          CRHOME: "http://cafe.daum.net/trulyhappy",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "87",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.44846757619602",
          LO: "126.90157460020771",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 14.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000485",
          CRNAME: "장미향기공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02011",
          CRADDR: "서울특별시 중랑구 중랑천로 252-1",
          CRTELNO: "02-977-0032",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "92",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2018-05-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000641",
          CRNAME: "어울림어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03300",
          CRADDR: "서울특별시 은평구 진관3로 15-45 1015동 1층 (진관동, 은평뉴타운 구파발)",
          CRTELNO: "02-355-9009",
          CRFAXNO: "02-355-9088",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "96",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.6442904974",
          LO: "126.9161702078",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-05-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000644",
          CRNAME: "구립 꽃가람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03382",
          CRADDR: "서울특별시 은평구 은평로21길 36-3 102-101",
          CRTELNO: "02-382-6130",
          CRFAXNO: "02-358-6130",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "90",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "29",
          CRCHCNT: "19",
          LA: "37.603218511",
          LO: "126.9306800534",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-05-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000642",
          CRNAME: "구립 거북마을어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03426",
          CRADDR: "서울특별시 은평구 서오릉로15길 7-1",
          CRTELNO: "02-352-1170",
          CRFAXNO: "02-352-1170",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "140",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "33",
          LA: "37.6135226284",
          LO: "126.9099300834",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-05-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 15.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 10.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 90.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000643",
          CRNAME: "구립 아롱별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03391",
          CRADDR: "서울특별시 은평구 통일로69길 12-10",
          CRTELNO: "02-383-2220",
          CRFAXNO: "02-384-2221",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.6118477281",
          LO: "126.9269299755",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-05-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 23.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 89.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000639",
          CRNAME: "구립 키즈빌리지어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03302",
          CRADDR: "서울특별시 은평구 진관4로 17 상림마을 812동 1층",
          CRTELNO: "02-355-0608",
          CRFAXNO: "02-355-0607",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "10",
          CRCAPAT: "23",
          CRCHCNT: "23",
          LA: "37.6436463798",
          LO: "126.9229013677",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-05-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000462",
          CRNAME: "거성어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07210",
          CRADDR: "서울특별시 영등포구 양평동3가 선유로43가길 24 관리동 1층",
          CRTELNO: "02-2672-9681",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "52",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "7",
          CRCAPAT: "17",
          CRCHCNT: "17",
          LA: "37.5314269827",
          LO: "126.8920129607",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-05-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 83.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000512",
          CRNAME: "현대홈키즈어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05328",
          CRADDR: "서울특별시 강동구 올림픽로70길 34 현대홈쇼핑 1층, 현대홈키즈어린이집",
          CRTELNO: "02-484-0508",
          CRFAXNO: "02-484-0509",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "219",
          PLGRDCO: "2",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "60",
          CRCHCNT: "29",
          LA: "37.5390716511",
          LO: "127.1256175541",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 73.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:36.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000461",
          CRNAME: "모아미래도어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07285",
          CRADDR: "서울특별시 영등포구 문래동5가 선유로9나길 5 관리동 1층",
          CRTELNO: "02-2637-2335",
          CRFAXNO: "02-2637-2333",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "48",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "6",
          CRCAPAT: "18",
          CRCHCNT: "17",
          LA: "37.5172726911",
          LO: "126.8867214504",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000202",
          CRNAME: "작은별어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "04311",
          CRADDR: "서울특별시 용산구 효창원로93길 12 1층",
          CRTELNO: "02-6367-0707",
          CRFAXNO: "02-6261-0867",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "52",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "0",
          CRCAPAT: "15",
          CRCHCNT: "0",
          LA: "37.5485354469",
          LO: "126.9628418282",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-03-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 2.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000201",
          CRNAME: "삼일어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04378",
          CRADDR: "서울특별시 용산구 한강대로 95 B동 4층 410호(한강로2가,래미안용산)",
          CRTELNO: "02-794-8831",
          CRFAXNO: "02-794-8830",
          CRHOME: "www.puruni.com/samil",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "133",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "26",
          LA: "37.52954731337001",
          LO: "126.96739471952138",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 56.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000110",
          CRNAME: "늘푸른어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04500",
          CRADDR: "서울특별시 중구 만리동2가 만리재로21길 9",
          CRTELNO: "02-2088-1318",
          CRFAXNO: "02-2088-1312",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "101",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "14",
          CRCAPAT: "38",
          CRCHCNT: "36",
          LA: "37.5528170627",
          LO: "126.9630705681",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000693",
          CRNAME: "마곡어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1308동 102호(마곡동,마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2665-6777",
          CRFAXNO: "0505-055-6777",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.556909852",
          LO: "126.8178734241",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000761",
          CRNAME: "석촌사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05611",
          CRADDR: "서울특별시 송파구 백제고분로33길 32-14 102호(석촌동, 호수맨션)",
          CRTELNO: "02-419-9134",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "129",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5055937164",
          LO: "127.0994493719",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000762",
          CRNAME: "방이두리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05642",
          CRADDR: "서울특별시 송파구 오금로23길 9-17 1층 2호(방이동)",
          CRTELNO: "02-422-1363",
          CRFAXNO: "02-420-1362",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "46",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "17",
          CRCHCNT: "17",
          LA: "37.5096196392",
          LO: "127.1150676002",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000760",
          CRNAME: "가락예은어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05711",
          CRADDR: "서울특별시 송파구 송파대로32길 8 6동 101호(가락동, 우성아파트)",
          CRTELNO: "02-6479-1273",
          CRFAXNO: "02-6479-1273",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49649053270299",
          LO: "127.11769390739268",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 86.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000638",
          CRNAME: "연세어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "03303",
          CRADDR: "서울특별시 은평구 진관4로 48-8 716동 1층 (진관동, 은평뉴타운상림마을)",
          CRTELNO: "02-383-9696",
          CRFAXNO: "02-383-9696",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "0",
          CRCAPAT: "23",
          CRCHCNT: "0",
          LA: "37.6439560659",
          LO: "126.9282129023",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2018-04-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2018-12-31",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000477",
          CRNAME: "솔솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02513",
          CRADDR: "서울특별시 동대문구 장안벚꽃로5길 19 2층(휘경동)",
          CRTELNO: "02-2249-4924",
          CRFAXNO: "02-3390-4924",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "134",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "32",
          CRCHCNT: "28",
          LA: "37.581479918005904",
          LO: "127.07435813095858",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 38.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000470",
          CRNAME: "가온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02644",
          CRADDR: "서울특별시 동대문구 천호대로89길 30 101동 109호(장안동,은하수드림필아파트)",
          CRTELNO: "02-2215-3342",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5630703724",
          LO: "127.0691152165",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000459",
          CRNAME: "한국교직원공제회어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07328",
          CRADDR: "서울특별시 영등포구 여의나루로 50 한국교직원공제회관 2층",
          CRTELNO: "02-786-1508",
          CRFAXNO: "02-786-1509",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "127",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "9",
          CRCAPAT: "33",
          CRCHCNT: "12",
          LA: "37.5218050224",
          LO: "126.9256513576",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 12.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000511",
          CRNAME: "삼성물산강동어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05288",
          CRADDR: "서울특별시 강동구 상일로6길 26 글로벌엔지니어링센터 B동 2층",
          CRTELNO: "02-481-9961",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "349",
          PLGRDCO: "1",
          CCTVINSTLCNT: "22",
          CHCRTESCNT: "19",
          CRCAPAT: "75",
          CRCHCNT: "62",
          LA: "37.5488183814",
          LO: "127.1753261481",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 16.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 42.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000200",
          CRNAME: "사랑꿈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04368",
          CRADDR: "서울특별시 용산구 원효로 216 관리동 1층",
          CRTELNO: "070-7767-6300",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "94",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "10",
          CRCAPAT: "21",
          CRCHCNT: "20",
          LA: "37.5367226428",
          LO: "126.9665271675",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 11.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000450",
          CRNAME: "KB합정어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04026",
          CRADDR: "서울특별시 마포구 포은로2가길 59",
          CRTELNO: "02-337-8102",
          CRFAXNO: "02-337-8103",
          CRHOME: "https://www.puruni.com/kbinsure",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "225",
          PLGRDCO: "4",
          CCTVINSTLCNT: "45",
          CHCRTESCNT: "19",
          CRCAPAT: "85",
          CRCHCNT: "51",
          LA: "37.5497108027",
          LO: "126.9100974574",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-16",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 9.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 22.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 51.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000328",
          CRNAME: "구립우솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08646",
          CRADDR: "서울특별시 금천구 금하로 816 벽산아파트 518-101",
          CRTELNO: "02-805-9707",
          CRFAXNO: "02-896-2234",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4497783639",
          LO: "126.9200222775",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000449",
          CRNAME: "드림어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "03948",
          CRADDR: "서울특별시 마포구 새터산2길 38",
          CRTELNO: "070-4452-4111",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "0",
          CRCAPAT: "25",
          CRCHCNT: "0",
          LA: "37.5654379794",
          LO: "126.9092771862",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2018-03-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-02-29",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000477",
          CRNAME: "오뚜기 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06177",
          CRADDR: "서울특별시 강남구 영동대로 308 2층",
          CRTELNO: "02-2010-0200",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "148",
          PLGRDCO: "0",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "16",
          CRCAPAT: "49",
          CRCHCNT: "31",
          LA: "37.5020770497",
          LO: "127.0676656525",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 31.0,
          EM_CNT_2Y: 8.0,
          EM_CNT_4Y: 15.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000200",
          CRNAME: "구립다온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01200",
          CRADDR: "서울특별시 강북구 삼양로19길 25 103동 104호(미아동, 래미안트라베라1단지아파트)",
          CRTELNO: "02-988-1717",
          CRFAXNO: "02-988-1719",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.613584827750365",
          LO: "127.02055843261218",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000448",
          CRNAME: "한빛어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "03955",
          CRADDR: "서울특별시 마포구 월드컵로31길 56 1층",
          CRTELNO: "02-332-3718",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "56",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5607684667",
          LO: "126.9018309872",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-08-21",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000706",
          CRNAME: "하선어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07609",
          CRADDR: "서울특별시 강서구 양천로14길 37 신안네트빌 101-102",
          CRTELNO: "02-2665-2994",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "0",
          CRCAPAT: "19",
          CRCHCNT: "0",
          LA: "37.5715661239",
          LO: "126.8102987808",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-06-23",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000355",
          CRNAME: "산들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03615",
          CRADDR: "서울특별시 서대문구 통일로 510 106-101",
          CRTELNO: "02-395-3232",
          CRFAXNO: "070-5175-7967",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "104",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "38",
          CRCHCNT: "35",
          LA: "37.5946359628",
          LO: "126.9411733601",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000199",
          CRNAME: "사랑나무어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04336",
          CRADDR: "서울특별시 용산구 후암로 4-8 후암동",
          CRTELNO: "02-2213-2929",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "125",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "14",
          LA: "37.546353570092634",
          LO: "126.97881652121346",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000758",
          CRNAME: "다사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05778",
          CRADDR: "서울특별시 송파구 양산로8길 24 211동 102호(거여동,거여2단지)",
          CRTELNO: "02-431-6667",
          CRFAXNO: "02-431-6667",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "101",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.48958500980208",
          LO: "127.14630630108344",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000757",
          CRNAME: "큰솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05707",
          CRADDR: "서울특별시 송파구 송이로 88 5동 107호(가락동,대림아파트)",
          CRTELNO: "02-430-7942",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "110",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49793451937219",
          LO: "127.11981089007302",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000058",
          CRNAME: "구립유쉘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08645",
          CRADDR: "서울특별시 금천구 금하로 750 우방아파트 단지내 구립유쉘어린이집",
          CRTELNO: "02-804-2007",
          CRFAXNO: "02-804-2007",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "82",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "31",
          CRCHCNT: "22",
          LA: "37.44970567180702",
          LO: "126.9137096847105",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000353",
          CRNAME: "다솜어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03625",
          CRADDR: "서울특별시 서대문구 문화촌길 6-24 102동 107호(홍제동, 문화촌현대아파트)",
          CRTELNO: "02-6082-9972",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000325",
          CRNAME: "구립롯데금빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08608",
          CRADDR: "서울특별시 금천구 벚꽃로 40 롯데캐슬골드파크1차아파트 내",
          CRTELNO: "02-809-7942",
          CRFAXNO: "02-809-7972",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "122",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "46",
          CRCHCNT: "34",
          LA: "37.459694461165974",
          LO: "126.89422757527106",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 34.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000707",
          CRNAME: "마곡1 고운비어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07598",
          CRADDR: "서울특별시 강서구 마곡서1로 131 101동 115호(마곡동, 엠벨리1단지아파트)",
          CRTELNO: "02-2666-2004",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.568750008687104",
          LO: "126.81857356382032",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 57.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000619",
          CRNAME: "돈암하늘채어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02826",
          CRADDR: "서울특별시 성북구 아리랑로 75 관리동 1층",
          CRTELNO: "02-924-7007",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "140",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "12",
          CRCAPAT: "50",
          CRCHCNT: "41",
          LA: "37.5988304358",
          LO: "127.013624921",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000450",
          CRNAME: "새한어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02058",
          CRADDR: "서울특별시 중랑구 용마산로 616 관리동 1층 (신내동)",
          CRTELNO: "02-3421-7900",
          CRFAXNO: "02-3421-8090",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "184",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "9",
          CRCAPAT: "43",
          CRCHCNT: "42",
          LA: "37.6049325667",
          LO: "127.1012258353",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001024",
          CRNAME: "파란나라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01650",
          CRADDR: "서울특별시 노원구 덕릉로94가길 20 청암2단지아파트",
          CRTELNO: "02-951-5854",
          CRFAXNO: "02-951-5856",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "150",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "9",
          CRCAPAT: "42",
          CRCHCNT: "31",
          LA: "37.663622272397724",
          LO: "127.07882331562413",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000175",
          CRNAME: "동화속아이들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03025",
          CRADDR: "서울특별시 종로구 통일로 246-11 무악현대아파트 단지내",
          CRTELNO: "02-733-2440",
          CRFAXNO: "",
          CRHOME: "www.i2440.com",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "172",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "14",
          CRCAPAT: "65",
          CRCHCNT: "44",
          LA: "37.5750955987",
          LO: "126.9591246301",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 9.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000341",
          CRNAME: "구립 능동주민센터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04989",
          CRADDR: "서울특별시 광진구 천호대로112길 55 능동주민센터 1층(능동 232-4)",
          CRTELNO: "02-452-1006",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "24",
          CRCHCNT: "22",
          LA: "37.55367109806976",
          LO: "127.08060014630003",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000446",
          CRNAME: "예랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03912",
          CRADDR: "서울특별시 마포구 월드컵북로47길 46 상암월드컵파크2단지  202동 1층",
          CRTELNO: "02-306-1600",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "76",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "10",
          CRCAPAT: "27",
          CRCHCNT: "24",
          LA: "37.5748827194",
          LO: "126.8907321801",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000530",
          CRNAME: "창1동뽀뽀뽀24시어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01421",
          CRADDR: "서울특별시 도봉구 해등로 50 323동 104호 (창동, 주공3단지아파트)",
          CRTELNO: "02-998-6033",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.6499993424",
          LO: "127.0433005707",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000610",
          CRNAME: "사랑별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08320",
          CRADDR: "서울특별시 구로구 구로동로8길 30-1",
          CRTELNO: "02-858-8010",
          CRFAXNO: "02-858-8015",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "122",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "11",
          CRCAPAT: "46",
          CRCHCNT: "45",
          LA: "37.4870528338",
          LO: "126.8865771392",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 38.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000624",
          CRNAME: "래미안숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02790",
          CRADDR: "서울특별시 성북구 화랑로 214 , 관리동 1층(석관동)",
          CRTELNO: "02-966-1466",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "69",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "26",
          CRCHCNT: "26",
          LA: "37.60821297760417",
          LO: "127.05463195512945",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000343",
          CRNAME: "구립 인정어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05001",
          CRADDR: "서울특별시 광진구 동일로 242 (군자동)",
          CRTELNO: "02-462-2758",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "7",
          CRCAPAT: "28",
          CRCHCNT: "20",
          LA: "37.55306493335688",
          LO: "127.07041421773185",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 11.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001023",
          CRNAME: "두산영재어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01825",
          CRADDR: "서울특별시 노원구 공릉로 126 두산힐스빌아파트 관리동",
          CRTELNO: "02-948-6816",
          CRFAXNO: "02-948-6816",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "115",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "13",
          CRCAPAT: "42",
          CRCHCNT: "39",
          LA: "37.6215344991222",
          LO: "127.07964823113428",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 9.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 46.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000447",
          CRNAME: "우애들어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04076",
          CRADDR: "서울특별시 마포구 독막로20나길 22 래미안밤섬리베뉴1 관리동",
          CRTELNO: "02-333-1003",
          CRFAXNO: "02-333-1020",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "197",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "13",
          CRCAPAT: "46",
          CRCHCNT: "35",
          LA: "37.546070295",
          LO: "126.9248939937",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 82.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 9.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000471",
          CRNAME: "서울시립대학교직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02504",
          CRADDR: "서울특별시 동대문구 서울시립대로 163 서울시립대학교직장어린이집",
          CRTELNO: "02-2213-9566",
          CRFAXNO: "02-2213-9567",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "206",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "37",
          LA: "37.5825764944",
          LO: "127.0599900508",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 60.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000065",
          CRNAME: "롯데캐슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04572",
          CRADDR: "서울특별시 중구 청계천로 400 롯데캐슬베네치아아파트 103동7층관리동 (황학동)",
          CRTELNO: "02-2048-5757",
          CRFAXNO: "0507-0876-582",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "69",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "22",
          CRCHCNT: "22",
          LA: "37.57089532",
          LO: "127.0213261",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000428",
          CRNAME: "이노키즈어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06641",
          CRADDR: "서울특별시 서초구 서초중앙로8길 47",
          CRTELNO: "02-581-5345",
          CRFAXNO: "02-581-5347",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "126",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "17",
          CRCAPAT: "46",
          CRCHCNT: "30",
          LA: "37.48728880494529",
          LO: "127.01804039135997",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 6.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 21.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000609",
          CRNAME: "두산어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08313",
          CRADDR: "서울특별시 구로구 도림로 59 105동 102호(구로동,구로두산아파트)",
          CRTELNO: "02-6735-9267",
          CRFAXNO: "02-839-2020",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "73",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.48945849144997",
          LO: "126.88843582526317",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 7.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000445",
          CRNAME: "엘프어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03904",
          CRADDR: "서울특별시 마포구 상암산로1길 52 상암월드컵파크5단지 505동 1층",
          CRTELNO: "02-373-3654",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "116",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "28",
          CRCHCNT: "23",
          LA: "37.5808061962",
          LO: "126.8853935181",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000612",
          CRNAME: "사과나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08330",
          CRADDR: "서울특별시 구로구 개봉로20길 158 204동 102호",
          CRTELNO: "02-2066-2564",
          CRFAXNO: "050-4099-1292",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4920420095",
          LO: "126.8607381598",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000613",
          CRNAME: "블루밍서연어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08228",
          CRADDR: "서울특별시 구로구 고척로60길 30 고척벽산베스트블루밍 아파트 관리동 1층",
          CRTELNO: "02-2686-4333",
          CRFAXNO: "02-2683-4333",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "102",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "23",
          CRCHCNT: "23",
          LA: "37.5051511052",
          LO: "126.8587685394",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000476",
          CRNAME: "위브어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02620",
          CRADDR: "서울특별시 동대문구 황물로15길 25 (답십리동,두산위브아파트)",
          CRTELNO: "02-2212-9919",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "139",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "33",
          CRCHCNT: "29",
          LA: "37.566561805",
          LO: "127.0571882",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000475",
          CRNAME: "이편한오렌지어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02407",
          CRADDR: "서울특별시 동대문구 한천로63길 10",
          CRTELNO: "02-966-0906",
          CRFAXNO: "02-966-0906",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "78",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "9",
          CRCAPAT: "29",
          CRCHCNT: "29",
          LA: "37.60458659240054",
          LO: "127.06550250220346",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000449",
          CRNAME: "아이누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02095",
          CRADDR: "서울특별시 중랑구 동일로 752 107동 102호 (중화동, 한신아파트)",
          CRTELNO: "02-433-1642",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "56",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.597007915",
          LO: "127.0820691159",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 57.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000529",
          CRNAME: "쌍문4동파란꿈나라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01388",
          CRADDR: "서울특별시 도봉구 해등로 242-11 101동 103호(쌍문동,성원아파트)",
          CRTELNO: "02-6225-6919",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.6589666131",
          LO: "127.0293434844",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 67.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000527",
          CRNAME: "쌍문4동아이천국어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01430",
          CRADDR: "서울특별시 도봉구 해등로 229 3동 109호(쌍문동, 한양아파트)",
          CRTELNO: "02-900-4245",
          CRFAXNO: "02-900-4245",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.657625456",
          LO: "127.0312740703",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000308",
          CRNAME: "파랑새어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02638",
          CRADDR: "서울특별시 동대문구 장안벚꽃로 107 108동 102호(장안동, 현대홈타운아파트)",
          CRTELNO: "02-2243-3935",
          CRFAXNO: "02-2243-3935",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.56966129",
          LO: "127.0746722",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 17.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000625",
          CRNAME: "휴먼빌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02826",
          CRADDR: "서울특별시 성북구 아리랑로 89 , 관리동 1층 (돈암동)",
          CRTELNO: "02-928-5240",
          CRFAXNO: "02-928-5239",
          CRHOME: "http://cafe.daum.net/humanvillchild",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "102",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "35",
          CRCHCNT: "33",
          LA: "37.60166461971621",
          LO: "127.01256717888114",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000116",
          CRNAME: "구립우리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08596",
          CRADDR: "서울특별시 금천구 범안로 1136 구립우리어린이집",
          CRTELNO: "02-869-7273",
          CRFAXNO: "02-863-7746",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "91",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "33",
          CRCHCNT: "32",
          LA: "37.465435718141514",
          LO: "126.88884172919437",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000473",
          CRNAME: "해솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02512",
          CRADDR: "서울특별시 동대문구 한천로 248 (휘경동, 휘경주공아파트)",
          CRTELNO: "02-6452-7942",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "101",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "26",
          CRCHCNT: "21",
          LA: "37.58278806196844",
          LO: "127.0716026538277",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000448",
          CRNAME: "아미어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02069",
          CRADDR: "서울특별시 중랑구 봉화산로56길 112 101동 102호 (신내동)",
          CRTELNO: "02-436-3859",
          CRFAXNO: "02-436-3859",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "67",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "15",
          LA: "37.6040136039",
          LO: "127.0968759111",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000472",
          CRNAME: "허브리츠어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02567",
          CRADDR: "서울특별시 동대문구 정릉천동로 36 (용두동,허브리츠) 관리동",
          CRTELNO: "02-965-0121",
          CRFAXNO: "02-966-0121",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "119",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "12",
          CRCAPAT: "43",
          CRCHCNT: "40",
          LA: "37.5754860712",
          LO: "127.0371126933",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 18.0,
          CHILD_CNT_02: 17.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000528",
          CRNAME: "쌍문4동리틀모아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01387",
          CRADDR: "서울특별시 도봉구 해등로 242-12 103동 102호(쌍문동)",
          CRTELNO: "02-7951-6174",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "19",
          CRCHCNT: "11",
          LA: "37.6586671351",
          LO: "127.0307259907",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 1.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 11.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 40.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000354",
          CRNAME: "인왕어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03622",
          CRADDR: "서울특별시 서대문구 문화촌길 34 홍제동",
          CRTELNO: "02-394-6753",
          CRFAXNO: "02-394-6754",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "88",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.59345969101366",
          LO: "126.94885077389004",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 63.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001021",
          CRNAME: "사슴어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01865",
          CRADDR: "서울특별시 노원구 월계로55길 15 사슴3단지아파트 관리동",
          CRTELNO: "02-979-1262",
          CRFAXNO: "02-979-1283",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "173",
          PLGRDCO: "2",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "21",
          CRCAPAT: "63",
          CRCHCNT: "49",
          LA: "37.6323976845",
          LO: "127.0598488135",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 49.0,
          EM_CNT_0Y: 61.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 18.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000052",
          CRNAME: "구립예능어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01191",
          CRADDR: "서울특별시 강북구 솔샘로 159 벽산라이브파크아파트 관리동 1층",
          CRTELNO: "02-982-8733",
          CRFAXNO: "02-982-8133",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "167",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "37",
          CRCHCNT: "19",
          LA: "37.62192004",
          LO: "127.0125706",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 83.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000704",
          CRNAME: "구립 모아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07517",
          CRADDR: "서울특별시 강서구 방화대로45길 78 101동 103호(방화동, 보람쉬움아파트)",
          CRTELNO: "02-2661-8767",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.5746106619",
          LO: "126.8120388999",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001022",
          CRNAME: "우리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01850",
          CRADDR: "서울특별시 노원구 동일로198가길 149 공릉2단지아파트 관리동",
          CRTELNO: "02-972-9207",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "31",
          CRCHCNT: "21",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000608",
          CRNAME: "파란나라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08227",
          CRADDR: "서울특별시 구로구 중앙로1길 18-19 103동 105호",
          CRTELNO: "02-2619-4501",
          CRFAXNO: "0504-206-2224",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "17",
          CRCHCNT: "17",
          LA: "37.4985789254",
          LO: "126.8631506148",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001020",
          CRNAME: "우주별어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01813",
          CRADDR: "서울특별시 노원구 공릉로46길 19 관리동 1층",
          CRTELNO: "02-948-2074",
          CRFAXNO: "070-8230-5500",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "140",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "14",
          CRCAPAT: "39",
          CRCHCNT: "37",
          LA: "37.6279059504",
          LO: "127.0801319515",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 73.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 18.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000422",
          CRNAME: "구립키즈사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06939",
          CRADDR: "서울특별시 동작구 알마타길 37 관리동 1층",
          CRTELNO: "02-3280-0377",
          CRFAXNO: "02-3280-0377",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000422",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "80",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "10",
          CRCAPAT: "27",
          CRCHCNT: "24",
          LA: "37.51291640947408",
          LO: "126.92971400525351",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000623",
          CRNAME: "꿈의숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02749",
          CRADDR: "서울특별시 성북구 오패산로16가길 40 , 관리동 1층",
          CRTELNO: "02-9772-9155",
          CRFAXNO: "02-909-6450",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "24",
          CRCHCNT: "24",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000342",
          CRNAME: "구립 건대티움아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05090",
          CRADDR: "서울특별시 광진구 능동로4길 41 701동 101호(자양동, 자양7차현대홈타운)",
          CRTELNO: "02-499-1279",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000474",
          CRNAME: "이문현대어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02422",
          CRADDR: "서울특별시 동대문구 한천로58길 107 (이문동, 현대아파트)",
          CRTELNO: "02-959-1153",
          CRFAXNO: "02-6451-1154",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "190",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "11",
          CRCAPAT: "65",
          CRCHCNT: "44",
          LA: "37.60052947012829",
          LO: "127.07014185036956",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 6.0,
          CHILD_CNT_04: 8.0,
          CHILD_CNT_05: 7.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001027",
          CRNAME: "주영어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01745",
          CRADDR: "서울특별시 노원구 한글비석로5길 62 중계8단지주공아파트 관리동",
          CRTELNO: "02-930-8787",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "109",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "36",
          CRCHCNT: "35",
          LA: "37.646042337497334",
          LO: "127.0746207386512",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000626",
          CRNAME: "삼선예일어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02875",
          CRADDR: "서울특별시 성북구 보문로29다길 31 , 관리동 1층",
          CRTELNO: "02-742-6371",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "24",
          CRCHCNT: "24",
          LA: "37.58341274331993",
          LO: "127.01286130124342",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000622",
          CRNAME: "현대어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02802",
          CRADDR: "서울특별시 성북구 종암로21길 127 , 관리동 1층",
          CRTELNO: "02-925-9777",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "24",
          CRCHCNT: "13",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000352",
          CRNAME: "작은숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03601",
          CRADDR: "서울특별시 서대문구 포방터10길 33 극동아파트 106동 103호",
          CRTELNO: "02-6378-7780",
          CRFAXNO: "",
          CRHOME: "작은숲어린이집.com",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "52",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.6024540067",
          LO: "126.9513909195",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000611",
          CRNAME: "이화우성어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08369",
          CRADDR: "서울특별시 구로구 도림로22길 8 101동 110호",
          CRTELNO: "02-859-5152",
          CRFAXNO: "02-859-5153",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.4901477076",
          LO: "126.8932529137",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000607",
          CRNAME: "하늘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08329",
          CRADDR: "서울특별시 구로구 개봉로20길 6 124동 104호",
          CRTELNO: "02-2066-7749",
          CRFAXNO: "050-4047-8354",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.49135189710704",
          LO: "126.85813698555301",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000531",
          CRNAME: "창1동즐거운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01423",
          CRADDR: "서울특별시 도봉구 덕릉로 371 (창동,대우그린아파트)",
          CRTELNO: "02-998-2689",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.6461118052",
          LO: "127.0496391845",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000469",
          CRNAME: "다함어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02553",
          CRADDR: "서울특별시 동대문구 사가정로 65 (전농동, 래미안크레시티아파트)",
          CRTELNO: "02-2249-9636",
          CRFAXNO: "02-2249-9637",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "272",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "12",
          CRCAPAT: "80",
          CRCHCNT: "63",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 15.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 63.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001019",
          CRNAME: "은빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01604",
          CRADDR: "서울특별시 노원구 동일로245가길 41 은빛2단지아파트 관리동",
          CRTELNO: "02-934-3006",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "196",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "67",
          CRCHCNT: "30",
          LA: "37.68010639137772",
          LO: "127.05348724268475",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 63.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000534",
          CRNAME: "방학3동꿈송이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01359",
          CRADDR: "서울특별시 도봉구 방학로 200 115동110호(방학동,신동아아파트)",
          CRTELNO: "02-955-1209",
          CRFAXNO: "02-3493-1123",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.6628263698",
          LO: "127.0295354084",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000759",
          CRNAME: "아이조아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05665",
          CRADDR: "서울특별시 송파구 백제고분로46길 8-23 101호(송파동, 온누리아파트)",
          CRTELNO: "02-415-5672",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "74",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "7",
          CRCAPAT: "17",
          CRCHCNT: "16",
          LA: "37.50750233584489",
          LO: "127.11148499005891",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000620",
          CRNAME: "SK키즈몬테소리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02863",
          CRADDR: "서울특별시 성북구 삼선동3가 삼선교로16길 35 , 관리동 1층",
          CRTELNO: "02-461-3510",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "57",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "21",
          CRCHCNT: "21",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001025",
          CRNAME: "아이맘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01614",
          CRADDR: "서울특별시 노원구 동일로231길 86 204동 108호(상계동, 현대2차아파트)",
          CRTELNO: "02-3391-5927",
          CRFAXNO: "02-3391-5927",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "67",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.67242011754624",
          LO: "127.05046942885771",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001026",
          CRNAME: "하계현대어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01747",
          CRADDR: "서울특별시 노원구 노원로18길 19 하계2차현대아파트",
          CRTELNO: "02-948-7386",
          CRFAXNO: "02-975-7386",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "107",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "38",
          CRCHCNT: "33",
          LA: "37.64449398504855",
          LO: "127.0724719974882",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000447",
          CRNAME: "알콩달콩어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02025",
          CRADDR: "서울특별시 중랑구 신내로 155 808동 109호 (신내동)",
          CRTELNO: "02-3423-3577",
          CRFAXNO: "02-3423-3822",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.6138580761",
          LO: "127.0943244338",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000621",
          CRNAME: "해피래미안어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02724",
          CRADDR: "서울특별시 성북구 길음로 74 , 관리동 1층",
          CRTELNO: "02-914-7979",
          CRFAXNO: "",
          CRHOME: "http://cafe.daum.net/happy-110-103",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.6103444981247",
          LO: "127.02077407206329",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000547",
          CRNAME: "서봄어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "08783",
          CRADDR: "서울특별시 관악구 신림로44나길 18 1층",
          CRTELNO: "02-882-3351",
          CRFAXNO: "02-882-3352",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "43",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "16",
          CRCHCNT: "0",
          LA: "37.4781408974",
          LO: "126.9355803115",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-03-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000705",
          CRNAME: "구립 한숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07518",
          CRADDR: "서울특별시 강서구 방화대로50길 7 101동 102호(방화동 한숲마을대림아파트)",
          CRTELNO: "02-6348-7942",
          CRFAXNO: "02-6368-7942",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "13",
          LA: "37.57681041",
          LO: "126.8174762926",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000171",
          CRNAME: "도담도담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03110",
          CRADDR: "서울특별시 종로구 숭인동길 47",
          CRTELNO: "02-921-4500",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "250",
          PLGRDCO: "4",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "12",
          CRCAPAT: "62",
          CRCHCNT: "43",
          LA: "37.5770648189",
          LO: "127.0218623558",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 11.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 43.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 22.0,
          EM_CNT_4Y: 67.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000703",
          CRNAME: "구립 하나로어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07542",
          CRADDR: "서울특별시 강서구 양천로73길 5 101동 105호",
          CRTELNO: "02-2652-5946",
          CRFAXNO: "02-2652-5946",
          CRHOME: "https://cafe.naver.com/hanarohouse",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5518951804",
          LO: "126.8715136217",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000598",
          CRNAME: "구립 파란나라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08107",
          CRADDR: "서울특별시 양천구 신정로 290",
          CRTELNO: "02-2065-8727",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "164",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "30",
          CRCHCNT: "27",
          LA: "37.5123238355",
          LO: "126.8534570407",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 57.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000331",
          CRNAME: "구립꿈의숲캐슬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01232",
          CRADDR: "서울특별시 강북구 오현로 56 관리동 1층(미아동, 꿈의숲롯데캐슬아파트)",
          CRTELNO: "02-980-7750",
          CRFAXNO: "02-980-7750",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "250",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "53",
          CRCHCNT: "37",
          LA: "37.617330166166866",
          LO: "127.03629077429585",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000532",
          CRNAME: "창4동별초롱어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01416",
          CRADDR: "서울특별시 도봉구 노해로70길 12 6동 106호(창동)",
          CRTELNO: "02-6316-5050",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "109",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "9",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.6507501156",
          LO: "127.0495244211",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 12.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000533",
          CRNAME: "창4동예나동산어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01411",
          CRADDR: "서울특별시 도봉구 노해로69길 103 109동101호(창동,동아청솔아파트)",
          CRTELNO: "02-6231-2555",
          CRFAXNO: "02-6231-2555",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.6577850908",
          LO: "127.0492752377",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000176",
          CRNAME: "삼양어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03129",
          CRADDR: "서울특별시 종로구 종로33길 31",
          CRTELNO: "02-760-5081",
          CRFAXNO: "02-740-7290",
          CRHOME: "www.puruni.com/samyangjn",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "191",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "6",
          CRCAPAT: "45",
          CRCHCNT: "10",
          LA: "37.5726123205",
          LO: "127.0010957695",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 2.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 3.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 75.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000702",
          CRNAME: "디앤오 강서어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07789",
          CRADDR: "서울특별시 강서구 마곡중앙로 150 2층",
          CRTELNO: "02-2088-2021",
          CRFAXNO: "02-2088-1117",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "151",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "6",
          CRCAPAT: "36",
          CRCHCNT: "10",
          LA: "37.56688203704603",
          LO: "126.8286860076051",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 2.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000701",
          CRNAME: "사이언스파크어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07796",
          CRADDR: "서울특별시 강서구 마곡중앙10로 30",
          CRTELNO: "02-6941-0302",
          CRFAXNO: "02-6941-0320",
          CRHOME: "http://moamom101.kiznet.co.kr",
          NRTRROOMCNT: "16",
          NRTRROOMSIZE: "2245",
          PLGRDCO: "3",
          CCTVINSTLCNT: "58",
          CHCRTESCNT: "64",
          CRCAPAT: "300",
          CRCHCNT: "271",
          LA: "37.563335803782486",
          LO: "126.83124645373728",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 15.0,
          CLASS_CNT_02: 12.0,
          CLASS_CNT_03: 6.0,
          CLASS_CNT_04: 5.0,
          CLASS_CNT_05: 4.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 42.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 50.0,
          CHILD_CNT_02: 54.0,
          CHILD_CNT_03: 63.0,
          CHILD_CNT_04: 58.0,
          CHILD_CNT_05: 46.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 271.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 35.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 8.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 51.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 1.0,
          EM_CNT_A7: 6.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 64.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000634",
          CRNAME: "구립 아이클어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03311",
          CRADDR: "서울특별시 은평구 진관1로 21-10 (진관동, 박석고개 1단지아파트) 주민공동시설 중 어린이집",
          CRTELNO: "02-355-3558",
          CRFAXNO: "02-355-2558",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "99",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "35",
          CRCHCNT: "35",
          LA: "37.63351709842303",
          LO: "126.91958559198706",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000427",
          CRNAME: "푸른산아이랜드어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "06801",
          CRADDR: "서울특별시 서초구 홍씨마을길 43-3",
          CRTELNO: "02-574-6530",
          CRFAXNO: "070-7609-0279",
          CRHOME: "https://cafe.naver.com/pilsc/1966",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "185",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "0",
          CRCAPAT: "39",
          CRCHCNT: "0",
          LA: "37.45190234034128",
          LO: "127.06642018673133",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2018-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-03-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000699",
          CRNAME: "마곡코오롱어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07793",
          CRADDR: "서울특별시 강서구 마곡동로 110 1층 (마곡동, 코오롱미래기술원)",
          CRTELNO: "02-2199-1990",
          CRFAXNO: "02-2199-1994",
          CRHOME: "www.puruni.com/kolongs",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "226",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "21",
          CRCAPAT: "65",
          CRCHCNT: "47",
          LA: "37.564516957873536",
          LO: "126.83503555233811",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 11.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 7.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 6.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 6.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000444",
          CRNAME: "LG마포어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04143",
          CRADDR: "서울특별시 마포구 마포대로 155 마포빌딩 3층",
          CRTELNO: "02-2039-7716",
          CRFAXNO: "02-2039-7726",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "156",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.5483592078",
          LO: "126.9536576364",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000700",
          CRNAME: "잘자람어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07604",
          CRADDR: "서울특별시 강서구 방화대로37길 26 방화현대아파트101-102",
          CRTELNO: "02-2662-6660",
          CRFAXNO: "",
          CRHOME: "blog.naver.com/kpsoul",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "62",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "18",
          LA: "37.5704040196",
          LO: "126.8138062711",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 11.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000476",
          CRNAME: "GKL행복(강남 코엑스2호점)어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06155",
          CRADDR: "서울특별시 강남구 봉은사로68길 27",
          CRTELNO: "02-501-3385",
          CRFAXNO: "02-501-3386",
          CRHOME: "www.puruni.com/gklc2",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "374",
          PLGRDCO: "3",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "15",
          CRCAPAT: "49",
          CRCHCNT: "21",
          LA: "37.5104322131",
          LO: "127.0512729194",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 5.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 46.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000443",
          CRNAME: "아이뜰어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "04179",
          CRADDR: "서울특별시 마포구 삼개로 33 우성아파트 8-101",
          CRTELNO: "02-6032-3600",
          CRFAXNO: "02-6010-9292",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "49",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "18",
          CRCHCNT: "0",
          LA: "37.5366437475",
          LO: "126.9477496706",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-06-30",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000327",
          CRNAME: "캐슬아이어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "08608",
          CRADDR: "서울특별시 금천구 벚꽃로 30 1층",
          CRTELNO: "02-804-7999",
          CRFAXNO: "02-804-7998",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "0",
          CRCAPAT: "49",
          CRCHCNT: "0",
          LA: "37.458223545",
          LO: "126.8937097245",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-02-28",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000506",
          CRNAME: "구립성내푸른어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05392",
          CRADDR: "서울특별시 강동구 성내로3길 49 (성내동)",
          CRTELNO: "02-470-1113",
          CRFAXNO: "02-470-1174",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "218",
          PLGRDCO: "2",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "15",
          CRCAPAT: "82",
          CRCHCNT: "71",
          LA: "37.5320205888",
          LO: "127.1237547917",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 16.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 71.0,
          EM_CNT_0Y: 92.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 8.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000549",
          CRNAME: "구립찬솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08853",
          CRADDR: "서울특별시 관악구 법원단지12길 24",
          CRTELNO: "02-853-0330",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "83",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "15",
          LA: "37.4728196514",
          LO: "126.9209337758",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 38.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000550",
          CRNAME: "구립즐거운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08751",
          CRADDR: "서울특별시 관악구 양녕로 31 두산아파트 3단지 관리동",
          CRTELNO: "02-3285-1998",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "155",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "31",
          CRCHCNT: "24",
          LA: "37.4851522616",
          LO: "126.9457774779",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000429",
          CRNAME: "서초구립 아르떼어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06676",
          CRADDR: "서울특별시 서초구 방배천로18길 11 관리동(방배동, 방배롯데캐슬아르떼)",
          CRTELNO: "02-521-5689",
          CRFAXNO: "02-522-5689",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "224",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "48",
          CRCHCNT: "41",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000548",
          CRNAME: "구립조앤아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08735",
          CRADDR: "서울특별시 관악구 관악로30길 12 봉천우성아파트 103-101",
          CRTELNO: "02-883-0312",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4840985767",
          LO: "126.9606848133",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-23",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000446",
          CRNAME: "사이좋은 어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02030",
          CRADDR: "서울특별시 중랑구 숙선옹주로 45 112동 102호(묵동,e-편한세상화랑대)",
          CRTELNO: "02-3421-1007",
          CRFAXNO: "02-3421-1004",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "2",
          CRCAPAT: "20",
          CRCHCNT: "1",
          LA: "37.6157084078",
          LO: "127.0827103544",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 8.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 1.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 1.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 1.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 2.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000636",
          CRNAME: "구립 응암봄샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03474",
          CRADDR: "서울특별시 은평구 백련산로 160 (응암동, 녹번역센트레빌아파트) 주민공동시설 중 어린이집",
          CRTELNO: "02-387-2977",
          CRFAXNO: "02-387-2978",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "10",
          CRCAPAT: "25",
          CRCHCNT: "25",
          LA: "37.5983179395",
          LO: "126.9260871276",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 63.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000174",
          CRNAME: "경희궁솔빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03165",
          CRADDR: "서울특별시 종로구 송월길 99 210동 1층",
          CRTELNO: "02-732-8003",
          CRFAXNO: "070-4036-8004",
          CRHOME: "http://cafe.daum.net/solshiningkids",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "134",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "14",
          CRCAPAT: "45",
          CRCHCNT: "42",
          LA: "37.570919642",
          LO: "126.9622964217",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-19",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 18.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 42.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000387",
          CRNAME: "구립 맑은샘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04731",
          CRADDR: "서울특별시 성동구 매봉길 51 (옥수동 528-2)",
          CRTELNO: "02-2293-0509",
          CRFAXNO: "02-2297-8701",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "203",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "10",
          CRCAPAT: "68",
          CRCHCNT: "28",
          LA: "37.5465907739",
          LO: "127.0133800346",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 71.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000173",
          CRNAME: "경희궁초록어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03166",
          CRADDR: "서울특별시 종로구 송월길 130 102동 1층",
          CRTELNO: "070-4024-1499",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "23",
          CRCHCNT: "20",
          LA: "37.5722357769",
          LO: "126.964496342",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 13.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000172",
          CRNAME: "경희궁자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03180",
          CRADDR: "서울특별시 종로구 경교장길 35 306동 데크층",
          CRTELNO: "02-720-1633",
          CRFAXNO: "02-720-1634",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "172",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "48",
          LA: "37.56893882048901",
          LO: "126.96685686495866",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 19.0,
          CHILD_CNT_02: 16.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 48.0,
          EM_CNT_0Y: 42.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000505",
          CRNAME: "구립천호1동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05308",
          CRADDR: "서울특별시 강동구 상암로27길 18",
          CRTELNO: "02-429-3337",
          CRFAXNO: "02-429-3337",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "95",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "30",
          CRCHCNT: "26",
          LA: "37.54673459315193",
          LO: "127.13778380739487",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000698",
          CRNAME: "드림아이어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07595",
          CRADDR: "서울특별시 강서구 방화대로34길 88 마곡푸르지오아파트 102동 102호",
          CRTELNO: "02-6489-9691",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.570155865141885",
          LO: "126.8217311371715",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-02-28",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000460",
          CRNAME: "아너스빌어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07437",
          CRADDR: "서울특별시 영등포구 여의대방로 25 경남아너스빌아파트 관리동",
          CRTELNO: "02-849-4279",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "93",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "10",
          CRCAPAT: "28",
          CRCHCNT: "28",
          LA: "37.4947127568",
          LO: "126.9089783295",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000356",
          CRNAME: "헤아림어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03770",
          CRADDR: "서울특별시 서대문구 북아현로1길 50 2단지 202동 1층",
          CRTELNO: "02-313-6702",
          CRFAXNO: "02-313-6703",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "22",
          CRCHCNT: "22",
          LA: "37.560007778762",
          LO: "126.9537121059292",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000635",
          CRNAME: "구립 해솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03304",
          CRADDR: "서울특별시 은평구 진관4로 87 (진관동, 은평뉴타운 상림마을 5단지 아파트) 주민공동시설 중 어린이집",
          CRTELNO: "02-352-1331",
          CRFAXNO: "02-352-1330",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "71",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "26",
          CRCHCNT: "21",
          LA: "37.6480578155",
          LO: "126.9289930855",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000389",
          CRNAME: "구립 서울숲리버뷰자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04745",
          CRADDR: "서울특별시 성동구 고산자로2길 65 행당동 100번지일대(행당6구역)",
          CRTELNO: "02-2293-7770",
          CRFAXNO: "02-2293-7730",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "265",
          PLGRDCO: "10",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "17",
          CRCAPAT: "98",
          CRCHCNT: "66",
          LA: "37.556326708",
          LO: "127.0389275652",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 8.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 21.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000632",
          CRNAME: "구립 예가어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03302",
          CRADDR: "서울특별시 은평구 진관4로 37 은평뉴타운 상림마을2단지아파트 관리동",
          CRTELNO: "02-387-2656",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "90",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "34",
          CRCHCNT: "26",
          LA: "37.6444694783",
          LO: "126.9250760356",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 3.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 30.0,
          EM_CNT_1Y: 30.0,
          EM_CNT_2Y: 10.0,
          EM_CNT_4Y: 30.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000188",
          CRNAME: "구립리틀버드어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01087",
          CRADDR: "서울특별시 강북구 삼양로93길 11-4",
          CRTELNO: "02-900-9284",
          CRFAXNO: "02-900-9334",
          CRHOME: "cafe.daum.net/littlebirdkids",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "175",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "41",
          CRCHCNT: "35",
          LA: "37.63740289",
          LO: "127.0162939",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000618",
          CRNAME: "별숲발도르프어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "02714",
          CRADDR: "서울특별시 성북구 길음로 119 220동 101호 (길음동, 길음뉴타운)",
          CRTELNO: "02-942-0683",
          CRFAXNO: "02-942-0684",
          CRHOME: "yanghy1999@hanmail.net",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.6104997105",
          LO: "127.0163723926",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-02-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-08-03",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000637",
          CRNAME: "구립 행복한우리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03467",
          CRADDR: "서울특별시 은평구 응암로22길 18-1",
          CRTELNO: "02-352-1566",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "338",
          PLGRDCO: "2",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "16",
          CRCAPAT: "82",
          CRCHCNT: "62",
          LA: "37.593387464",
          LO: "126.9201677708",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 16.0,
          CHILD_CNT_04: 8.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 23.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 23.0,
          EM_CNT_4Y: 39.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000425",
          CRNAME: "서초구립 양재목련어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06781",
          CRADDR: "서울특별시 서초구 언남16길 37",
          CRTELNO: "02-529-3579",
          CRFAXNO: "02-529-0435",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "221",
          PLGRDCO: "2",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "80",
          CRCHCNT: "68",
          LA: "37.47348208",
          LO: "127.0464950607",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 11.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 68.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 9.0,
          EM_CNT_4Y: 46.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000631",
          CRNAME: "사랑꿈어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03304",
          CRADDR: "서울특별시 은평구 진관4로 100 609동 1층 (진관동, 은평뉴타운 상림마을)",
          CRTELNO: "02-384-0003",
          CRFAXNO: "02-384-2240",
          CRHOME: "e_kids_/",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "67",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "4",
          CRCAPAT: "16",
          CRCHCNT: "2",
          LA: "37.64896766664846",
          LO: "126.93180696626572",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 2.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 2.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 2.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 4.0,
          WORK_DTTM: "2022-10-26 22:03:26.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000458",
          CRNAME: "창의나라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07356",
          CRADDR: "서울특별시 영등포구 여의대방로47길 24-2",
          CRTELNO: "02-844-3234",
          CRFAXNO: "02-844-3233",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "223",
          PLGRDCO: "1",
          CCTVINSTLCNT: "22",
          CHCRTESCNT: "15",
          CRCAPAT: "84",
          CRCHCNT: "79",
          LA: "37.5088963987",
          LO: "126.921556261",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 18.0,
          CHILD_CNT_03: 25.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 79.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 8.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000424",
          CRNAME: "서초구립 방배1동초록꿈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06685",
          CRADDR: "서울특별시 서초구 효령로23길 16",
          CRTELNO: "02-3486-2019",
          CRFAXNO: "070-7163-2969",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "161",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "60",
          CRCHCNT: "56",
          LA: "37.4811640717",
          LO: "126.9939760978",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 21.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 15.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 27.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000423",
          CRNAME: "서초구립 양재별하어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06791",
          CRADDR: "서울특별시 서초구 논현로5길 15-5",
          CRTELNO: "02-533-4503",
          CRFAXNO: "02-574-4503",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "190",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "22",
          CRCAPAT: "71",
          CRCHCNT: "71",
          LA: "37.4719708093",
          LO: "127.049397181",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 33.0,
          CHILD_CNT_SP: 9.0,
          CHILD_CNT_TOT: 71.0,
          EM_CNT_0Y: 47.0,
          EM_CNT_1Y: 6.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 18.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 3.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 22.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000421",
          CRNAME: "서초구립 서울교육대학교사향어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06639",
          CRADDR: "서울특별시 서초구 서초중앙로 96 서울교육대학교 평생교육원 1층",
          CRTELNO: "02-583-6688",
          CRFAXNO: "02-583-6689",
          CRHOME: "http://naver.com/sahyang6688",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "179",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "10",
          CRCAPAT: "62",
          CRCHCNT: "56",
          LA: "37.4908433337",
          LO: "127.0176895804",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000422",
          CRNAME: "서초구립 래미안서초에스티지S어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06625",
          CRADDR: "서울특별시 서초구 서운로 104",
          CRTELNO: "02-525-2018",
          CRFAXNO: "02-525-2019",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "111",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "42",
          CRCHCNT: "38",
          LA: "37.4931733593",
          LO: "127.0270892835",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000452",
          CRNAME: "이화어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07365",
          CRADDR: "서울특별시 영등포구 도신로29길 28 대우푸르지오 2단지내",
          CRTELNO: "02-847-2243",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "27",
          CRCHCNT: "27",
          LA: "37.5117544634",
          LO: "126.9023250258",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000456",
          CRNAME: "선유어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07211",
          CRADDR: "서울특별시 영등포구 양평동3가 선유로 207",
          CRTELNO: "02-2676-7111",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "77",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "29",
          CRCHCNT: "29",
          LA: "37.5320088434",
          LO: "126.8937951748",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000455",
          CRNAME: "아르미어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07214",
          CRADDR: "서울특별시 영등포구 당산동5가 당산로 214",
          CRTELNO: "02-2068-5515",
          CRFAXNO: "02-2068-5515",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "74",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "28",
          CRCHCNT: "26",
          LA: "37.5329320445",
          LO: "126.9028359571",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000457",
          CRNAME: "신길삼성어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07362",
          CRADDR: "서울특별시 영등포구 가마산로79길 7 삼성래미안아파트 관리동",
          CRTELNO: "02-841-8386",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "28",
          CRCHCNT: "27",
          LA: "37.504081787981455",
          LO: "126.92209963443078",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000453",
          CRNAME: "드림타운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07365",
          CRADDR: "서울특별시 영등포구 도신로29길 28 대우푸르지오 1단지",
          CRTELNO: "02-6746-1004",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "27",
          CRCHCNT: "27",
          LA: "37.5117544634",
          LO: "126.9023250258",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000454",
          CRNAME: "푸르지오어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07226",
          CRADDR: "서울특별시 영등포구 영등포동8가 영중로 154 당산푸르지오아파트 관리동",
          CRTELNO: "02-2677-3927",
          CRFAXNO: "02-2677-3927",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "103",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "39",
          CRCHCNT: "30",
          LA: "37.5311867152",
          LO: "126.9060648785",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000241",
          CRNAME: "구립아이원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01198",
          CRADDR: "서울특별시 강북구 삼양로19길 113 102동 102호(미아동1357, 삼각산아이원아파트)",
          CRTELNO: "02-6086-7700",
          CRFAXNO: "02-984-7711",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "12",
          LA: "37.61631846139443",
          LO: "127.01831220821827",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 12.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 17.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000159",
          CRNAME: "구립슬비어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01233",
          CRADDR: "서울특별시 강북구 오패산로38길 6-15",
          CRTELNO: "02-980-1248",
          CRFAXNO: "02-6280-0934",
          CRHOME: "http://cafe.daum.net/slbeahouse",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "213",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "10",
          CRCAPAT: "49",
          CRCHCNT: "33",
          LA: "37.61488455223853",
          LO: "127.0343895926541",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000484",
          CRNAME: "상봉키움공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02079",
          CRADDR: "서울특별시 중랑구 신내로7가길 71",
          CRTELNO: "02-435-0032",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "78",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2018-01-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000755",
          CRNAME: "삼전초록어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05584",
          CRADDR: "서울특별시 송파구 백제고분로32길 6-76 (삼전동)",
          CRTELNO: "02-422-8931",
          CRFAXNO: "02-422-8942",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "175",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "15",
          CRCAPAT: "65",
          CRCHCNT: "64",
          LA: "37.4999334087",
          LO: "127.0930500472",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 64.0,
          EM_CNT_0Y: 39.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 39.0,
          EM_CNT_4Y: 8.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000756",
          CRNAME: "송파레미니스어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05720",
          CRADDR: "서울특별시 송파구 성내천로 6 1단지(오금동, 송파레미니스)",
          CRTELNO: "02-6713-6714",
          CRFAXNO: "02-6713-6715",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "204",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "14",
          CRCAPAT: "77",
          CRCHCNT: "67",
          LA: "37.50737240627916",
          LO: "127.13557099894667",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-15",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 67.0,
          EM_CNT_0Y: 9.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 91.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000504",
          CRNAME: "구립성내1동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05393",
          CRADDR: "서울특별시 강동구 풍성로 127 관리동(성내동, 성내삼성아파트)",
          CRTELNO: "02-478-0010",
          CRFAXNO: "02-478-0160",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "9",
          CRCAPAT: "25",
          CRCHCNT: "25",
          LA: "37.5320720288",
          LO: "127.1262303352",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 25.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 57.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000388",
          CRNAME: "구립 트리마제어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04773",
          CRADDR: "서울특별시 성동구 성수동1가 왕십리로 16 관리동 (성수동1가, 트리마제)",
          CRTELNO: "02-465-7717",
          CRFAXNO: "02-465-7718",
          CRHOME: "www.kidsnote.com",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "200",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "12",
          CRCAPAT: "34",
          CRCHCNT: "30",
          LA: "37.5392561544",
          LO: "127.0446711778",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 22.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000507",
          CRNAME: "구립봄빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05210",
          CRADDR: "서울특별시 강동구 아리수로97길 19 (강일동, 강일리버파크4단지아파트)",
          CRTELNO: "02-3426-7714",
          CRFAXNO: "02-3426-7717",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "148",
          PLGRDCO: "1",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "11",
          CRCAPAT: "51",
          CRCHCNT: "50",
          LA: "37.56711778683841",
          LO: "127.17641944090542",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 50.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000509",
          CRNAME: "구립도토리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05215",
          CRADDR: "서울특별시 강동구 고덕로97길 20 강일동, 강일리버파크10단지아파트",
          CRTELNO: "02-428-3944",
          CRFAXNO: "02-428-3950",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "78",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "27",
          CRCHCNT: "27",
          LA: "37.55947006263661",
          LO: "127.18122850482224",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 86.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000510",
          CRNAME: "구립태영어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05336",
          CRADDR: "서울특별시 강동구 천호대로163길 21-10 관리동(천호동, 천호태영아파트)",
          CRTELNO: "02-470-2122",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "118",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "29",
          LA: "37.55723906640136",
          LO: "126.98955384887674",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 38.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000508",
          CRNAME: "구립유진어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05213",
          CRADDR: "서울특별시 강동구 아리수로94길 19 강일동,강일리버파크6단지아파트",
          CRTELNO: "02-442-7942",
          CRFAXNO: "02-442-7952",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "23",
          CRCHCNT: "23",
          LA: "37.56409988983604",
          LO: "127.17688063227504",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000503",
          CRNAME: "구립고덕숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05277",
          CRADDR: "서울특별시 강동구 고덕로80길 134 107동 1층(상일동, 고덕숲아이파크아파트)",
          CRTELNO: "02-442-2323",
          CRFAXNO: "02-3013-2323",
          CRHOME: "키즈노트",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "183",
          PLGRDCO: "1",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "14",
          CRCAPAT: "65",
          CRCHCNT: "58",
          LA: "37.5517166524",
          LO: "127.1648581451",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 18.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000606",
          CRNAME: "오류동행복주택어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08272",
          CRADDR: "서울특별시 구로구 경인로20가길 38 1층",
          CRTELNO: "02-2088-5752",
          CRFAXNO: "02-2135-5752",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "320",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "16",
          CRCAPAT: "76",
          CRCHCNT: "66",
          LA: "37.4939419533",
          LO: "126.8412305271",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 39.0,
          EM_CNT_1Y: 31.0,
          EM_CNT_2Y: 15.0,
          EM_CNT_4Y: 15.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000340",
          CRNAME: "구립 예담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04983",
          CRADDR: "서울특별시 광진구 아차산로 537-17 광장힐스테이트 관리동",
          CRTELNO: "02-444-2008",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "23",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2018-01-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000697",
          CRNAME: "LG CNS어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07795",
          CRADDR: "서울특별시 강서구 마곡중앙10로 70",
          CRTELNO: "02-2088-4065",
          CRFAXNO: "02-2088-4063",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "120",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "12",
          CRCAPAT: "35",
          CRCHCNT: "31",
          LA: "37.562764866928084",
          LO: "126.83528276194731",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000198",
          CRNAME: "맑은숲어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04417",
          CRADDR: "서울특별시 용산구 한남대로40길 76 맑은숲어린이집",
          CRTELNO: "02-798-3500",
          CRFAXNO: "02-798-3501",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "735",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "20",
          CRCAPAT: "90",
          CRCHCNT: "86",
          LA: "37.5450381635",
          LO: "127.0032951499",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2017-12-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 17.0,
          CHILD_CNT_04: 15.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 86.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 31.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000753",
          CRNAME: "송파위례23어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05814",
          CRADDR: "서울특별시 송파구 위례순환로 477 2323동 1층(장지동, 위례포레샤인)",
          CRTELNO: "02-448-0048",
          CRFAXNO: "02-448-0041",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "316",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "28",
          CRCAPAT: "104",
          CRCHCNT: "104",
          LA: "37.475019709",
          LO: "127.1365667469",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 16.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 9.0,
          CHILD_CNT_TOT: 104.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 5.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 23.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 19.0,
          EM_CNT_A3: 3.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 29.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000754",
          CRNAME: "송파위례햇살어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05814",
          CRADDR: "서울특별시 송파구 위례순환로 477",
          CRTELNO: "02-402-0056",
          CRFAXNO: "02-407-0058",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "277",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "20",
          CRCAPAT: "95",
          CRCHCNT: "93",
          LA: "37.47562676736727",
          LO: "127.13440289035827",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 12.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 93.0,
          EM_CNT_0Y: 47.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 12.0,
          EM_CNT_4Y: 12.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 17.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 20.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000326",
          CRNAME: "별찌어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08607",
          CRADDR: "서울특별시 금천구 벚꽃로6길 3 102동 102호",
          CRTELNO: "070-8159-4578",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.4606082966",
          LO: "126.8924630167",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000419",
          CRNAME: "서초구립 반포단비어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06533",
          CRADDR: "서울특별시 서초구 주흥13길 12",
          CRTELNO: "02-585-3927",
          CRFAXNO: "02-542-3927",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "153",
          PLGRDCO: "1",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "12",
          CRCAPAT: "50",
          CRCHCNT: "38",
          LA: "37.5086759206",
          LO: "127.0185171754",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 14.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000426",
          CRNAME: "서초구립 잠원동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06529",
          CRADDR: "서울특별시 서초구 강남대로95길 75 .",
          CRTELNO: "02-523-3615",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "203",
          PLGRDCO: "1",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "12",
          CRCAPAT: "65",
          CRCHCNT: "29",
          LA: "37.5119702262",
          LO: "127.0169661519",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 2.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000420",
          CRNAME: "서초구립 방배4동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06573",
          CRADDR: "서울특별시 서초구 서초대로19길 16",
          CRTELNO: "02-523-6545",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "180",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "65",
          CRCHCNT: "58",
          LA: "37.4878277609",
          LO: "126.9912618523",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 46.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 18.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000617",
          CRNAME: "안암래미안어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02843",
          CRADDR: "서울특별시 성북구 고려대로17가길 64 안암래미안아파트 관리동 1층",
          CRTELNO: "02-927-8179",
          CRFAXNO: "02-927-8179",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "120",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "9",
          CRCAPAT: "30",
          CRCHCNT: "26",
          LA: "37.589285550246274",
          LO: "127.02364129113732",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 26.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000418",
          CRNAME: "서초구립 도구머리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06690",
          CRADDR: "서울특별시 서초구 청두곶2길 33",
          CRTELNO: "02-588-5952",
          CRFAXNO: "02-587-5952",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "191",
          PLGRDCO: "3",
          CCTVINSTLCNT: "25",
          CHCRTESCNT: "21",
          CRCAPAT: "72",
          CRCHCNT: "71",
          LA: "37.4786226852",
          LO: "126.9871928579",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 18.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 71.0,
          EM_CNT_0Y: 35.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 12.0,
          EM_CNT_4Y: 35.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 21.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000417",
          CRNAME: "서초구립 내곡연두어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06800",
          CRADDR: "서울특별시 서초구 헌릉로 226 1층",
          CRTELNO: "02-529-0081",
          CRFAXNO: "02-529-0082",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "300",
          PLGRDCO: "1",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "16",
          CRCAPAT: "88",
          CRCHCNT: "81",
          LA: "37.45461533995891",
          LO: "127.06470748859125",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 18.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 81.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 16.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000384",
          CRNAME: "구립 이편한세상금호어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04727",
          CRADDR: "서울특별시 성동구 금호로 140 (금호동1가, e편한세상 금호파크힐스아파트 104동 앞)",
          CRTELNO: "02-2282-2018",
          CRFAXNO: "",
          CRHOME: "http://cafe.daum.net/i-love2018",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "146",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "10",
          CRCAPAT: "43",
          CRCHCNT: "35",
          LA: "37.55532274466242",
          LO: "127.02260634065662",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 57.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000385",
          CRNAME: "구립 힐스테이트서울숲리버어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04743",
          CRADDR: "서울특별시 성동구 금호동4가 금호로 40 힐스테이트서울숲리버아파트 관리동",
          CRTELNO: "02-2295-7100",
          CRFAXNO: "02-2295-7101",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "206",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "12",
          CRCAPAT: "60",
          CRCHCNT: "39",
          LA: "37.5467040992",
          LO: "127.0255334536",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 44.0,
          EM_CNT_2Y: 22.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000616",
          CRNAME: "코오롱하늘채어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "02757",
          CRADDR: "서울특별시 성북구 돌곶이로 220 코오롱하늘채아파트 관리동어린이집",
          CRTELNO: "02-909-2700",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "401",
          PLGRDCO: "3",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "0",
          CRCAPAT: "93",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-01-31",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000630",
          CRNAME: "구립 폭포동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03310",
          CRADDR: "서울특별시 은평구 진관1로 77-8 폭포동4-1단지아파트내 관리동1층 부대복리시설",
          CRTELNO: "02-352-5233",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "105",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "12",
          CRCAPAT: "39",
          CRCHCNT: "29",
          LA: "37.6313653265",
          LO: "126.9305950077",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 3.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000450",
          CRNAME: "금나래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07350",
          CRADDR: "서울특별시 영등포구 도신로60길 17-12",
          CRTELNO: "02-844-2018",
          CRFAXNO: "02-834-2018",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "144",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "14",
          CRCAPAT: "45",
          CRCHCNT: "37",
          LA: "37.5104366213",
          LO: "126.9181705375",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 18.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000451",
          CRNAME: "다온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07415",
          CRADDR: "서울특별시 영등포구 도림로39길 11-13",
          CRTELNO: "02-831-0462",
          CRFAXNO: "02-831-0461",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "209",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "18",
          CRCAPAT: "79",
          CRCHCNT: "77",
          LA: "37.4945442062",
          LO: "126.8968426434",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 19.0,
          CHILD_CNT_05: 17.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 77.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 47.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000441",
          CRNAME: "한샘어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03929",
          CRADDR: "서울특별시 마포구 성암로 179",
          CRTELNO: "02-6470-6300",
          CRFAXNO: "02-6470-6305",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "320",
          PLGRDCO: "2",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "14",
          CRCAPAT: "70",
          CRCHCNT: "50",
          LA: "37.5761512717",
          LO: "126.8987633275",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 10.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 50.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000597",
          CRNAME: "구립 해누리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08094",
          CRADDR: "서울특별시 양천구 목동동로 81",
          CRTELNO: "02-2062-0102",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "150",
          PLGRDCO: "3",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "45",
          LA: "37.5159763328",
          LO: "126.8638563534",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000629",
          CRNAME: "구립 비단산어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03446",
          CRADDR: "서울특별시 은평구 은평터널로7가길 6",
          CRTELNO: "02-376-9993",
          CRFAXNO: "02-376-9994",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "123",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "12",
          CRCAPAT: "45",
          CRCHCNT: "40",
          LA: "37.5921280021",
          LO: "126.9034520092",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 40.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 67.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000628",
          CRNAME: "구립 북한산어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03366",
          CRADDR: "서울특별시 은평구 진흥로 265 주민공동시설 중 어린이집(불광동, 북한산래미안아파트)",
          CRTELNO: "02-353-8860",
          CRFAXNO: "02-353-8861",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "10",
          CRCAPAT: "22",
          CRCHCNT: "22",
          LA: "37.611669587",
          LO: "126.9367292736",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000386",
          CRNAME: "구립 텐즈아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04702",
          CRADDR: "서울특별시 성동구 무학로 33 114동 1층 (하왕십리동, 텐즈힐1단지)",
          CRTELNO: "02-2282-2114",
          CRFAXNO: "02-2282-2115",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "225",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "15",
          CRCAPAT: "70",
          CRCHCNT: "47",
          LA: "37.5691639797",
          LO: "127.0263470607",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 6.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 8.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000197",
          CRNAME: "아모레퍼시픽 서울어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04386",
          CRADDR: "서울특별시 용산구 한강대로 100 (주)아모레퍼시픽 2층",
          CRTELNO: "02-709-5193",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "305",
          PLGRDCO: "1",
          CCTVINSTLCNT: "35",
          CHCRTESCNT: "28",
          CRCAPAT: "94",
          CRCHCNT: "72",
          LA: "37.5287908187",
          LO: "126.9686757151",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-05",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 8.0,
          CLASS_CNT_02: 6.0,
          CLASS_CNT_03: 4.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 19.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 24.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 20.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 72.0,
          EM_CNT_0Y: 59.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 18.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 22.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 28.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000502",
          CRNAME: "구립다온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05245",
          CRADDR: "서울특별시 강동구 올림픽로79길 46",
          CRTELNO: "02-489-1712",
          CRFAXNO: "02-489-1712",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "170",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "12",
          CRCAPAT: "59",
          CRCHCNT: "54",
          LA: "37.5447901168",
          LO: "127.123219164",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 70.0,
          EM_CNT_1Y: 10.0,
          EM_CNT_2Y: 10.0,
          EM_CNT_4Y: 10.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000633",
          CRNAME: "구립 다음어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03366",
          CRADDR: "서울특별시 은평구 진흥로 267 (불광1동, 북한산래미안                1단지아파트) 주민공동시설 중 어린이집",
          CRTELNO: "02-388-2277",
          CRFAXNO: "02-6929-2278",
          CRHOME: "http://cafe.naver.com/daumchild",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "96",
          PLGRDCO: "0",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "12",
          CRCAPAT: "27",
          CRCHCNT: "27",
          LA: "37.6118509164",
          LO: "126.9388765061",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 27.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 44.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000195",
          CRNAME: "꿈나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04316",
          CRADDR: "서울특별시 용산구 원효로1가 백범로 329 꿈나무어린이집",
          CRTELNO: "02-706-2468",
          CRFAXNO: "02-706-2467",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "420",
          PLGRDCO: "1",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "18",
          CRCAPAT: "60",
          CRCHCNT: "60",
          LA: "37.538396941434364",
          LO: "126.96579265701348",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 60.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000596",
          CRNAME: "구립 꿈초롱어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08054",
          CRADDR: "서울특별시 양천구 신정로11길 20 202동 104호",
          CRTELNO: "02-6091-0102",
          CRFAXNO: "02-6091-4102",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "67",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.511315169332",
          LO: "126.83992580984001",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 38.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000338",
          CRNAME: "구립 굿모닝어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04971",
          CRADDR: "서울특별시 광진구 아차산로 552 2동105호(광장동, 광장극동아파트)",
          CRTELNO: "02-458-6169",
          CRFAXNO: "02-458-6168",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.54258285625199",
          LO: "127.10278051118978",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000339",
          CRNAME: "구립 샘터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04984",
          CRADDR: "서울특별시 광진구 아차산로 503-23 102동 102호(광장동,청구아파트)",
          CRTELNO: "02-456-4566",
          CRFAXNO: "02-456-4568",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "85",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "16",
          LA: "37.5431614673",
          LO: "127.0956067292",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 40.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001018",
          CRNAME: "초안숲속어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01866",
          CRADDR: "서울특별시 노원구 마들로5길 25 (월계동, 두산위브아파트)",
          CRTELNO: "02-990-0502",
          CRFAXNO: "02-990-0503",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "16",
          LA: "37.6409822741",
          LO: "127.0522553361",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-12-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 12.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000751",
          CRNAME: "파크리오어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05507",
          CRADDR: "서울특별시 송파구 올림픽로 435 112동 102호(신천동, 파크리오아파트)",
          CRTELNO: "02-418-7710",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5213601057",
          LO: "127.104972539",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-11-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000449",
          CRNAME: "NH투자증권어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07325",
          CRADDR: "서울특별시 영등포구 여의대로 66 2층",
          CRTELNO: "02-761-9433",
          CRFAXNO: "02-761-9434",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "179",
          PLGRDCO: "0",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "23",
          LA: "37.52461445957741",
          LO: "126.92370731477659",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-11-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 23.0,
          EM_CNT_0Y: 11.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 56.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000752",
          CRNAME: "풍납또래어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05514",
          CRADDR: "서울특별시 송파구 한가람로 478 101동 109호(풍납동, 씨티극동아파트)",
          CRTELNO: "02-485-9540",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "102",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5397355298",
          LO: "127.1179063951",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-11-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 57.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000696",
          CRNAME: "마곡13 하나어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 (마곡동, 마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2666-4521",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "9",
          NRTRROOMSIZE: "317",
          PLGRDCO: "0",
          CCTVINSTLCNT: "22",
          CHCRTESCNT: "23",
          CRCAPAT: "120",
          CRCHCNT: "111",
          LA: "37.55789162665938",
          LO: "126.81767184323118",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 30.0,
          CHILD_CNT_05: 37.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 111.0,
          EM_CNT_0Y: 59.0,
          EM_CNT_1Y: 12.0,
          EM_CNT_2Y: 24.0,
          EM_CNT_4Y: 6.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 17.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 23.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000196",
          CRNAME: "용문어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04363",
          CRADDR: "서울특별시 용산구 효창원로 88 브라운스톤용산 104-103",
          CRTELNO: "02-711-3136",
          CRFAXNO: "02-715-3136",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 67.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000544",
          CRNAME: "구립조은어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08734",
          CRADDR: "서울특별시 관악구 관악로30길 27 관악푸르지오아파트 1단지 관리동(122동 123동 사이)",
          CRTELNO: "02-875-9199",
          CRFAXNO: "02-875-9198",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "80",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "29",
          CRCHCNT: "29",
          LA: "37.48658967172006",
          LO: "126.96010911531094",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000413",
          CRNAME: "서초구립 방배본동신나는어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06560",
          CRADDR: "서울특별시 서초구 동광로11길 23 .",
          CRTELNO: "02-534-8450",
          CRFAXNO: "02-534-8451",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "171",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "57",
          CRCHCNT: "50",
          LA: "37.4922241542",
          LO: "126.9858516936",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-11-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 10.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 50.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 22.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000474",
          CRNAME: "놀이존어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06072",
          CRADDR: "서울특별시 강남구 영동대로141길 5",
          CRTELNO: "070-4837-0620",
          CRFAXNO: "070-4827-0622",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "180",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "11",
          CRCAPAT: "49",
          CRCHCNT: "24",
          LA: "37.5232755739",
          LO: "127.0542817753",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-10-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 3.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 3.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000109",
          CRNAME: "LG서울역어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04637",
          CRADDR: "서울특별시 중구 남대문로5가 후암로 98 2층",
          CRTELNO: "02-3789-1002",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "177",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "13",
          CRCAPAT: "49",
          CRCHCNT: "31",
          LA: "37.55395945981493",
          LO: "126.9747967942587",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-10-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 6.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 31.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 30.0,
          EM_CNT_4Y: 10.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000382",
          CRNAME: "공룡 어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04734",
          CRADDR: "서울특별시 성동구 독서당로 218 107동 104호(옥수동, 삼성아파트)",
          CRTELNO: "02-2298-8212",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.54300059149875",
          LO: "127.01465068423069",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-10-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000369",
          CRNAME: "동화속어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "휴지",
          ZIPCODE: "06202",
          CRADDR: "서울특별시 강남구 역삼로 456-2 1층",
          CRTELNO: "02-2247-0008",
          CRFAXNO: "02-2247-0008",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "76",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "21",
          CRCHCNT: "0",
          LA: "37.500372605033505",
          LO: "127.06054848121488",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-10-02",
          CRPAUSEBEGINDT: "2022-10-05",
          CRPAUSEENDDT: "2023-10-04",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 6.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 15.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000421",
          CRNAME: "구립장미어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06990",
          CRADDR: "서울특별시 동작구 동작대로29길 115",
          CRTELNO: "02-596-1116",
          CRFAXNO: "02-596-1161",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000421",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "19",
          CRCHCNT: "19",
          LA: "37.489188942035454",
          LO: "126.97635071505641",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 80.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000420",
          CRNAME: "구립백합어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06990",
          CRADDR: "서울특별시 동작구 동작대로29길 119 110동 105호 (사당동, 극동아파트)",
          CRTELNO: "02-596-9117",
          CRFAXNO: "02-596-9117",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000420",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "70",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.49006703749307",
          LO: "126.97449036036143",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-10-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 40.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000383",
          CRNAME: "서울교통공사 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04806",
          CRADDR: "서울특별시 성동구 자동차시장길 22 인재개발원 1층",
          CRTELNO: "02-6110-8093",
          CRFAXNO: "02-6110-8098",
          CRHOME: "https://metrokids.modoo.at/",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "150",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "49",
          CRCHCNT: "19",
          LA: "37.56179409647753",
          LO: "127.05643302079545",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 3.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000546",
          CRNAME: "구립강감찬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08790",
          CRADDR: "서울특별시 관악구 관악로8길 45",
          CRTELNO: "02-873-6677",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "239",
          PLGRDCO: "2",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "12",
          CRCAPAT: "79",
          CRCHCNT: "54",
          LA: "37.4756127973",
          LO: "126.9553983852",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001017",
          CRNAME: "서울테크노파크친친어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01811",
          CRADDR: "서울특별시 노원구 공릉로 232 (공릉동, 서울과기대 내 서울테크노파크친친 어린이집)",
          CRTELNO: "02-944-6100",
          CRFAXNO: "02-944-6103",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "210",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "9",
          CRCAPAT: "70",
          CRCHCNT: "22",
          LA: "37.63307983",
          LO: "127.0767931577",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000545",
          CRNAME: "구립장군봉어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08783",
          CRADDR: "서울특별시 관악구 장군봉길 100",
          CRTELNO: "02-875-0960",
          CRFAXNO: "02-871-0960",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "275",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "19",
          CRCAPAT: "91",
          CRCHCNT: "54",
          LA: "37.4787555564",
          LO: "126.9393061617",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2017-09-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 5.0,
          CLASS_CNT_SP: 6.0,
          CLASS_CNT_TOT: 19.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 9.0,
          CHILD_CNT_TOT: 54.0,
          EM_CNT_0Y: 85.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 8.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 2.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000695",
          CRNAME: "해피랜드어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1312동 106호(마곡동,마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2667-0008",
          CRFAXNO: "02-2665-2088",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.55808573162723",
          LO: "126.81939166373981",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000415",
          CRNAME: "우성어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06760",
          CRADDR: "서울특별시 서초구 방배선행길 1 102동 103호(방배동,우성아파트)",
          CRTELNO: "02-588-8979",
          CRFAXNO: "02-588-8979",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "67",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.4741098413",
          LO: "126.9825992517",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000448",
          CRNAME: "아크로타워어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07247",
          CRADDR: "서울특별시 영등포구 영등포동7가 국회대로54길 11 아크로타워스퀘어아파트 관리동어린이집",
          CRTELNO: "02-2677-9207",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "276",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "13",
          CRCAPAT: "74",
          CRCHCNT: "61",
          LA: "37.5243334406",
          LO: "126.9080282944",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 28.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 61.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 10.0,
          EM_CNT_4Y: 10.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000749",
          CRNAME: "송파더샵어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05852",
          CRADDR: "서울특별시 송파구 위례광장로 270 103동 1층",
          CRTELNO: "02-3012-7776",
          CRFAXNO: "02-3012-7776",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "119",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "13",
          CRCAPAT: "35",
          CRCHCNT: "35",
          LA: "37.47611949756507",
          LO: "127.14350882224677",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 60.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000750",
          CRNAME: "송파아이별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05849",
          CRADDR: "서울특별시 송파구 위례광장로 230 204동 1층",
          CRTELNO: "02-404-5556",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "286",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "17",
          CRCAPAT: "78",
          CRCHCNT: "76",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 17.0,
          CHILD_CNT_05: 18.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 76.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 21.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000526",
          CRNAME: "한그루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01431",
          CRADDR: "서울특별시 도봉구 도봉로131길 86",
          CRTELNO: "02-907-2720",
          CRFAXNO: "02-907-2721",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "180",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "17",
          CRCAPAT: "67",
          CRCHCNT: "66",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 3.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 15.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 9.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 42.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 1.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:06.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000419",
          CRNAME: "구립해와별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06917",
          CRADDR: "서울특별시 동작구 만양로8길 50",
          CRTELNO: "02-817-4972",
          CRFAXNO: "02-811-1312",
          CRHOME: "https://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000419",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.56749990836573",
          LO: "126.97842568280833",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 11.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 44.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000444",
          CRNAME: "영은어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07271",
          CRADDR: "서울특별시 영등포구 양평동3가 양산로 61",
          CRTELNO: "02-2633-6966",
          CRFAXNO: "02-2632-5715",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "191",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "13",
          CRCAPAT: "45",
          CRCHCNT: "39",
          LA: "37.5252874944",
          LO: "126.8899900369",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 10.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 10.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000475",
          CRNAME: "한울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06280",
          CRADDR: "서울특별시 강남구 삼성로51길 25 대치SK-VIEW아파트 관리동",
          CRTELNO: "02-565-0302",
          CRFAXNO: "02-564-0302",
          CRHOME: "http://gncare.go.kr/ghanul",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "181",
          PLGRDCO: "1",
          CCTVINSTLCNT: "24",
          CHCRTESCNT: "17",
          CRCAPAT: "68",
          CRCHCNT: "57",
          LA: "37.49598322713887",
          LO: "127.05991166942247",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 8.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 57.0,
          EM_CNT_0Y: 62.0,
          EM_CNT_1Y: 15.0,
          EM_CNT_2Y: 15.0,
          EM_CNT_4Y: 8.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 09:13:36.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000604",
          CRNAME: "키즈극동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08312",
          CRADDR: "서울특별시 구로구 구로중앙로7길 28 1동 101호(구로동, 극동아파트)",
          CRTELNO: "02-6347-5001",
          CRFAXNO: "02-6091-7725",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "16",
          LA: "37.4912796333",
          LO: "126.8896147652",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 3.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:16.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000414",
          CRNAME: "서초구립 서초1동하은어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06632",
          CRADDR: "서울특별시 서초구 서초대로58길 35-6 .",
          CRTELNO: "02-3473-1757",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "255",
          PLGRDCO: "2",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "12",
          CRCAPAT: "77",
          CRCHCNT: "63",
          LA: "37.494120720969285",
          LO: "127.01786675935651",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 20.0,
          CHILD_CNT_04: 10.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 63.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000407",
          CRNAME: "서초구립 서초3동어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06670",
          CRADDR: "서울특별시 서초구 반포대로13길 64 서초구립 서초3동어린이집",
          CRTELNO: "02-522-5665",
          CRFAXNO: "02-522-5665",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "173",
          PLGRDCO: "1",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "13",
          CRCAPAT: "61",
          CRCHCNT: "47",
          LA: "37.48519734635416",
          LO: "127.00759812289571",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 12.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 47.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 9.0,
          EM_CNT_4Y: 27.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000410",
          CRNAME: "서초구립 서초4동써밋1어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06608",
          CRADDR: "서울특별시 서초구 서운로 201 (서초4동, 푸르지오써밋아파트)",
          CRTELNO: "02-6933-6447",
          CRFAXNO: "02-6949-6447",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "162",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "10",
          CRCAPAT: "54",
          CRCHCNT: "38",
          LA: "37.501306830141495",
          LO: "127.02115802315722",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000412",
          CRNAME: "서초구립 서초4동써밋2어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06610",
          CRADDR: "서울특별시 서초구 서운로 212 (서초4동, 서초푸르지오써밋아파트)",
          CRTELNO: "02-6930-5651",
          CRFAXNO: "02-6930-5652",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "118",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "8",
          CRCAPAT: "30",
          CRCHCNT: "20",
          LA: "37.501816695252145",
          LO: "127.02292382148658",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 67.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000408",
          CRNAME: "서초구립 서초4동행복어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06601",
          CRADDR: "서울특별시 서초구 서초중앙로 200 3동 106호(서초동, 삼풍아파트)",
          CRTELNO: "02-537-1240",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "48",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.49846608534648",
          LO: "127.01605839769846",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000615",
          CRNAME: "국민대학교부설어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "02714",
          CRADDR: "서울특별시 성북구 길음로 119 216동 102호",
          CRTELNO: "02-910-4373",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "2",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "13",
          CRCHCNT: "0",
          LA: "37.6103891235",
          LO: "127.0000588934",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-03-02",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:45.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000595",
          CRNAME: "구립 꽃별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07900",
          CRADDR: "서울특별시 양천구 화곡로3길 43 103동 103호",
          CRTELNO: "02-2603-9933",
          CRFAXNO: "02-2603-6633",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "43",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "6",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.543628821833224",
          LO: "126.82817345375274",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 40.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000440",
          CRNAME: "홍익어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04060",
          CRADDR: "서울특별시 마포구 서강로9길 45 태영아파트 내 보육시설",
          CRTELNO: "02-3141-7770",
          CRFAXNO: "02-3141-7710",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "114",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "8",
          CRCAPAT: "32",
          CRCHCNT: "21",
          LA: "37.552658738",
          LO: "126.9313787633",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 21.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000594",
          CRNAME: "구립 별하어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08097",
          CRADDR: "서울특별시 양천구 목동동로 50 1220동 107호",
          CRTELNO: "02-2647-8900",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "71",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.5120942492",
          LO: "126.8602891992",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000411",
          CRNAME: "서초구립 반포1동주민센터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06544",
          CRADDR: "서울특별시 서초구 사평대로 273",
          CRTELNO: "02-534-8895",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "241",
          PLGRDCO: "2",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "17",
          CRCAPAT: "88",
          CRCHCNT: "66",
          LA: "37.50503925489784",
          LO: "127.01339636594457",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 16.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 17.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 66.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 21.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000406",
          CRNAME: "서초구립 느티나무어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06638",
          CRADDR: "서울특별시 서초구 사임당로19길 126",
          CRTELNO: "02-523-0100",
          CRFAXNO: "02-523-0109",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "125",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "10",
          CRCAPAT: "44",
          CRCHCNT: "29",
          LA: "37.49230711593786",
          LO: "127.01991869340803",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 5.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 29.0,
          EM_CNT_0Y: 75.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000337",
          CRNAME: "구립 구의1동 아이터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05023",
          CRADDR: "서울특별시 광진구 자양로23길 79",
          CRTELNO: "02-2201-8684",
          CRFAXNO: "02-2201-8683",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "289",
          PLGRDCO: "0",
          CCTVINSTLCNT: "19",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "41",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 7.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000249",
          CRNAME: "햇빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02533",
          CRADDR: "서울특별시 동대문구 사가정로 190 16동 108호(전농동, 우성아파트)",
          CRTELNO: "02-2242-0089",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "43",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "6",
          CRCAPAT: "16",
          CRCHCNT: "8",
          LA: "37.57727289",
          LO: "127.065358",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 8.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 40.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 20.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000466",
          CRNAME: "한울어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02638",
          CRADDR: "서울특별시 동대문구 장안벚꽃로 107 102동 101호(장안동,현대홈타운)",
          CRTELNO: "02-6457-0087",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "13",
          LA: "37.5710567385",
          LO: "127.0751129785",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000465",
          CRNAME: "아이미소어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02508",
          CRADDR: "서울특별시 동대문구 전농로16길 51 107동 104호(전농동,래미안아름숲)",
          CRTELNO: "02-2212-2293",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "111",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "1",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5783343868",
          LO: "127.0604394791",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 100.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 1.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000252",
          CRNAME: "신나는어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02427",
          CRADDR: "서울특별시 동대문구 외대역동로 101 102동 102호(이문동, 중앙하이츠아파트)",
          CRTELNO: "02-969-5906",
          CRFAXNO: "070-4410-5277",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "62",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.59644915",
          LO: "127.0646052",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 7.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 43.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 29.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000409",
          CRNAME: "서초구립 반포미도어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06592",
          CRADDR: "서울특별시 서초구 서초중앙로29길 28 303동 108호(반포동, 반포미도아파트)",
          CRTELNO: "02-595-2237",
          CRFAXNO: "02-595-2237",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "18",
          CRCHCNT: "8",
          LA: "37.50091990159365",
          LO: "127.00790506150648",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 8.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000467",
          CRNAME: "누리보듬어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02521",
          CRADDR: "서울특별시 동대문구 장안벚꽃로1길 7 1003동 104호(장안동, 힐스테이트아파트)",
          CRTELNO: "02-2212-1256",
          CRFAXNO: "02-2212-1259",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.57647898630614",
          LO: "127.07501540802064",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 57.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000438",
          CRNAME: "도토리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04019",
          CRADDR: "서울특별시 마포구 희우정로 53-6",
          CRTELNO: "02-322-0556",
          CRFAXNO: "02-325-0595",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "270",
          PLGRDCO: "8",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "14",
          CRCAPAT: "99",
          CRCHCNT: "61",
          LA: "37.5513650028",
          LO: "126.9054420373",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 11.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 61.0,
          EM_CNT_0Y: 9.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 9.0,
          EM_CNT_4Y: 82.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000437",
          CRNAME: "리버웰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04161",
          CRADDR: "서울특별시 마포구 토정로31길 23 래미안마포리버웰 관리동어린이집",
          CRTELNO: "02-711-6161",
          CRFAXNO: "02-711-9110",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "253",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "15",
          CRCAPAT: "76",
          CRCHCNT: "55",
          LA: "37.5416648648",
          LO: "126.9416449835",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 9.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 42.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000439",
          CRNAME: "삼성어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03905",
          CRADDR: "서울특별시 마포구 상암산로1길 57 상암월드컵6단지 610동 1층",
          CRTELNO: "02-307-7101",
          CRFAXNO: "02-307-7102",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "6",
          CRCAPAT: "37",
          CRCHCNT: "10",
          LA: "37.580284186",
          LO: "126.8823059254",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-09-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 10.0,
          EM_CNT_0Y: 100.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "종로구",
          STCODE: "11110000170",
          CRNAME: "SC으뜸별 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03160",
          CRADDR: "서울특별시 종로구 종로 47",
          CRTELNO: "02-3210-0904",
          CRFAXNO: "02-3210-0901",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "149",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "12",
          LA: "37.5711261798",
          LO: "126.9824408691",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-31",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 2.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 12.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 33.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:01:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000436",
          CRNAME: "햇살가득어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04169",
          CRADDR: "서울특별시 마포구 새창로6길 16 새창로6길 15(추후수정-도로명연동불가)",
          CRTELNO: "02-719-9995",
          CRFAXNO: "",
          CRHOME: "www.puruni.com/s-oil",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "207",
          PLGRDCO: "5",
          CCTVINSTLCNT: "35",
          CHCRTESCNT: "19",
          CRCAPAT: "75",
          CRCHCNT: "52",
          LA: "37.5414175495",
          LO: "126.9527476639",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 7.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 20.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 52.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 6.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 19.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000748",
          CRNAME: "문정훼밀리타운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05834",
          CRADDR: "서울특별시 송파구 중대로 24 228동 102호",
          CRTELNO: "02-404-5600",
          CRFAXNO: "02-404-7878",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4881254764",
          LO: "127.1110590234",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000605",
          CRNAME: "꿈사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08276",
          CRADDR: "서울특별시 구로구 경인로40길 11 101동 104호",
          CRTELNO: "02-6734-4757",
          CRFAXNO: "0504-082-4753",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "56",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4960553367",
          LO: "126.8594234615",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000603",
          CRNAME: "경남큰사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08342",
          CRADDR: "서울특별시 구로구 오류로 65 105동 101호(오류동, 경남아너스빌)",
          CRTELNO: "02-2066-2081",
          CRFAXNO: "02-2614-2080",
          CRHOME: "zz2081@ hanmail.net",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "68",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4906463706",
          LO: "126.8401157948",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000447",
          CRNAME: "래미안어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07390",
          CRADDR: "서울특별시 영등포구 신풍로 77 래미안에스티움 110동 101호",
          CRTELNO: "02-6449-2345",
          CRFAXNO: "070-8240-2345",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5004198781",
          LO: "126.9115453356",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 60.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000694",
          CRNAME: "센트럴어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1303동 103호(마곡동,마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2663-6999",
          CRFAXNO: "02-2663-6998",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.556909852",
          LO: "126.8178734241",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-08-31",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000444",
          CRNAME: "아름뜰어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02080",
          CRADDR: "서울특별시 중랑구 상봉중앙로8길 76 1509동 101호 (상봉동)",
          CRTELNO: "02-6231-2848",
          CRFAXNO: "02-3421-9390",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.6027060794",
          LO: "127.0914656404",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 4.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 7.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000445",
          CRNAME: "예쁜별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02054",
          CRADDR: "서울특별시 중랑구 신내로 110 13동 106호(신내동, 동성아파트)",
          CRTELNO: "02-438-5751",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.6097984319",
          LO: "127.0962944847",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-08-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000483",
          CRNAME: "먹골꼬마공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02030",
          CRADDR: "서울특별시 중랑구 공릉로12가길 70-15",
          CRTELNO: "02-949-0032",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "49",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2017-08-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000446",
          CRNAME: "푸르름어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07405",
          CRADDR: "서울특별시 영등포구 도림로81길 12-1",
          CRTELNO: "02-833-2446",
          CRFAXNO: "02-833-2446",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "145",
          PLGRDCO: "0",
          CCTVINSTLCNT: "17",
          CHCRTESCNT: "13",
          CRCAPAT: "48",
          CRCHCNT: "36",
          LA: "37.5014191105",
          LO: "126.9035101208",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 7.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 27.0,
          EM_CNT_1Y: 9.0,
          EM_CNT_2Y: 46.0,
          EM_CNT_4Y: 18.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000445",
          CRNAME: "하람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07390",
          CRADDR: "서울특별시 영등포구 신풍로 77 114동 106호",
          CRTELNO: "02-835-9922",
          CRFAXNO: "02-835-9966",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "10",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.5004198781",
          LO: "126.9115453356",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000381",
          CRNAME: "구립 왕십리자이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04711",
          CRADDR: "서울특별시 성동구 난계로 100",
          CRTELNO: "02-2296-0901",
          CRFAXNO: "02-2296-0905",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "222",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "10",
          CRCAPAT: "50",
          CRCHCNT: "37",
          LA: "37.56066971614554",
          LO: "127.02483196774351",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 2.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 13.0,
          EM_CNT_1Y: 50.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000628",
          CRNAME: "해우리장난감도서관공동육아방(양천구육아종합지원센터)",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07958",
          CRADDR: "서울특별시 양천구 목동중앙남로 57-10 2층",
          CRTELNO: "02-2062-9010",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "432",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2017-07-17",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:56.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000501",
          CRNAME: "구립꿈마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05340",
          CRADDR: "서울특별시 강동구 천호대로 1077 101동 1층(천호동, 래미안강동팰리스)",
          CRTELNO: "02-477-0713",
          CRFAXNO: "02-477-0712",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "290",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "17",
          CRCAPAT: "70",
          CRCHCNT: "67",
          LA: "37.5372561075",
          LO: "127.1314392536",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-13",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 18.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 67.0,
          EM_CNT_0Y: 15.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 23.0,
          EM_CNT_4Y: 54.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 2.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000443",
          CRNAME: "화랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02030",
          CRADDR: "서울특별시 중랑구 숙선옹주로 45 108동(묵동, e편한세상 화랑대)",
          CRTELNO: "02-979-7802",
          CRFAXNO: "02-979-7803",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "108",
          PLGRDCO: "0",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "15",
          CRCAPAT: "40",
          CRCHCNT: "38",
          LA: "37.6157084078",
          LO: "127.0827103544",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 38.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:02:36.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000349",
          CRNAME: "솔빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03771",
          CRADDR: "서울특별시 서대문구 북아현로 29 e편한세상신촌3단지 302동",
          CRTELNO: "02-313-4800",
          CRFAXNO: "02-392-2774",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "109",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "11",
          CRCAPAT: "35",
          CRCHCNT: "33",
          LA: "37.55934430540307",
          LO: "126.95636939911608",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 33.0,
          EM_CNT_0Y: 56.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000417",
          CRNAME: "구립새빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06937",
          CRADDR: "서울특별시 동작구 장승배기로11가길 11",
          CRTELNO: "02-827-0791",
          CRFAXNO: "02-827-0793",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11590000417",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "128",
          PLGRDCO: "0",
          CCTVINSTLCNT: "11",
          CHCRTESCNT: "11",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.5055657216",
          LO: "126.9389089785",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,휴일보육",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "동작구",
          STCODE: "11590000418",
          CRNAME: "구립강남어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06914",
          CRADDR: "서울특별시 동작구 만양로12길 5-12",
          CRTELNO: "02-814-7615",
          CRFAXNO: "02-812-7615",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "228",
          PLGRDCO: "1",
          CCTVINSTLCNT: "15",
          CHCRTESCNT: "12",
          CRCAPAT: "74",
          CRCHCNT: "52",
          LA: "37.5102325501",
          LO: "126.9455059855",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 12.0,
          CHILD_CNT_04: 9.0,
          CHILD_CNT_05: 16.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 52.0,
          EM_CNT_0Y: 78.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 09:19:45.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000350",
          CRNAME: "별빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03772",
          CRADDR: "서울특별시 서대문구 신촌로35길 10",
          CRTELNO: "02-364-1231",
          CRFAXNO: "02-364-1232",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "97",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "12",
          CRCAPAT: "30",
          CRCHCNT: "28",
          LA: "37.557564697878675",
          LO: "126.95599695414017",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 28.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 22.0,
          EM_CNT_2Y: 11.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000192",
          CRNAME: "새순어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04361",
          CRADDR: "서울특별시 용산구 원효로35길 37-7 1,2층",
          CRTELNO: "02-716-7930",
          CRFAXNO: "02-717-7930",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "130",
          PLGRDCO: "1",
          CCTVINSTLCNT: "9",
          CHCRTESCNT: "11",
          CRCAPAT: "40",
          CRCHCNT: "30",
          LA: "37.5348941342334",
          LO: "126.95519141061648",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 22.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000348",
          CRNAME: "은빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03773",
          CRADDR: "서울특별시 서대문구 북아현로1길 17",
          CRTELNO: "02-313-7500",
          CRFAXNO: "02-312-7176",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "130",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "11",
          CRCAPAT: "45",
          CRCHCNT: "41",
          LA: "37.55828476823861",
          LO: "126.95408665800543",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 41.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 22.0,
          EM_CNT_4Y: 44.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000347",
          CRNAME: "숲속어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03635",
          CRADDR: "서울특별시 서대문구 통일로 348 청구아파트",
          CRTELNO: "02-396-9333",
          CRFAXNO: "02-396-9334",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "372",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "11",
          CRCAPAT: "86",
          CRCHCNT: "44",
          LA: "37.58321881565442",
          LO: "126.95159476298113",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 10.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 9.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "서대문구",
          STCODE: "11410000351",
          CRNAME: "푸른빛어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03768",
          CRADDR: "서울특별시 서대문구 북아현로1가길 20 e편한세상신촌 102동",
          CRTELNO: "02-313-9200",
          CRFAXNO: "02-393-5532",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "107",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "14",
          CRCAPAT: "40",
          CRCHCNT: "37",
          LA: "37.558008493161736",
          LO: "126.95044817982928",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-07-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 9.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 64.0,
          EM_CNT_1Y: 18.0,
          EM_CNT_2Y: 18.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 14.0,
          WORK_DTTM: "2022-10-26 22:03:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000627",
          CRNAME: "구립 역마을어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03431",
          CRADDR: "서울특별시 은평구 갈현로7길 20",
          CRTELNO: "02-356-8083",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "787",
          PLGRDCO: "2",
          CCTVINSTLCNT: "20",
          CHCRTESCNT: "15",
          CRCAPAT: "85",
          CRCHCNT: "69",
          LA: "37.60422693854436",
          LO: "126.90851890783636",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 13.0,
          CHILD_CNT_05: 19.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 69.0,
          EM_CNT_0Y: 42.0,
          EM_CNT_1Y: 8.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 12.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 15.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000692",
          CRNAME: "푸른씨앗어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07605",
          CRADDR: "서울특별시 강서구 방화대로37길 15 제2동 103호(방화동, 신동아아파트)",
          CRTELNO: "02-2666-2103",
          CRFAXNO: "02-2666-2103",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5700795797",
          LO: "126.8160528743",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2021-03-25",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 3.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000473",
          CRNAME: "서울세관 직장어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "06050",
          CRADDR: "서울특별시 강남구 언주로 721 서울세관 별관동 1층",
          CRTELNO: "02-510-1993",
          CRFAXNO: "02-3444-8051",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "72",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "7",
          CRCAPAT: "27",
          CRCHCNT: "11",
          LA: "37.5182988698",
          LO: "127.0337768047",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 4.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 11.0,
          EM_CNT_0Y: 80.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000691",
          CRNAME: "예지어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1314동 102호(마곡동,마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2666-3330",
          CRFAXNO: "02-2666-3330",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.556909852",
          LO: "126.8178734241",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-21",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-04-30",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000464",
          CRNAME: "한국외국어대학교어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02449",
          CRADDR: "서울특별시 동대문구 천장산로9길 11",
          CRTELNO: "02-2173-2518",
          CRFAXNO: "02-969-2518",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "91",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "8",
          CRCAPAT: "30",
          CRCHCNT: "17",
          LA: "37.5990516765",
          LO: "127.0570817007",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-12",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:56.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000690",
          CRNAME: "고운아이어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1307동 101호(공항동,마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2665-5757",
          CRFAXNO: "02-2665-5757",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.556909852",
          LO: "126.8178734241",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-07",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000591",
          CRNAME: "구립 채송화어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07902",
          CRADDR: "서울특별시 양천구 화곡로 85 상진지오벨리 아파트 103호",
          CRTELNO: "02-2692-6670",
          CRFAXNO: "070-4009-0955",
          CRHOME: "http://cafe.naver.com/love1004chae?viewType=pc",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "51",
          PLGRDCO: "0",
          CCTVINSTLCNT: "6",
          CHCRTESCNT: "8",
          CRCAPAT: "19",
          CRCHCNT: "17",
          LA: "37.539745875199564",
          LO: "126.83154856198908",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000374",
          CRNAME: "자곡단비어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "06370",
          CRADDR: "서울특별시 강남구 자곡로 260 417동 104호(자곡동, 강남한양수자인아파트)",
          CRTELNO: "02-6326-7879",
          CRFAXNO: "02-6326-7879",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "64",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.47619166320607",
          LO: "127.11101309807081",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-02-28",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000592",
          CRNAME: "구립 아가사랑어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07987",
          CRADDR: "서울특별시 양천구 목동동로 350 510동 106호(목동, 목동5단지아파트)",
          CRTELNO: "02-6342-7756",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "43",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "16",
          CRCHCNT: "16",
          LA: "37.53276035413168",
          LO: "126.88337061188092",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 6.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 16.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 60.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000625",
          CRNAME: "구립 광현어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03332",
          CRADDR: "서울특별시 은평구 연서로27길 31-7",
          CRTELNO: "02-356-8522",
          CRFAXNO: "02-356-8622",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "141",
          PLGRDCO: "0",
          CCTVINSTLCNT: "10",
          CHCRTESCNT: "10",
          CRCAPAT: "45",
          CRCHCNT: "37",
          LA: "37.618541460948464",
          LO: "126.91618525056768",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 37.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 38.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "양천구",
          STCODE: "11470000593",
          CRNAME: "구립 소담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08107",
          CRADDR: "서울특별시 양천구 신정로 290 306동 104호(신정동, 신트리아파트)",
          CRTELNO: "02-2061-2282",
          CRFAXNO: "02-2061-2282",
          CRHOME: "https://cafe.naver.com/kjs610211/",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.51170996496548",
          LO: "126.85250248516414",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-06-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 17.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 17.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:03:55.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000563",
          CRNAME: "청명어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02789",
          CRADDR: "서울특별시 성북구 화랑로32라길 21",
          CRTELNO: "02-959-7890",
          CRFAXNO: "02-959-7895",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "225",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "7",
          CRCAPAT: "65",
          CRCHCNT: "22",
          LA: "37.607460053767696",
          LO: "127.0563814325907",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-30",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 22.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 40.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000443",
          CRNAME: "노아어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07390",
          CRADDR: "서울특별시 영등포구 신풍로 77 래미안에스티움 103동103호",
          CRTELNO: "02-832-5527",
          CRFAXNO: "02-832-5527",
          CRHOME: "http://cafe.daum.net/No-Ah",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.50161569896814",
          LO: "126.91300959757203",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000500",
          CRNAME: "구립올림픽파크꿈별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05401",
          CRADDR: "서울특별시 강동구 성내로 80",
          CRTELNO: "02-487-0708",
          CRFAXNO: "02-487-0709",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "81",
          PLGRDCO: "1",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "9",
          CRCAPAT: "26",
          CRCHCNT: "24",
          LA: "37.5271182808",
          LO: "127.1279460959",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-25",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 24.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000747",
          CRNAME: "송파푸르지오어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05837",
          CRADDR: "서울특별시 송파구 송파대로 111 103동 1층",
          CRTELNO: "02-406-3040",
          CRFAXNO: "02-406-3041",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "220",
          PLGRDCO: "2",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "17",
          CRCAPAT: "83",
          CRCHCNT: "74",
          LA: "37.4796436688937",
          LO: "127.12348294554248",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 18.0,
          CHILD_CNT_04: 11.0,
          CHILD_CNT_05: 9.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 74.0,
          EM_CNT_0Y: 79.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001016",
          CRNAME: "중계해봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01742",
          CRADDR: "서울특별시 노원구 중계로19길 44",
          CRTELNO: "02-966-5300",
          CRFAXNO: "02-952-0520",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "139",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "10",
          CRCAPAT: "30",
          CRCHCNT: "30",
          LA: "37.6492584511",
          LO: "127.0759486149",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-22",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 30.0,
          EM_CNT_0Y: 63.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:17.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000689",
          CRNAME: "하늘빛어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1309동 104호(마곡동,마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2652-4675",
          CRFAXNO: "02-2652-4675",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "66",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5585674410454",
          LO: "126.81771546767959",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-18",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-02-29",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:07.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000687",
          CRNAME: "마곡아이솔어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1301동 101호(마곡동,마곡13단지힐스테이트마스터)",
          CRTELNO: "02-6080-7839",
          CRFAXNO: "02-6080-7839",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.556909852",
          LO: "126.8178734241",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-03-02",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000278",
          CRNAME: "보라어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07579",
          CRADDR: "서울특별시 강서구 공항대로39길 100 103동 105호(등촌동,등촌대림아파트)",
          CRTELNO: "02-3661-7715",
          CRFAXNO: "02-3661-7716",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "66",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5636154647",
          LO: "126.8473940123",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-05-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 2.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000688",
          CRNAME: "고운아이어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71",
          CRTELNO: "02-2665-5757",
          CRFAXNO: "02-2665-5757",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.556909852",
          LO: "126.8178734241",
          CRCARGBNAME: "",
          CRCNFMDT: "2017-05-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2017-05-24",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000686",
          CRNAME: "마곡두린아이어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07809",
          CRADDR: "서울특별시 강서구 마곡중앙1로 71 1305동 102호(마곡동, 마곡13단지힐스테이트마스터)",
          CRTELNO: "02-2663-0207",
          CRFAXNO: "02-2663-0207",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "55",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.556909852",
          LO: "126.8178734241",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-10",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000442",
          CRNAME: "래미안에스티움어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07390",
          CRADDR: "서울특별시 영등포구 신풍로 77 래미안에스티움아파트 관리동",
          CRTELNO: "02-842-4111",
          CRFAXNO: "02-843-4111",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "250",
          PLGRDCO: "1",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "10",
          CRCAPAT: "69",
          CRCHCNT: "55",
          LA: "37.5004198781",
          LO: "126.9115453356",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-04",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 15.0,
          CHILD_CNT_04: 12.0,
          CHILD_CNT_05: 14.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 55.0,
          EM_CNT_0Y: 57.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000435",
          CRNAME: "착한나라어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04007",
          CRADDR: "서울특별시 마포구 망원로4길 16-8",
          CRTELNO: "02-324-0965",
          CRFAXNO: "02-326-0922",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "206",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "10",
          CRCAPAT: "68",
          CRCHCNT: "45",
          LA: "37.55594157827766",
          LO: "126.90153288133119",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 2.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 11.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 15.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 45.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 63.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:03:46.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000441",
          CRNAME: "꿈땅어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07217",
          CRADDR: "서울특별시 영등포구 당산동4가 당산로41길 23 106동 105호",
          CRTELNO: "02-2633-3998",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "62",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "18",
          LA: "37.53097515082343",
          LO: "126.89656508633061",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 2.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 38.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000107",
          CRNAME: "미담어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04575",
          CRADDR: "서울특별시 중구 퇴계로 447",
          CRTELNO: "02-2231-7227",
          CRFAXNO: "02-2231-7337",
          CRHOME: "cafe.daum.net/midam0529",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "166",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "12",
          CRCAPAT: "49",
          CRCHCNT: "35",
          LA: "37.5660402677",
          LO: "127.0217233062",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 15.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 35.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 22.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "동대문구",
          STCODE: "11230000463",
          CRNAME: "다온어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02553",
          CRADDR: "서울특별시 동대문구 사가정로 65 212동 105호(전농동,래미안크레시티)",
          CRTELNO: "02-2214-3155",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "85",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-06-15",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-06-15 09:29:55.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000194",
          CRNAME: "위드어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "04365",
          CRADDR: "서울특별시 용산구 원효로4가 원효로 40 101-105",
          CRTELNO: "02-701-5554",
          CRFAXNO: "02-701-5554",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.53418053488569",
          LO: "126.94802858510799",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-05-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-03-04",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000626",
          CRNAME: "구립 꼬마대통령어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03300",
          CRADDR: "서울특별시 은평구 진관3로 15-35 구파발10단지 1009동 1층",
          CRTELNO: "02-357-1008",
          CRFAXNO: "02-382-1121",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "125",
          PLGRDCO: "0",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "18",
          CRCAPAT: "39",
          CRCHCNT: "39",
          LA: "37.6425165456065",
          LO: "126.91757038848048",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-28",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 15.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 39.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 27.0,
          EM_CNT_4Y: 20.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "성동구",
          STCODE: "11200000380",
          CRNAME: "서울시설공단 누비어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04707",
          CRADDR: "서울특별시 성동구 왕십리로26길 29",
          CRTELNO: "02-2298-2800",
          CRFAXNO: "02-2298-2600",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "136",
          PLGRDCO: "1",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "10",
          CRCAPAT: "48",
          CRCHCNT: "20",
          LA: "37.5656916752",
          LO: "127.0329877595",
          CRCARGBNAME: "운영",
          CRCNFMDT: "2017-04-26",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 5.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 2.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 38.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:02:05.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000746",
          CRNAME: "파인정원어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "05813",
          CRADDR: "서울특별시 송파구 송파대로8길 10 파인타운13단지 관리동 1층",
          CRTELNO: "02-400-0609",
          CRFAXNO: "02-409-0609",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "24",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2020-02-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000193",
          CRNAME: "늘봄어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04374",
          CRADDR: "서울특별시 용산구 이촌로2가길 122 105동 106호",
          CRTELNO: "02-702-2522",
          CRFAXNO: "02-702-2523",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "59",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000614",
          CRNAME: "아뜰리에어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02874",
          CRADDR: "서울특별시 성북구 보문동6가 보문사길 111",
          CRTELNO: "02-929-5556",
          CRFAXNO: "02-929-5557",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "204",
          PLGRDCO: "2",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "19",
          CRCAPAT: "77",
          CRCHCNT: "77",
          LA: "37.57984407036568",
          LO: "127.01843063290067",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 6.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 16.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 30.0,
          CHILD_CNT_02: 27.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 77.0,
          EM_CNT_0Y: 19.0,
          EM_CNT_1Y: 44.0,
          EM_CNT_2Y: 13.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000745",
          CRNAME: "사랑가득어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "05853",
          CRADDR: "서울특별시 송파구 위례광장로 121 2418동 101호",
          CRTELNO: "02-6082-1357",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.474714454293085",
          LO: "127.13930062282775",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-11",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-03-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000120",
          CRNAME: "구립예람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08558",
          CRADDR: "서울특별시 금천구 독산로72길 11-16",
          CRTELNO: "02-830-5855",
          CRFAXNO: "02-830-5856",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "280",
          PLGRDCO: "1",
          CCTVINSTLCNT: "16",
          CHCRTESCNT: "13",
          CRCAPAT: "71",
          CRCHCNT: "53",
          LA: "37.46846646",
          LO: "126.9030673",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 8.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 16.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 53.0,
          EM_CNT_0Y: 55.0,
          EM_CNT_1Y: 27.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 9.0,
          EM_CNT_6Y: 9.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 11.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 13.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000055",
          CRNAME: "구립하늘아이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01200",
          CRADDR: "서울특별시 강북구 삼양로19길 25 103동 102호(미아동, 래미안트라베라1단지아파트)",
          CRTELNO: "02-983-2323",
          CRFAXNO: "02-983-2303",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "54",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.613584827750365",
          LO: "127.02055843261218",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 43.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 14.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000080",
          CRNAME: "구립해맑은어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01192",
          CRADDR: "서울특별시 강북구 솔샘로 174 117동 102호(미아동, 에스케이북한산시티아파트)",
          CRTELNO: "02-6229-2225",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.61764",
          LO: "127.010605",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "서초구",
          STCODE: "11650000405",
          CRNAME: "봄꽃나라어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "06515",
          CRADDR: "서울특별시 서초구 잠원로14길 41 324동106호(잠원동,신반포한신아파트)",
          CRTELNO: "02-536-9203",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "87",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "19",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2018-10-31",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:05.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000440",
          CRNAME: "키즈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07416",
          CRADDR: "서울특별시 영등포구 도림천로11길 3",
          CRTELNO: "02-846-2131",
          CRFAXNO: "02-846-2111",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "133",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "10",
          CRCAPAT: "49",
          CRCHCNT: "44",
          LA: "37.4911129271",
          LO: "126.8965624104",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-04-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 13.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 44.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 10.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000744",
          CRNAME: "위례별마루어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05850",
          CRADDR: "서울특별시 송파구 위례광장로 215 (장지동, 위례스타힐스)",
          CRTELNO: "02-403-3334",
          CRFAXNO: "02-403-3338",
          CRHOME: "",
          NRTRROOMCNT: "10",
          NRTRROOMSIZE: "364",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "27",
          CRCAPAT: "135",
          CRCHCNT: "127",
          LA: "37.47995053183536",
          LO: "127.1466719162935",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-29",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,휴일보육,시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 13.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 21.0,
          CHILD_CNT_03: 30.0,
          CHILD_CNT_04: 18.0,
          CHILD_CNT_05: 20.0,
          CHILD_CNT_M2: 9.0,
          CHILD_CNT_M5: 19.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 127.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 22.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 1.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 28.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000324",
          CRNAME: "지밸리경협어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08594",
          CRADDR: "서울특별시 금천구 가산디지털1로 1 더루벤스밸리 305,306,307호",
          CRTELNO: "02-830-1501",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "253",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "9",
          CRCAPAT: "49",
          CRCHCNT: "15",
          LA: "37.4662797361",
          LO: "126.8871737232",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 4.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "중랑구",
          STCODE: "11260000482",
          CRNAME: "햇살아래공동육아방",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02262",
          CRADDR: "서울특별시 중랑구 신내역로 131",
          CRTELNO: "02-3421-1120",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "0",
          NRTRROOMSIZE: "104",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "0",
          CRCHCNT: "0",
          LA: "",
          LO: "",
          CRCARGBNAME: "",
          CRCNFMDT: "2017-03-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000191",
          CRNAME: "새둥지어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04422",
          CRADDR: "서울특별시 용산구 이촌로65가길 3 110동 101호",
          CRTELNO: "02-796-5025",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "81",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "4",
          CRCAPAT: "20",
          CRCHCNT: "7",
          LA: "37.5223116372",
          LO: "126.9719635243",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 7.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 7.0,
          EM_CNT_0Y: 67.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 2.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 4.0,
          WORK_DTTM: "2022-10-26 22:01:54.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000499",
          CRNAME: "애플어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05229",
          CRADDR: "서울특별시 강동구 아리수로50길 50 124동 204호",
          CRTELNO: "02-441-6310",
          CRFAXNO: "050-4082-6823",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.55962437649136",
          LO: "127.1481068818659",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-27",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 20.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 40.0,
          EM_CNT_4Y: 40.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:36.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000472",
          CRNAME: "킨더바움어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "06372",
          CRADDR: "서울특별시 강남구 자곡로7길 8-16",
          CRTELNO: "02-3411-0505",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "214",
          PLGRDCO: "0",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "0",
          CRCAPAT: "45",
          CRCHCNT: "0",
          LA: "37.47472820788142",
          LO: "127.10016364380247",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-24",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-02-28",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000190",
          CRNAME: "푸른꿈어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04355",
          CRADDR: "서울특별시 용산구 백범로 260 효창파크푸르지오아파트 104동, 1층",
          CRTELNO: "02-719-9989",
          CRFAXNO: "02-719-9979",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "70",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.54023934237648",
          LO: "126.95833237770782",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "중구",
          STCODE: "11140000108",
          CRNAME: "IBK 참! 좋은 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04538",
          CRADDR: "서울특별시 중구 을지로2가 을지로 82",
          CRTELNO: "02-2031-3394",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "283",
          PLGRDCO: "1",
          CCTVINSTLCNT: "13",
          CHCRTESCNT: "19",
          CRCAPAT: "90",
          CRCHCNT: "57",
          LA: "37.5657063891",
          LO: "126.9870828853",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-20",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 3.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 12.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 18.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 57.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 7.0,
          EM_CNT_2Y: 36.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 1.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 06:18:44.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000740",
          CRNAME: "위례꿈별어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05850",
          CRADDR: "서울특별시 송파구 위례광장로 215 (장지동, 위례스타힐스)",
          CRTELNO: "02-3402-2300",
          CRFAXNO: "02-3402-2600",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "312",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "19",
          CRCAPAT: "85",
          CRCHCNT: "81",
          LA: "37.48170935088371",
          LO: "127.14517163020893",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,휴일보육",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 14.0,
          CHILD_CNT_04: 20.0,
          CHILD_CNT_05: 18.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 81.0,
          EM_CNT_0Y: 31.0,
          EM_CNT_1Y: 38.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 6.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "금천구",
          STCODE: "11545000323",
          CRNAME: "미쁘어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "08608",
          CRADDR: "서울특별시 금천구 벚꽃로 40 101동 102호",
          CRTELNO: "02-805-1245",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "69",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2019-02-28",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:04:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000739",
          CRNAME: "서밋RUTC어린이집",
          CRTYPENAME: "협동",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05663",
          CRADDR: "서울특별시 송파구 오금로20길 3",
          CRTELNO: "02-417-1363",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "6",
          NRTRROOMSIZE: "140",
          PLGRDCO: "1",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "11",
          CRCAPAT: "48",
          CRCHCNT: "32",
          LA: "37.479319627934466",
          LO: "127.12742249677835",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 1.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 11.0,
          CHILD_CNT_SP: 3.0,
          CHILD_CNT_TOT: 32.0,
          EM_CNT_0Y: 25.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 63.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 8.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 11.0,
          WORK_DTTM: "2022-10-26 22:05:26.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000743",
          CRNAME: "파크하비오어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05837",
          CRADDR: "서울특별시 송파구 송파대로 111 107동 1층",
          CRTELNO: "02-431-6757",
          CRFAXNO: "02-431-6755",
          CRHOME: "http://habiokids.com",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "225",
          PLGRDCO: "1",
          CCTVINSTLCNT: "18",
          CHCRTESCNT: "19",
          CRCAPAT: "85",
          CRCHCNT: "63",
          LA: "37.48061659099311",
          LO: "127.1236428310237",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-14",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 9.0,
          CHILD_CNT_05: 13.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 63.0,
          EM_CNT_0Y: 53.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 7.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 15.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000741",
          CRNAME: "힐스송파어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05849",
          CRADDR: "서울특별시 송파구 위례광장로 170 102동 1층(장지동, 힐스테이트송파위례)",
          CRTELNO: "02-430-6594",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "185",
          PLGRDCO: "1",
          CCTVINSTLCNT: "12",
          CHCRTESCNT: "18",
          CRCAPAT: "70",
          CRCHCNT: "57",
          LA: "37.47945092331935",
          LO: "127.14262344363068",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-09",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,휴일보육,시간제보육",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 57.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 18.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "강남구",
          STCODE: "11680000471",
          CRNAME: "청담키즈어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "06063",
          CRADDR: "서울특별시 강남구 삼성로147길 24 1층(청담동)",
          CRTELNO: "02-3444-3020",
          CRFAXNO: "02-3444-3020",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "63",
          PLGRDCO: "0",
          CCTVINSTLCNT: "3",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.52127131977962",
          LO: "127.04685501443802",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-08",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-07-18",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 09:13:35.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000623",
          CRNAME: "구립 파란하늘어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03357",
          CRADDR: "서울특별시 은평구 통일로72길 16 관리동(불광1동, 북한산힐스테이트7차아파트)",
          CRTELNO: "02-389-0025",
          CRFAXNO: "02-389-0080",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "302",
          PLGRDCO: "1",
          CCTVINSTLCNT: "32",
          CHCRTESCNT: "17",
          CRCAPAT: "74",
          CRCHCNT: "58",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,시간제보육",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 9.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 20.0,
          CHILD_CNT_02: 19.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 10.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 31.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 39.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 13.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "은평구",
          STCODE: "11380000624",
          CRNAME: "구립 백련산힐1차어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03476",
          CRADDR: "서울특별시 은평구 백련산로2길 19 관리동(응암2동, 백련산힐스테이트1차)",
          CRTELNO: "02-303-9276",
          CRFAXNO: "02-6713-9277",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "138",
          PLGRDCO: "0",
          CCTVINSTLCNT: "14",
          CHCRTESCNT: "12",
          CRCAPAT: "40",
          CRCHCNT: "36",
          LA: "37.59274627450155",
          LO: "126.92476445293681",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-06",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 14.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 36.0,
          EM_CNT_0Y: 22.0,
          EM_CNT_1Y: 11.0,
          EM_CNT_2Y: 56.0,
          EM_CNT_4Y: 11.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:25.0",
        },
        {
          SIGUNNAME: "송파구",
          STCODE: "11710000738",
          CRNAME: "푸른솔어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05856",
          CRADDR: "서울특별시 송파구 정의로 30",
          CRTELNO: "02-430-5599",
          CRFAXNO: "02-430-5995",
          CRHOME: "http://moamom091.kiznet.co.kr/",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "272",
          PLGRDCO: "3",
          CCTVINSTLCNT: "27",
          CHCRTESCNT: "19",
          CRCAPAT: "99",
          CRCHCNT: "62",
          LA: "37.48320915004869",
          LO: "127.11710068341368",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 2.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 13.0,
          CHILD_CNT_02: 11.0,
          CHILD_CNT_03: 16.0,
          CHILD_CNT_04: 10.0,
          CHILD_CNT_05: 12.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 62.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 36.0,
          EM_CNT_2Y: 21.0,
          EM_CNT_4Y: 7.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 2.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:05:27.0",
        },
        {
          SIGUNNAME: "구로구",
          STCODE: "11530000602",
          CRNAME: "구로구청 사랑채움 어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08284",
          CRADDR: "서울특별시 구로구 가마산로 245",
          CRTELNO: "02-858-2046",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "8",
          NRTRROOMSIZE: "239",
          PLGRDCO: "1",
          CCTVINSTLCNT: "21",
          CHCRTESCNT: "17",
          CRCAPAT: "84",
          CRCHCNT: "56",
          LA: "37.4958299113",
          LO: "126.8879072957",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-03",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 1.0,
          CLASS_CNT_05: 1.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 13.0,
          CHILD_CNT_03: 9.0,
          CHILD_CNT_04: 7.0,
          CHILD_CNT_05: 11.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 56.0,
          EM_CNT_0Y: 36.0,
          EM_CNT_1Y: 21.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 14.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 17.0,
          WORK_DTTM: "2022-10-26 22:04:15.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000497",
          CRNAME: "강동경희대병원어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "05269",
          CRADDR: "서울특별시 강동구 동남로 881",
          CRTELNO: "02-440-6710",
          CRFAXNO: "02-440-6714",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "102",
          PLGRDCO: "0",
          CCTVINSTLCNT: "0",
          CHCRTESCNT: "0",
          CRCAPAT: "39",
          CRCHCNT: "0",
          LA: "37.5522912082",
          LO: "127.1557742458",
          CRCARGBNAME: "",
          CRCNFMDT: "2017-03-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 0.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000495",
          CRNAME: "봄빛어린이집",
          CRTYPENAME: "민간",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "05210",
          CRADDR: "서울특별시 강동구 아리수로97길 19 관리동(강일동, 강일리버파크4단지아파트)",
          CRTELNO: "02-3426-7714",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "148",
          PLGRDCO: "0",
          CCTVINSTLCNT: "8",
          CHCRTESCNT: "0",
          CRCAPAT: "51",
          CRCHCNT: "0",
          LA: "37.5669946966",
          LO: "127.1767904161",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2018-03-01",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "용산구",
          STCODE: "11170000189",
          CRNAME: "오케이최고어린이집",
          CRTYPENAME: "가정",
          CRSTATUSNAME: "재개",
          ZIPCODE: "04336",
          CRADDR: "서울특별시 용산구 두텁바위로31길 28",
          CRTELNO: "02-775-2560",
          CRFAXNO: "",
          CRHOME: "",
          NRTRROOMCNT: "2",
          NRTRROOMSIZE: "87",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.5475629767",
          LO: "126.9803551745",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:01:55.0",
        },
        {
          SIGUNNAME: "강동구",
          STCODE: "11740000498",
          CRNAME: "강동경희대병원어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "05269",
          CRADDR: "서울특별시 강동구 동남로 881 5층 서희스타힐스(명일동)",
          CRTELNO: "02-440-6710",
          CRFAXNO: "02-440-6714",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "102",
          PLGRDCO: "0",
          CCTVINSTLCNT: "7",
          CHCRTESCNT: "6",
          CRCAPAT: "39",
          CRCHCNT: "15",
          LA: "37.5522912082",
          LO: "127.1557742458",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-02",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 4.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 4.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 6.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 15.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 25.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 75.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:05:35.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001007",
          CRNAME: "꼬마어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01766",
          CRADDR: "서울특별시 노원구 동일로213길 21 107동 104호(상계동, 주공아파트)",
          CRTELNO: "02-935-5942",
          CRFAXNO: "02-935-5942",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "58",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.566470",
          LO: "126.977963",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000335",
          CRNAME: "구립 휴먼시아어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04981",
          CRADDR: "서울특별시 광진구 천호대로 716 102동 102호(구의동, 휴먼시아아파트)",
          CRTELNO: "02-456-9709",
          CRFAXNO: "070-4009-0630",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "92",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.5482735626",
          LO: "127.0935718071",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 2.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 7.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 14.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 57.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "노원구",
          STCODE: "11350001015",
          CRNAME: "샛별몬테소리어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01894",
          CRADDR: "서울특별시 노원구 광운로 46 102동 104호(월계동, 대동아파트)",
          CRTELNO: "02-6221-5243",
          CRFAXNO: "02-943-5243",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "65",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.6216610396",
          LO: "127.0608052968",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:03:16.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000320",
          CRNAME: "구립이루미어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01193",
          CRADDR: "서울특별시 강북구 삼양로27길 80 303동 104호(미아동, 두산위브아파트)",
          CRTELNO: "02-6397-0660",
          CRFAXNO: "02-6397-0660",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "75",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.6190093233307",
          LO: "127.016459488188",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 10.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 50.0,
          EM_CNT_1Y: 33.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 17.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000438",
          CRNAME: "아이꿈터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07217",
          CRADDR: "서울특별시 영등포구 당산동4가 당산로41길 23 당산현대아파트 103동 105호",
          CRTELNO: "02-2068-0011",
          CRFAXNO: "02-2068-0011",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "48",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "7",
          CRCAPAT: "18",
          CRCHCNT: "18",
          LA: "37.5314959813",
          LO: "126.8966243298",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 4.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 18.0,
          EM_CNT_0Y: 33.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 17.0,
          EM_CNT_4Y: 50.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:35.0",
        },
        {
          SIGUNNAME: "광진구",
          STCODE: "11215000333",
          CRNAME: "구립 중곡1동 자람터어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "04917",
          CRADDR: "서울특별시 광진구 긴고랑로8길 76",
          CRTELNO: "02-469-7942",
          CRFAXNO: "02-469-7944",
          CRHOME: "",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "169",
          PLGRDCO: "2",
          CCTVINSTLCNT: "23",
          CHCRTESCNT: "19",
          CRCAPAT: "62",
          CRCHCNT: "58",
          LA: "37.560386864863595",
          LO: "127.07729259739237",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "장애아통합,야간연장",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 1.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 2.0,
          CLASS_CNT_TOT: 11.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 9.0,
          CHILD_CNT_02: 12.0,
          CHILD_CNT_03: 11.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 14.0,
          CHILD_CNT_SP: 6.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 44.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 31.0,
          EM_CNT_4Y: 13.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 16.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 19.0,
          WORK_DTTM: "2022-10-26 22:02:15.0",
        },
        {
          SIGUNNAME: "영등포구",
          STCODE: "11560000439",
          CRNAME: "즐거운어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07217",
          CRADDR: "서울특별시 영등포구 당산동4가 당산로41길 23 101동 102호",
          CRTELNO: "02-6269-3939",
          CRFAXNO: "02-6269-3939",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "53",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.5314959813",
          LO: "126.8966243298",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 5.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 8.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:36.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000681",
          CRNAME: "구립 꼬꼬마라인어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07548",
          CRADDR: "서울특별시 강서구 화곡로68길 33 102동 101호(등촌동, 라인아파트)",
          CRTELNO: "02-6736-2352",
          CRFAXNO: "02-6736-2352",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.55935917424414",
          LO: "126.85601336522251",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 14.0,
          EM_CNT_4Y: 43.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000536",
          CRNAME: "구립보람어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08730",
          CRADDR: "서울특별시 관악구 관악로 304 현대아파트 118-101",
          CRTELNO: "02-6275-7942",
          CRFAXNO: "",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11620000536",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "61",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "7",
          CRCAPAT: "20",
          CRCHCNT: "17",
          LA: "37.4920516482",
          LO: "126.9577134881",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 5.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 17.0,
          EM_CNT_0Y: 17.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 50.0,
          EM_CNT_4Y: 33.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 5.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 7.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "성북구",
          STCODE: "11290000603",
          CRNAME: "하늘채어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "02786",
          CRADDR: "서울특별시 성북구 한천로 509 104-101",
          CRTELNO: "02-969-8586",
          CRFAXNO: "070-4312-8586",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "19",
          LA: "37.60619022762279",
          LO: "127.0657304087499",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 1.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 1.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 7.0,
          CHILD_CNT_02: 6.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 19.0,
          EM_CNT_0Y: 38.0,
          EM_CNT_1Y: 13.0,
          EM_CNT_2Y: 25.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 7.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:46.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000086",
          CRNAME: "구립동그라미어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01191",
          CRADDR: "서울특별시 강북구 솔샘로 159 104동 102호(미아동, 벽산라이브파크)",
          CRTELNO: "02-982-7582",
          CRFAXNO: "02-6223-5700",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "105",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "9",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.6210820003573",
          LO: "127.0126358449875",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 6.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 10.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 71.0,
          EM_CNT_1Y: 14.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 9.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000206",
          CRNAME: "도봉1동엄마무릎어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "01312",
          CRADDR: "서울특별시 도봉구 시루봉로23나길 17 (도봉동)",
          CRTELNO: "02-3494-4001",
          CRFAXNO: "02-3494-4001",
          CRHOME: "",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "83",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "0",
          CRCAPAT: "20",
          CRCHCNT: "0",
          LA: "37.6732755",
          LO: "127.0399215",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-02-28",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 5.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000543",
          CRNAME: "구립꿀송이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08725",
          CRADDR: "서울특별시 관악구 성현로 80 관악드림타운아파트 106-104",
          CRTELNO: "02-874-2425",
          CRFAXNO: "02-874-2426",
          CRHOME: "http://iseoul.seoul.go.kr/images/portal/contents/btn_home.gif",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "57",
          PLGRDCO: "1",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4898477985",
          LO: "126.9529837015",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 8.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 7.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 29.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 14.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
        {
          SIGUNNAME: "마포구",
          STCODE: "11440000434",
          CRNAME: "SKY어린이집",
          CRTYPENAME: "직장",
          CRSTATUSNAME: "정상",
          ZIPCODE: "03926",
          CRADDR: "서울특별시 마포구 매봉산로 75 DDMC 3층",
          CRTELNO: "02-2146-0980",
          CRFAXNO: "02-2146-0980",
          CRHOME: "",
          NRTRROOMCNT: "7",
          NRTRROOMSIZE: "626",
          PLGRDCO: "1",
          CCTVINSTLCNT: "38",
          CHCRTESCNT: "28",
          CRCAPAT: "99",
          CRCHCNT: "58",
          LA: "37.5784526428",
          LO: "126.8929005594",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 2.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 2.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 18.0,
          CHILD_CNT_02: 15.0,
          CHILD_CNT_03: 13.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 12.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 58.0,
          EM_CNT_0Y: 35.0,
          EM_CNT_1Y: 20.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 25.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 20.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 4.0,
          EM_CNT_A8: 1.0,
          EM_CNT_TOT: 28.0,
          WORK_DTTM: "2022-10-26 22:03:45.0",
        },
        {
          SIGUNNAME: "강서구",
          STCODE: "11500000682",
          CRNAME: "구립 밤비어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "07566",
          CRADDR: "서울특별시 강서구 공항대로45길 68-6 106동 104호(등촌동, 등촌서광마을아파트)",
          CRTELNO: "02-3662-8003",
          CRFAXNO: "02-3662-3110",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "60",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.55768754323786",
          LO: "126.85763783742568",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 2.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 0.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 4.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 8.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 29.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:06.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000493",
          CRNAME: "도봉2동해솔어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01318",
          CRADDR: "서울특별시 도봉구 마들로 859-19 103동 109호(도봉동, 도봉한신아파트)",
          CRTELNO: "02-954-2666",
          CRFAXNO: "02-954-2667",
          CRHOME: "www.cyworld.com/lovehaesol",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "56",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "6",
          CRCAPAT: "20",
          CRCHCNT: "14",
          LA: "37.686043",
          LO: "127.04676",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장",
          CLASS_CNT_00: 2.0,
          CLASS_CNT_01: 1.0,
          CLASS_CNT_02: 3.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 4.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 10.0,
          CHILD_CNT_00: 2.0,
          CHILD_CNT_01: 4.0,
          CHILD_CNT_02: 5.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 3.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 14.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 100.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 4.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 6.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "도봉구",
          STCODE: "11320000197",
          CRNAME: "도봉2동재롱이어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "01318",
          CRADDR: "서울특별시 도봉구 마들로 859-19 121동 101호(도봉동, 도봉한신아파트)",
          CRTELNO: "02-954-8237",
          CRFAXNO: "02-954-8235",
          CRHOME: "",
          NRTRROOMCNT: "3",
          NRTRROOMSIZE: "84",
          PLGRDCO: "0",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "12",
          CRCAPAT: "19",
          CRCHCNT: "13",
          LA: "37.686043",
          LO: "127.04676",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "야간연장,24시간",
          CLASS_CNT_00: 5.0,
          CLASS_CNT_01: 3.0,
          CLASS_CNT_02: 2.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 3.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 14.0,
          CHILD_CNT_00: 8.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 5.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 13.0,
          EM_CNT_0Y: 40.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 20.0,
          EM_CNT_4Y: 40.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 9.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 12.0,
          WORK_DTTM: "2022-10-26 22:03:05.0",
        },
        {
          SIGUNNAME: "강북구",
          STCODE: "11305000121",
          CRNAME: "구립다솜어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "폐지",
          ZIPCODE: "01031",
          CRADDR: "서울특별시 강북구 인수봉로72길 15-20 (수유동)",
          CRTELNO: "02-997-9644",
          CRFAXNO: "02-997-9645",
          CRHOME: "https://cafe.daum.net/ds2019",
          NRTRROOMCNT: "5",
          NRTRROOMSIZE: "111",
          PLGRDCO: "0",
          CCTVINSTLCNT: "5",
          CHCRTESCNT: "0",
          CRCAPAT: "42",
          CRCHCNT: "0",
          LA: "37.6428744947",
          LO: "127.0119696312",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "2022-06-30",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 0.0,
          CLASS_CNT_01: 0.0,
          CLASS_CNT_02: 0.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 5.0,
          CLASS_CNT_M5: 1.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 6.0,
          CHILD_CNT_00: 0.0,
          CHILD_CNT_01: 0.0,
          CHILD_CNT_02: 0.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 0.0,
          EM_CNT_0Y: 0.0,
          EM_CNT_1Y: 0.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 0.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 0.0,
          EM_CNT_A2: 0.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 0.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 0.0,
          WORK_DTTM: "2022-10-26 22:02:55.0",
        },
        {
          SIGUNNAME: "관악구",
          STCODE: "11620000538",
          CRNAME: "구립토마토어린이집",
          CRTYPENAME: "국공립",
          CRSTATUSNAME: "정상",
          ZIPCODE: "08797",
          CRADDR: "서울특별시 관악구 남부순환로248길 78 아이펠리스 101호",
          CRTELNO: "02-886-2696",
          CRFAXNO: "02-885-2696",
          CRHOME: "http://iseoul.seoul.go.kr/homepage/main.do?stCode=11620000538",
          NRTRROOMCNT: "4",
          NRTRROOMSIZE: "63",
          PLGRDCO: "1",
          CCTVINSTLCNT: "4",
          CHCRTESCNT: "8",
          CRCAPAT: "20",
          CRCHCNT: "20",
          LA: "37.4728016083",
          LO: "126.9661396749",
          CRCARGBNAME: "미운영",
          CRCNFMDT: "2017-03-01",
          CRPAUSEBEGINDT: "",
          CRPAUSEENDDT: "",
          CRABLDT: "",
          DATASTDRDT: "2022-10-26",
          CRSPEC: "일반",
          CLASS_CNT_00: 3.0,
          CLASS_CNT_01: 4.0,
          CLASS_CNT_02: 4.0,
          CLASS_CNT_03: 0.0,
          CLASS_CNT_04: 0.0,
          CLASS_CNT_05: 0.0,
          CLASS_CNT_M2: 1.0,
          CLASS_CNT_M5: 0.0,
          CLASS_CNT_SP: 0.0,
          CLASS_CNT_TOT: 12.0,
          CHILD_CNT_00: 3.0,
          CHILD_CNT_01: 8.0,
          CHILD_CNT_02: 9.0,
          CHILD_CNT_03: 0.0,
          CHILD_CNT_04: 0.0,
          CHILD_CNT_05: 0.0,
          CHILD_CNT_M2: 0.0,
          CHILD_CNT_M5: 0.0,
          CHILD_CNT_SP: 0.0,
          CHILD_CNT_TOT: 20.0,
          EM_CNT_0Y: 43.0,
          EM_CNT_1Y: 29.0,
          EM_CNT_2Y: 0.0,
          EM_CNT_4Y: 29.0,
          EM_CNT_6Y: 0.0,
          EM_CNT_A1: 1.0,
          EM_CNT_A2: 6.0,
          EM_CNT_A3: 0.0,
          EM_CNT_A4: 0.0,
          EM_CNT_A5: 0.0,
          EM_CNT_A6: 0.0,
          EM_CNT_A10: 0.0,
          EM_CNT_A7: 1.0,
          EM_CNT_A8: 0.0,
          EM_CNT_TOT: 8.0,
          WORK_DTTM: "2022-10-26 22:04:55.0",
        },
      ],
    },
  },
];
